/**
 * Єдиний словник інтерфейсу CRM. Українська — мова за замовчуванням.
 * Щоб додати мову: створіть en.ts / pl.ts з `Partial<Dict>` і зареєструйте в i18n/index.ts.
 * Плейсхолдери: {name}.
 */
export const uk = {
  // загальне
  'app.admin': 'CRM',
  'app.skip': 'Перейти до вмісту',
  'common.save': 'Зберегти',
  'common.saved': 'Збережено',
  'common.saving': 'Збереження…',
  'common.cancel': 'Скасувати',
  'common.close': 'Закрити',
  'common.create': 'Створити',
  'common.add': 'Додати',
  'common.delete': 'Видалити',
  'common.remove': 'Прибрати',
  'common.edit': 'Редагувати',
  'common.search': 'Пошук',
  'common.loading': 'Завантаження…',
  'common.loadMore': 'Завантажити ще',
  'common.retry': 'Спробувати ще',
  'common.empty': 'Порожньо',
  'common.nothingFound': 'Нічого не знайдено.',
  'common.error': 'Не вдалося завантажити дані.',
  'common.all': 'Усі',
  'common.any': 'Будь-який',
  'common.none': '—',
  'common.yes': 'Так',
  'common.no': 'Ні',
  'common.unknown': 'невідомо',
  'common.back': 'Назад',
  'common.open': 'Відкрити',
  'common.copy': 'Копіювати',
  'common.copied': 'Скопійовано',
  'common.download': 'Зберегти на компʼютер',
  'common.addFile': 'Додати файл',
  'common.showTechCodes': 'Показати технічні коди',
  'common.techCode': 'Технічний код: {code}',
  'common.upload': 'Завантажити файл',
  'common.uploading': 'Завантаження файлу…',
  'common.actions': 'Дії',
  'common.status': 'Статус',
  'common.name': 'Назва',
  'common.fullName': 'ПІБ',
  'common.phone': 'Телефон',
  'common.email': 'Email',
  'common.message': 'Повідомлення',
  'common.note': 'Примітка',
  'common.notes': 'Нотатки',
  'common.date': 'Дата',
  'common.created': 'Створено',
  'common.updated': 'Оновлено',
  'common.from': 'Від',
  'common.to': 'До',
  'common.qty': 'К-сть',
  'common.price': 'Ціна',
  'common.total': 'Разом',
  'common.currency': 'Валюта',
  'common.country': 'Країна',
  'common.site': 'Сайт',
  'common.assignee': 'Відповідальний',
  'common.unassigned': 'Не призначено',
  'common.me': 'Я',
  'common.active': 'Активний',
  'common.inactive': 'Вимкнено',
  'common.required': 'Обовʼязкове поле',
  'common.optional': 'необовʼязково',
  'common.confirmDelete': 'Видалити? Дію не можна скасувати.',
  'common.selectPlaceholder': 'Оберіть…',
  'common.notAvailable': 'Розділ ще не підтримується сервером.',

  // помилки API
  // помилки API: error.<код> — для кожного коду ApiError у services/api (B5); c.* — обмеження БД, v.* — перевірка полів
  'error.network': 'Немає звʼязку з сервером. Перевірте інтернет і спробуйте ще раз.',
  'error.unauthorized': 'Сесія завершилась. Увійдіть знову.',
  'error.invalid_credentials': 'Невірний email або пароль.',
  'error.totp_required': 'Потрібен код двофакторної автентифікації.',
  'error.invalid_code': 'Невірний код.',
  'error.invalid_totp': 'Невірний код.',
  'error.wrong_password': 'Поточний пароль введено неправильно.',
  'error.forbidden': 'Недостатньо прав для цієї дії. Зверніться до керівника.',
  'error.not_found': 'Не знайдено — можливо, запис уже видалили. Оновіть сторінку.',
  'error.lead_out_of_country_filter': 'Заявка є, але вона з іншої країни ({lead_country}), а в перемикачі вгорі обрано {country}. Перемкніть країну, щоб її відкрити.',
  'error.ritual_out_of_country_filter': 'Ритуальна картка є, але її справа поза обраною країною ({country}) у перемикачі вгорі. Оберіть «Усі» в перемикачі, щоб її побачити.',
  'error.out_of_country_filter': 'Справа є, але вона поза обраною країною ({country}) у перемикачі вгорі. Оберіть «Усі» в перемикачі, щоб її побачити.',
  'error.rule_violation': 'Зараз цю дію виконати не можна.',
  'error.check_violation': 'Не вистачає залишку на складі для цієї дії.',
  'error.duplicate': 'Такий запис уже є.',
  'error.validation': 'Перевірте заповнені поля.',
  'error.rate_limited': 'Забагато спроб. Зачекайте кілька хвилин.',
  'error.rate_limited_wait': 'Забагато спроб. Спробуйте знову через {n} хв.',
  'error.choose_organization': 'Оберіть організацію.',
  'error.no_membership': 'Цей користувач не має доступу до жодної організації.',
  'error.membership_suspended': 'Ваш доступ призупинено. Зверніться до керівника.',
  'error.member_suspended': 'Цього працівника призупинено — спершу поновіть доступ.',
  'error.fx_rate_missing': 'Немає курсу НБУ для цієї валюти — оновіть курси в розділі «Ціни».',
  'error.fx_source_unavailable': 'Сайт НБУ зараз недоступний. Спробуйте оновити курси пізніше.',
  'error.upload_failed': 'Не вдалося завантажити файл. Спробуйте ще раз.',
  'error.invalid_range': 'Дата завершення має бути пізніше за дату початку.',
  'error.invalid_reference': 'Вибраний запис не знайдено. Оновіть сторінку й оберіть ще раз.',
  'error.invalid_input': 'Перевірте заповнені поля — одне зі значень має неправильний формат.',
  'error.server_error': 'Помилка сервера. Спробуйте пізніше.',
  'error.db_error': 'Помилка сервера. Спробуйте пізніше.',
  'error.bad_request': 'Запит не вдалося виконати. Оновіть сторінку й спробуйте ще раз.',
  'error.conflict': 'Дані щойно змінилися. Оновіть сторінку й спробуйте ще раз.',
  'error.unknown': 'Сталася помилка. Спробуйте ще раз.',
  'error.already_converted': 'Із цієї заявки вже створено справу.',
  'error.note_required': 'Вкажіть причину — без неї зберегти не можна.',
  'error.object_missing': 'Файл не завантажився до кінця. Додайте його ще раз.',
  'error.not_uploaded': 'Файл ще не завантажено.',
  'error.unsupported_type': 'Такий тип файлу не підтримується. Додайте PDF або фото (JPG, PNG).',
  'error.unsupported_mime': 'Такий тип файлу не підтримується. Додайте PDF або фото (JPG, PNG).',
  'error.invalid_size': 'Файл завеликий (макс. {max} МБ).',
  'error.vehicle_documents': 'У машини не в порядку документи: {detail}. Оновіть їх у розділі «Документи».',
  'error.empty_file': 'Файл порожній.',
  'error.name_required': 'Вкажіть назву.',
  'error.already_booked': 'Це місце вже заброньовано для цієї справи на цьому рейсі.',
  'error.cannot_edit_self': 'Свої власні права змінити не можна.',
  'error.no_capacity': 'Не вистачає місць: вільно {free}, потрібно {need}.',
  'error.document_type_archived': 'Цей тип документа в архіві. Оберіть інший або поверніть тип з архіву.',
  'error.invalid_phone': 'Перевірте номер телефону, наприклад: 067 123 45 67 або +48 601 234 567.',
  'error.consent_required': 'Потрібна згода на обробку персональних даних.',
  'error.unknown_template': 'Такого шаблону документа немає.',
  'error.party_required': 'Вкажіть учасника: організацію, контакт, працівника або назву.',
  'error.same_location': 'Склад «звідки» і «куди» мають бути різними.',
  'error.invalid_qty': 'Перевірте кількість: вона має бути додатною і не надто великою.',
  'error.currency_not_supported': 'Ця валюта не підтримується.',
  'error.base_currency': 'Гривня — основна валюта, її курс не задається.',
  'error.invalid_cursor': 'Список застарів. Оновіть сторінку.',
  'error.invalid_item': 'Для послуги вкажіть назву і ціну.',
  'error.contact_required': 'Вкажіть телефон або email.',
  'error.invalid_destination': 'Вкажіть правильний номер телефону або email.',
  'error.no_destination': 'У цього контакту немає телефону чи email для запрошення.',
  'error.no_cabinet_site': 'У компанії ще немає сайту з кабінетом клієнта — запрошення надіслати нікуди.',
  'error.partner_in_use': 'Партнер уже працює в системі: пароль його працівнику може змінити лише власник партнерської компанії.',
  'error.invalid_weekdays': 'Оберіть дні тижня.',
  'error.invalid_document_type': 'Цей тип документа сюди не підходить.',
  'error.unknown_document_type': 'Такого типу документа немає.',
  'error.range_too_long': 'Задовгий період — оберіть не більше двох місяців.',
  'error.invalid_country': 'Невідома країна.',
  'error.owner_required': 'Оберіть, до кого належить документ.',
  'error.cargo_not_allowed': 'Ця машина не перевозить такий вантаж.',
  'error.cargo_required': 'Оберіть тип вантажу.',
  'error.invalid_cargo_type': 'Невідомий тип вантажу.',
  'error.invalid_places': 'Перевірте схему місць у машині.',
  'error.invalid_position': 'Такого місця в машині немає.',
  'error.invalid_stops': 'Перевірте зупинки: час має йти вперед за маршрутом, а посадка — раніше за висадку.',
  'error.case_required': 'Перевезення тіла має бути привʼязане до справи.',
  'error.reference_required': 'Вкажіть замовлення або номер переміщення.',
  'error.ref_required': 'Вкажіть, на що посилається пункт.',
  'error.carrier_required': 'Оберіть перевізника або машину.',
  'error.invalid_dates': 'Дата «з» має бути раніше за дату «по».',
  'error.min_order_not_met': 'Мінімальне замовлення {min}, у цьому {total}.',
  'error.credit_limit_exceeded': 'Перевищено кредитний ліміт: доступно {available}.',
  'error.wrong_status': 'Зараз це неможливо: замовлення вже «{status}».',
  'error.insufficient_stock': 'Не вистачає товару {sku} на складі «{location}»: є {available}, потрібно {needed}.',
  'error.b2b_paused': 'Співпрацю з цим партнером призупинено.',
  'error.duplicate_order': 'Замовлення з цим номером уже є: #{number}.',
  'error.sku_taken': 'Такий артикул уже є в іншого товару.',
  'error.publish_incomplete': 'Товар ще не готовий до публікації: заповніть назву, ціну й фото.',
  'error.seller_incomplete': 'Заповніть дані продавця в налаштуваннях.',
  'orders.sellerMissing': 'Документ створено без повних реквізитів продавця (код ІПН/ЄДРПОУ, IBAN). Заповніть їх у Налаштуваннях → Реквізити компанії.',
  'error.template_mismatch': 'Цей шаблон не підходить до цієї справи.',
  'error.trip_closed': 'Рейс уже закрито — змінювати його не можна.',
  'error.trip_transition': 'Рейс зараз не можна перевести в цей стан.',
  'error.already_received': 'Це вже прийнято на склад.',
  'error.no_document': 'Спершу додайте документ.',
  'error.overlap': 'На цей час уже є запис.',
  'error.shift_overlap': 'Ця зміна перетинається з іншою.',
  'error.template_archived': 'Цей шаблон в архіві.',
  'error.invalid_role': 'Невідома роль.',
  // деталь — ім'я (передача роботи при відсутності); без неї (чергування) лишається перше речення
  'error.person_absent': 'Працівник у цей час відсутній: {detail} — оберіть іншу людину.',
  'error.invalid_image_url': 'Не вдалося відкрити фото за цим посиланням.',
  'error.use_transfer': 'Для переміщення між складами скористайтеся кнопкою «Переміщення».',
  'error.not_a_truck': 'Планувати вантаж можна лише для вантажних рейсів.',
  'error.unknown_site': 'Невідомий сайт.',
  'error.site_required': 'Не вказано сайт.',
  'error.unknown_service_type': 'Невідомий вид послуги.',
  'error.unknown_channel': 'Невідомий канал продажу.',
  'error.invalid_attribute': 'Перевірте властивості товару.',
  'error.invalid_axis': 'Окремі варіанти можна створювати лише зі списку або кольору.',
  'error.no_axes': 'У товару немає властивостей, з яких створюються варіанти.',
  'error.invalid_type': 'Варіанти значень бувають лише у властивостей типу «список» або «колір».',
  'error.invalid_parent': 'Категорія не може бути вкладена сама в себе.',
  'error.invalid_folder': 'Невідома папка.',
  'error.invalid_flags': 'Перевірте позначки пункту.',
  'error.file_too_large': 'Файл завеликий (макс. {max} МБ).',
  'error.too_many_images': 'Забагато фото: можна не більше {max}.',
  'error.invalid_iban': 'Перевірте IBAN: він починається з UA і має 29 символів.',
  'error.invalid_tax_id': 'Перевірте код ЄДРПОУ/ІПН: має бути {digits} цифр.',
  'error.location_not_empty': 'Склад не порожній: на ньому ще {on_hand} од. товару. Спершу перемістіть залишки.',
  'error.no_items': 'Додайте в замовлення хоча б одну позицію.',
  'error.no_price': 'Немає ціни для цього товару — додайте її в розділі «Ціни».',
  'error.guardChecklist': 'Не можна перейти далі: у чеклісті ще {n|обовʼязковий документ|обовʼязкові документи|обовʼязкових документів}.',
  'error.guardChecklistList': 'Не можна перейти далі: у чеклісті ще {n|обовʼязковий документ|обовʼязкові документи|обовʼязкових документів} — {items}.',
  'error.guardDocs': 'Не можна перейти далі: бракує {n|обовʼязкового документа|обовʼязкових документів|обовʼязкових документів}.',
  'error.guardFailed': 'Не можна перейти далі: спершу виконайте обовʼязкові кроки.',
  'error.transitionNotAllowed': 'Справу не можна перевести в цей етап напряму.',
  'error.orderStatus': 'Зараз це неможливо: замовлення вже «{status}».',
  'error.orderNoItems': 'Додайте в замовлення хоча б одну позицію.',
  'error.orderConfirmed': 'Замовлення вже підтверджено.',
  'error.noPipelineOrder': 'У справі ще немає замовлення — спершу застосуйте план.',
  'error.applyTemplate': 'Спершу застосуйте шаблон плану.',
  'error.generatedByBlock': 'Цей рядок створено блоком плану — змініть або приберіть сам блок.',
  'error.noDefaultPrice': 'Немає основного прайс-листа — створіть його в розділі «Ціни».',
  'error.contactAnonymized': 'Цей контакт знеособлено — обʼєднати з ним не можна.',
  'error.vehicleTypeBooked': 'Цей тип машини вже використовується в активних рейсах — змінювати місця не можна.',
  'error.vehicleInactive': 'Ця машина неактивна.',
  'error.stopHasLoads': 'На цій зупинці є вантажі — спершу перенесіть їх.',
  'error.tripTwoStops': 'Рейс має мати щонайменше дві зупинки.',
  'error.tripClosed': 'Рейс уже закрито — змінювати його не можна.',
  'error.shipmentClosed': 'Перевезення вже закрито.',
  'error.shipmentTransition': 'Перевезення зараз не можна перевести в цей стан.',
  'error.batchLoaded': 'Цю партію вже повністю завантажено.',
  'error.poLoaded': 'Замовлення вже завантажене в рейс.',
  'error.deceasedRequired': 'Спершу заповніть дані про померлого.',
  'error.keepOwner': 'В організації має лишитися хоча б один активний власник.',
  'error.attrInUse': 'Властивість уже використовується в товарах — змінити це не можна.',
  'error.leadConverted': 'Із цієї заявки вже створено справу.',
  'error.absenceDecided': 'Цю відсутність уже розглянуто.',
  'error.b2bStatus': 'Співпрацю з цим партнером призупинено.',
  'error.clientUploadOnly': 'Клієнт може лише завантажувати документи.',
  'error.noStockLocation': 'Немає складу для резерву — створіть склад у розділі «Склад».',
  'error.dupName': 'Запис із такою назвою вже є.',
  'error.c.vehicles_plate': 'Машина з таким номером уже є.',
  'error.c.product_variants_organization_id_sku_key': 'Такий артикул уже є в іншого товару.',
  'error.c.users_email_key': 'Користувач із таким email уже є.',
  'error.c.sites_domain_key': 'Сайт із таким доменом уже є.',
  'error.c.inventory_levels_on_hand_check': 'Не вистачає товару на складі.',
  'error.c.inventory_levels_reserved_check': 'Не вистачає товару на складі.',
  'error.c.inventory_levels_check': 'Не вистачає вільного товару на складі: частину вже зарезервовано під замовлення.',
  'error.c.orders_organization_id_number_key': 'Замовлення з таким номером уже є.',
  'error.c.orders_external': 'Замовлення з цим номером уже є.',
  'error.c.trip_stops_trip_id_seq_key': 'Така зупинка в рейсі вже є.',
  'error.c.price_lists_one_default': 'Основний прайс-лист може бути лише один.',
  'error.c.memberships_user_id_organization_id_key': 'Цей користувач уже є в організації.',
  'error.c.contact_identities_organization_id_kind_value_normalized_key': 'Цей телефон або email уже належить іншому контакту.',
  'error.c.case_checklist_items_case_id_document_type_id_key': 'Цей документ уже є в чеклісті.',
  'error.c.channel_listings_channel_id_variant_id_key': 'Цей товар уже є в каналі продажу.',
  'error.c.product_translations_organization_id_locale_slug_key': 'Така адреса сторінки товару вже зайнята.',
  'error.c.collection_items_collection_id_product_id_key': 'Цей товар уже є в колекції.',
  'error.v.minLength': 'Поле «{field}» занадто коротке (мінімум {n} символів).',
  'error.v.maxLength': 'Поле «{field}» занадто довге (максимум {n} символів).',
  'error.v.required': 'Заповніть поле «{field}».',
  'error.v.invalid': 'Перевірте поле «{field}».',
  'error.v.requiredAny': 'Заповніть обовʼязкові поля.',
  // підписи полів для повідомлень про помилки перевірки (B5)
  'field.password': 'Пароль',
  'field.new_password': 'Новий пароль',
  'field.current_password': 'Поточний пароль',
  'field.email': 'Email',
  'field.phone': 'Телефон',
  'field.name': 'Назва',
  'field.full_name': 'ПІБ',
  'field.title': 'Назва',
  'field.plate': 'Номерний знак',
  'field.sku': 'Артикул',
  'field.qty': 'Кількість',
  'field.price': 'Ціна',
  'field.amount_minor': 'Сума',
  'field.unit_price_minor': 'Ціна',
  'field.domain': 'Домен',
  'field.code': 'Код',
  'field.number': 'Номер',
  'field.message': 'Повідомлення',
  'field.body': 'Текст',
  'field.note': 'Коментар',
  'field.country': 'Країна',
  'field.city': 'Місто',
  'field.address': 'Адреса',
  'field.starts_at': 'Початок',
  'field.ends_at': 'Кінець',
  'field.date_from': 'Дата з',
  'field.date_to': 'Дата по',
  'field.origin_country': 'Звідки',
  'field.dest_country': 'Куди',
  'field.seats': 'Кількість місць',
  'field.payload_kg': 'Вантажопідйомність',
  'field.valid_until': 'Дійсний до',
  'field.key': 'Код',

  // тема
  'theme.toDark': 'Темна тема',
  'theme.toLight': 'Світла тема',
  'theme.toggle': 'Перемкнути світлу або темну тему',

  // навігація
  'nav.label': 'Розділи CRM',
  'nav.dashboard': 'Огляд',
  'nav.leads': 'Заявки',
  'nav.inbox': 'Повідомлення',
  'nav.cases': 'Справи',
  'nav.products': 'Товари',
  'nav.inventory': 'Склад',
  'nav.orders': 'Замовлення',
  'nav.b2b': 'Оптові (B2B)',
  'nav.pricing': 'Ціни',
  'nav.channels': 'Канали продажу',
  'nav.settings': 'Налаштування',
  'nav.logout': 'Вийти',
  'nav.menu': 'Меню',
  'nav.profile': 'мій профіль і безпека',
  'nav.sub': 'Вкладки розділу',
  'nav.noAccess': 'Цей розділ недоступний для вашої ролі.',
  'nav.group.work': 'Робота',
  'nav.group.trade': 'Торгівля',
  'nav.group.logistics': 'Логістика',
  'nav.group.team': 'Команда',
  'nav.group.settings': 'Налаштування',
  'nav.today': 'Сьогодні',
  'nav.requests': 'Звернення',
  'nav.tasks': 'Задачі',
  'nav.catalog': 'Каталог',
  'nav.collections': 'Колекції',
  'nav.stock': 'Залишки',
  'nav.fleet': 'Рейси і місця',
  'nav.freight': 'Поставки з цеху',
  'nav.planner': 'Планування',
  'nav.documents': 'Документи',
  'nav.dictionaries': 'Властивості товарів',
  'nav.vehicleTypes': 'Місткість машин',
  'nav.processes': 'Процеси',
  'nav.users': 'Користувачі і доступ',
  'nav.control': 'Показники й цілі',

  'scope.label': 'Країна',
  'scope.onlyCountry': 'Вам доступна лише ця країна',
  'scope.countries': 'Країни',
  'scope.allCountries': 'Усі країни',
  'scope.showAll': 'Показати всі країни',
  'scope.switchTo': 'Перемкнути на {country}',

  'search.title': 'Пошук',
  'search.placeholder': 'Пошук: телефон, справа, держномер',
  'search.type.case': 'Справа',
  'search.type.order': 'Замовлення',
  'search.type.contact': 'Контакт',
  'search.type.product': 'Товар',
  'search.type.vehicle': 'Машина',
  'search.type.trip': 'Рейс',

  'today.morning': 'Доброго ранку',
  'today.day': 'Добрий день',
  'today.evening': 'Добрий вечір',
  'today.burningCount': 'потребує уваги: {n}',
  'today.tasksCount': 'задач на сьогодні: {n}',
  'today.newOrder': 'Нове замовлення',
  'today.newCase': 'Нова справа',
  'today.burning': 'Потребує уваги',
  'today.nothingBurns': 'Нічого не горить.',
  'today.myTasks': 'Мої задачі',
  'today.allTasks': 'усі',
  'today.doneOf': '{done} з {total}',
  'today.inCase': 'Справа {n}',
  'today.noDue': 'без терміну',
  'today.myOpenN': 'моїх відкритих: {n}',
  'today.nextDue': 'найближче {d}',
  'today.otherTasks': 'Без справи',
  'task.dueEndOfDay': '{d}, до кінця дня',
  'task.openCase': 'Відкрити справу',
  'task.markDone': 'Позначити виконаним',
  'task.reopen': 'Повернути в роботу',
  'task.markDoneAria': 'Позначити виконаним: {title}',
  'task.reopenAria': 'Повернути в роботу: {title}',
  'task.doneAt': 'виконано {d}',
  'task.notDone': 'Не виконано',
  'task.step': 'Крок плану',
  'task.what': 'Що потрібно',
  'task.other': 'Інші задачі',
  'task.allOfCase': 'Усі задачі справи',
  'today.goal': 'Ціль: {n} трун',
  'today.forecast': 'прогноз',
  'today.details': 'Детальніше',
  'today.soldOf': 'з {n} продано',
  'today.pace': 'Темп за {n|день|дні|днів}',
  'today.perWeek': '{n}/тиж',
  'today.eta': 'Ціль буде виконана орієнтовно',
  'today.notEnoughData': 'Прогноз зʼявиться, коли буде хоча б тиждень продажів',
  'today.burn.absence': '{kind}: {from} — {to}, чекає погодження',
  'today.burn.conflict': 'У відпустці, але призначено: {what}',
  'today.act.lead': 'Відповісти',
  'today.act.absence': 'Погодити',
  'today.act.doc': 'Оновити',
  'today.act.task': 'Відкрити задачу',
  'today.more': 'і ще {n}',
  'today.shownFirst': 'Показано перші {n}',
  'today.alertsOff': 'Про нові повідомлення клієнтів зараз ніхто не дізнається одразу: у чергуванні не вказано Telegram-чат (поле «Номер чату в Telegram») або Telegram-бот не підключений. Відкрити чергування',
  'today.burn.conflictNamed': '{name} {away}, але призначено: {what}',
  'today.away.vacation': 'у відпустці',
  'today.away.sick': 'на лікарняному',
  'today.away.day_off': 'на вихідному',
  'today.away.absent': 'відсутній(-я)',
  'today.noDueMore': 'Без терміну: ще {n}',
  'today.showAll': 'Показати всі',
  'today.belowFloor': '{channel}: середня ціна {price}, нижче {floor}',
  'today.goalHint': 'Рахується з реальних замовлень по всіх каналах. Тривога, якщо середня ціна каналу нижче {floor}.',
  'today.week': 'Мій тиждень',
  'today.calendar': 'Календар',
  'today.weekEmpty': 'На цей тиждень нічого не заплановано.',
  'today.nTasks': 'задач: {n}',
  'today.duty': 'Чергування',
  'today.shift': 'Зміна',
  'today.absence': 'Відсутність',
  'today.trip': 'Рейс',
  'today.burn.taskLate': 'Прострочено на {t}',
  'today.burn.lead': 'Звернення: {name}',
  'today.burn.leadLate': 'Не відповіли вчасно — минуло {t}',
  'today.burn.urgent': 'Терміновий пріоритет',
  'today.burn.noStock': '{channel}: товарів без залишку — {n}',
  'today.burn.noStockHint': 'Досі показуються в продажу',
  'today.burn.docExpired': 'Термін дії минув {n|день|дні|днів} тому',
  'today.burn.docExpires': 'Термін дії спливає через {n|день|дні|днів}',

  'common.pcs': 'шт',

  'catalog.view': 'Вигляд каталогу',
  'catalog.newProduct': 'Товар',
  'catalog.kpi.active': 'Активних товарів',
  'catalog.kpi.leader': 'Лідер попиту, 30 днів',
  'catalog.kpi.sold': 'Продано за 30 днів',
  'catalog.kpi.priceCost': 'Середня ціна / собівартість',
  'catalog.filters': 'Фільтри з довідників:',
  'catalog.clear': 'Скинути',
  'catalog.searchPh': 'Назва або артикул',
  'catalog.allCategories': 'Усі категорії',
  'catalog.found': 'Товарів: {n}',
  'catalog.col.product': 'Товар',
  'catalog.col.sales': 'Продажі, 30 днів',
  'catalog.col.stock': 'Залишок',
  'catalog.col.price': 'Ціна · маржа',
  'catalog.demand': 'Попит',
  'catalog.views': '{n} переглядів',
  'catalog.margin': 'маржа {n}%',
  'catalog.noCost': 'собівартість невідома',
  'catalog.listedNoStock': 'в продажу без залишку!',
  'catalog.madeToOrder': 'під замовлення, {n|день|дні|днів}',
  'catalog.openProduct': 'Відкрити товар',
  'catalog.demandHint': 'Попит = продажі й перегляди за 30 днів відносно середнього по категорії. Рахується щоночі з денної статистики по каналах.',
  'catalog.updated': 'Оновлено {t}.',
  'catalog.noStats': 'Статистику ще не рахували.',
  'catalog.recompute': 'Перерахувати зараз',
  'catalog.recomputed': 'Статистику перераховано',
  'demand.high': 'Високий',
  'demand.good': 'Добрий',
  'demand.medium': 'Середній',
  'demand.low': 'Низький',
  'demand.new': 'Новий',

  'collections.new': 'Нова колекція',
  'collections.newHint': 'Назва, історія, моделі і кольори з довідника, план продажу. Можна запустити як тест: мала партія на один канал.',
  'collections.models': 'Моделей',
  'collections.subtitle': 'Нові лінійки товарів: план продажів на перші 30 і 90 днів і як вони продаються порівняно з попередніми.',
  'collections.empty': 'Колекцій ще немає.',
  'collections.plan30': 'План 30 днів, шт',
  'collections.plan90': 'План 90 днів',
  'collections.sold': 'Продано',
  'collections.planDone': 'Виконання плану',
  'collections.noModels': 'Моделей ще немає.',
  'collections.startsIn': 'Старт {d}, через {n|день|дні|днів}',
  'collections.launched': 'У продажу з {d}',
  'collections.noLaunch': 'Без дати запуску',
  'collections.vsControl': 'Перші 30 днів: {a} шт проти {b} шт у «{name}».',
  'collections.launchDate': 'Дата запуску',
  'collections.control': 'Контрольна колекція',
  'collections.story': 'Історія колекції',
  'collections.ownPrice': 'Своя ціна, грн',
  'collections.addModel': 'Додати модель…',
  'collectionStatus.draft': 'Чернетка',
  'collectionStatus.test': 'Тест',
  'collectionStatus.live': 'У продажу',
  'collectionStatus.archived': 'Архів',

  'product.collection': 'Колекція «{name}»',
  'product.updateStock': 'Оновити залишок',
  'product.toCard': 'До картки',
  'product.onHand': 'На складі',
  'product.available': 'Вільно до продажу',
  'product.sold30': 'Продано, 30 дн',
  'product.reserved': 'У резерві',
  'product.main': 'Основне',
  'product.cost': 'Собівартість',
  'product.kind': 'Тип',
  'product.leadTime': 'Термін виготовлення',
  'product.days': '{n|день|дні|днів}',
  'product.packed': 'Габарити в упаковці',
  'product.noDims': 'не вказано',
  'product.packedHint': 'потрібно, щоб рахувати, скільки поміститься у фуру',
  'product.attributes': 'Атрибути з довідника',
  'product.attributesWhere': 'Налаштування → Властивості товарів',
  'product.axis': 'створює окремі варіанти',
  'product.newColor': 'Новий колір',
  'product.variants': 'Варіанти',
  'product.skuCount': '{n|артикул|артикули|артикулів}',
  'product.generate': 'Створити з осей',
  'product.generated': 'Варіанти: створено {created}, вимкнено {off}',
  'product.stock': 'Залишок',
  'product.none': '—',
  'product.off': 'вимкнено',
  'product.channelPrices': 'Ціни по каналах',
  'product.channel': 'Канал',
  'product.noVariants': 'У товару ще немає варіантів.',

  'edit.attributesDictHint': 'Значення з Налаштування → Властивості товарів',
  'edit.noAttributes': 'Для цієї категорії атрибутів немає.',

  'dict.subtitle': 'Атрибути товарів і їхні значення: кольори, матеріали, розміри. Нове значення — новий рядок, без програміста.',
  'dict.attributes': 'Атрибути',
  'dict.newAttribute': 'Атрибут',
  'dict.showArchived': 'Показати архів',
  'dict.archive': 'В архів',
  'dict.restore': 'Повернути',
  'dict.isFilter': 'Фільтр у каталозі і на сайті',
  'dict.isAxis': 'Кожне значення стає окремим варіантом зі своїм артикулом',
  'dict.categories': 'Для категорій',
  'dict.allCategories': 'Усі категорії',
  'dict.values': 'Значення',
  'dict.newValue': 'Нове значення',
  'dict.colorPlaceholder': 'напр. Махагон',
  'dict.swatch': 'Зразок',
  'dict.usedIn': 'товарів: {n}',
  'dict.key': 'Ключ',
  'dict.keyHint': 'Латиницею, для фільтрів на сайті й маркетплейсів. Потім не змінюється.',
  'dict.type': 'Тип',
  'dict.unit': 'Одиниця',
  'attrType.list': 'Список',
  'attrType.color': 'Колір',
  'attrType.number': 'Число',
  'attrType.text': 'Текст',

  'fleet.title': 'Рейси і місця',
  'fleet.subtitle': 'Знайдіть вільне місце на дату й маршрут, або оберіть машину, щоб побачити її рейс.',
  'fleet.searchTitle': 'Знайти вільне місце',
  'fleet.add': 'Додати…',
  'fleet.addVehicle': 'Машину',
  'fleet.addOffer': 'Вільні місця від партнера',
  'fleet.route1': 'Маршрут',
  'fleet.bookedNext': 'Місце заброньовано. Перевести справу {n} на наступний етап?',
  'fleet.notNow': 'Не зараз',
  'fleet.onlyOpenCases': 'Показуються лише відкриті справи з перевезенням тіла.',
  'fleet.whose': 'Чиї машини',
  'fleet.partner': 'Партнерів',
  'fleet.ownLeased': 'Наші машини',
  'fleet.ours': 'наша',
  'fleet.partnerName': 'Партнер «{name}»',
  'fleet.updated': 'оновлено {t}',
  'fleet.list': 'Машини',
  'fleet.idleMore': 'Ще {n|машина|машини|машин} без рейсів у ці дні',
  'fleet.noVehicles': 'Машин ще немає. Додайте машину партнера або власну.',
  'fleet.noTrip': 'без рейсу',
  'fleet.noTripShort': 'без рейсу',
  'fleet.lateDeparture': 'не вирушив вчасно',
  'fleet.freeOf': 'вільно {n} з {m}',
  'fleet.route': 'Звідки → куди',
  'fleet.routePh': 'Львів → Краків',
  'fleet.when': 'Коли',
  'fleet.what': 'Що',
  'fleet.find': 'Знайти',
  'fleet.results': 'Підходить рейсів: {n}',
  'fleet.fits': 'підходить · вільно {n} з {m}',
  'fleet.reason.no_capacity': 'немає місця',
  'fleet.reason.cargo_not_allowed': 'не возить цей вантаж',
  'fleet.offerPlaces': 'вільно {n} з {m}',
  'fleet.source.partner_cabinet': 'кабінет партнера',
  'fleet.source.api': 'API партнера',
  'fleet.source.dispatcher': 'диспетчер',
  'fleet.offer': 'Вільні місця від партнера',
  'fleet.newOffer': 'Вільні місця від партнера',
  'fleet.offerHint': 'Що партнер повідомив телефоном чи в месенджері. Згодом партнер відмічатиме це сам у своєму кабінеті.',
  'fleet.offerSaved': 'Місця партнера збережено',
  'fleet.dateFrom': 'Дата з',
  'fleet.dateTo': 'Дата по',
  'fleet.places': 'Місць',
  'fleet.vehicle': 'Машина',
  'fleet.trip': 'Рейс',
  'fleet.newTrip': 'Новий рейс',
  'fleet.tripCreated': 'Рейс створено',
  'fleet.stops': 'Зупинки маршруту',
  'fleet.place': 'Місто або адреса',
  'fleet.addStop': 'Зупинка',
  'fleet.vehicleDriver': 'Водій машини',
  'fleet.newVehicle': 'Нова машина',
  'fleet.vehicleCreated': 'Машину додано',
  'fleet.ownershipLabel': 'Чия машина',
  'fleet.ownership.partner': 'партнерська',
  'fleet.ownership.leased': 'лізингова',
  'fleet.ownership.owned': 'власна',
  'fleet.carrier': 'Перевізник',
  'fleet.newCarrierOpt': 'Новий перевізник…',
  'fleet.newCarrier': 'Назва нового перевізника',
  'fleet.plate': 'Держномер',
  'fleet.model': 'Модель',
  'fleet.base': 'Базове місто',
  'fleet.driver': 'Водій',
  'fleet.leaseCompany': 'Лізингова компанія',
  'fleet.leaseNo': 'Договір лізингу №',
  'fleet.leaseEnd': 'Лізинг до',
  'fleet.leaseMonthly': 'Платіж на місяць',
  'fleet.profile': 'Профіль',
  'fleet.profileVal': '{name} · {n} місць',
  'fleet.body.van': 'Бус',
  'fleet.body.hearse': 'Катафалк',
  'fleet.body.truck': 'Фура',
  'fleet.body.other': 'Інше',
  'fleet.vstatus.active': 'активна',
  'fleet.vstatus.repair': 'ремонт',
  'fleet.vstatus.inactive': 'не працює',
  'tripStatus.planned': 'заплановано',
  'tripStatus.in_progress': 'в дорозі',
  'tripStatus.done': 'завершено',
  'tripStatus.cancelled': 'скасовано',
  'fleet.sideView': 'вигляд збоку',
  'fleet.topView': 'Вантажний відсік, вигляд зверху',
  'fleet.cabin': 'кабіна',
  'fleet.typeCapacity': 'Місткість цього типу машини',
  'fleet.tripSegments': 'Рейс: вільні місця між зупинками',
  'fleet.book': 'Забронювати місце',
  'fleet.bookTitle': 'Місце на рейсі {n}',
  'fleet.booked': 'Місце заброньовано',
  'fleet.unbook': 'Зняти',
  'fleet.unbookConfirm': 'Зняти бронь з рейсу?',
  'fleet.unbooked': 'Бронь знято',
  'fleet.caseSearch': 'Справа',
  'fleet.caseSearchPh': 'Номер справи або ПІБ померлого',
  'fleet.transferRef': 'Документ переміщення або замовлення',
  'fleet.noTripsForVehicle': 'У цієї машини немає запланованих рейсів.',
  'fleet.seatsFree': 'пасажирських місць вільно {n} з {m}',
  'fleet.pickups': 'забір: {n}',
  'fleet.drops': 'видача: {n}',
  'fleet.departure': 'відправлення',
  'fleet.final': 'кінцева',
  'fleet.freeTo': 'до {place}: вільно {n} з {m}',
  'fleet.segmentsHint': 'Вільні місця рахуються по кожному відрізку: місткість мінус те, що вже везуть між цими зупинками. Клік по зупинці показує план на відрізку від неї.',
  'fleet.free': 'Вільно',
  'fleet.wholeRoute': 'на відрізку',
  'fleet.onlyFor': 'лише {c}',
  'fleet.unitsOf': '{n} з {m}',
  'fleet.placeAria': 'Місце {n}: {s}',
  'fleet.mode.any': 'Будь-що',
  'fleet.mode.off': 'Недоступно',
  'fleet.legend.body': 'тіло',
  'fleet.legend.coffin': 'труна в упаковці',
  'fleet.legend.partial': 'вільно частково',
  'fleet.legend.free': 'вільно',

  'vt.newType': 'Тип',
  'vt.holds': 'Вміщає',
  'vt.any': '{n} будь-яких',
  'vt.anyStack': '{n} будь-яких (до {m} трун)',
  'vt.nothing': 'нічого',
  'vt.floor': 'План вантажного відсіку, вигляд зверху',
  'vt.floorHint': 'Клік по місцю міняє, що на ньому можна везти',
  'vt.levelsShort': '× {n} ярус.',
  'vt.placeN': 'місце {n}',
  'vt.capacity': 'Місткість',
  'vt.rows': 'Місць уздовж',
  'vt.cols': 'Місць поперек',
  'vt.levels': 'Ярусів для упакованих трун',
  'vt.seats': 'Місць у салоні для супроводу',
  'vt.payload': 'Вантажопідйомність, кг',
  'vt.bodyType': 'Тип кузова',
  'vt.art': 'Малюнок',
  'vt.allowed': 'Що можна возити',
  'vt.allowedHint': 'Список береться з довідника «Типи вантажу»',
  'vt.newCargo': 'Новий тип вантажу',
  'vt.stackable': 'ярусами',
  'vt.footer': 'Кожна машина автопарку бере один тип. Партнер зможе змінити місткість своєї машини у своєму кабінеті.',

  'case.view': 'Вигляд справи',
  'case.tabDelivery': 'Доставка',
  'case.tabDetails': 'Документи і хронологія',
  'case.customerLine': 'замовник {name}',
  'case.assigneeLine': 'відповідальний {name}',

  'pipe.chain': 'План справи',
  'pipe.noChain': 'План — це кроки справи: хто що робить, які документи потрібні, скільки це коштує. Оберіть шаблон — потрібні документи для країн відправлення і призначення підставляться самі. Після застосування створяться задачі для кроків і чернетка замовлення для клієнта.',
  'pipe.template': 'Шаблон',
  'pipe.variants': 'Варіанти справи',
  'pipe.variantsHint': 'Зміна варіанту перебудовує план: додає або прибирає кроки.',
  'pipe.selectStep': 'Кроки плану — оберіть, щоб побачити деталі',
  'pipe.templateLine': 'Шаблон «{name}»',
  'pipe.assemble': 'Застосувати шаблон',
  'pipe.applied': 'План складено: додано задачі і чернетку замовлення',
  'pipe.noTemplates': 'Шаблонів ще немає: Налаштування → Процеси.',
  'pipe.readiness': 'Готовність справи',
  'pipe.ready': 'Готово {n}%',
  'pipe.missingN': 'бракує: {n}',
  'pipe.done': 'готово',
  'pipe.missingBadge': 'ще {n}',
  'pipe.noParty': 'виконавця не призначено',
  'pipe.block': 'Крок',
  'pipe.addBlock': 'Додати крок',
  'pipe.blockType': 'Який крок',
  'pipe.position': 'Номер кроку в плані',
  'pipe.manual': 'доданий вручну',
  'pipe.removeConfirm': 'Прибрати крок зі справи? Його незроблені задачі і рядки замовлення теж зникнуть.',
  'pipe.blockRemoved': 'Крок прибрано',
  'pipe.who': 'Хто виконує',
  'pipe.docs': 'Документи',
  'pipe.todo': 'Що зробити',
  'pipe.nuance': 'Зверніть увагу',
  'pipe.trips': 'Рейси',
  'pipe.noBooking': 'Місце ще не заброньовано.',
  'pipe.autoFromFleet': 'відмітиться саме, коли заброньоване місце в рейсі',
  'pipe.optional': 'за потреби',
  'pipe.openTask': 'Відкрити задачу',
  'pipe.assign': 'Призначити',
  'pipe.partyPh': 'Організація або людина',
  'pipe.upload': 'Завантажити',
  'pipe.uploaded': 'Документ завантажено',
  'pipe.fromCatalog': 'З каталогу',
  'pipe.fromCatalogFull': 'Товар з каталогу',
  'pipe.addProduct': 'Товар з каталогу',
  'pipe.productAdded': 'Товар додано до замовлення',
  'pipe.addTodo': 'Додати свій пункт до цього кроку',
  'pipe.blockTitle': 'Свій заголовок',
  'pipe.partnerCost': 'Вартість партнера',
  'pipe.partnerCostHint': 'У валюті партнера; у гривні — за курсом НБУ з націнкою',
  'pipe.clientPrice': 'Ціна клієнту, грн',
  'pipe.clientPriceHint': 'Порожньо — вартість партнера + наша націнка',
  'pipe.missingAll': 'Чого бракує по всій справі',
  'pipe.nothingMissing': 'Усе на місці.',
  'pipe.inBlock': 'крок {n} · {kind}',
  'pipe.andMore': 'і ще {n}',
  'pipe.order': 'Замовлення для клієнта',
  'pipe.openOrder': 'Відкрити замовлення',
  'pipe.noLines': 'Рядків ще немає.',
  'pipe.orderNeedsCustomer': 'Замовлення для клієнта зʼявиться, щойно в справі буде замовник: додайте його у вкладці «Огляд» → «Контакти» (роль «Замовник»).',
  'pipe.line': 'Позиція',
  'pipe.from': 'Звідки',
  'pipe.cost': 'Собівартість',
  'pipe.costUah': 'Собівартість, грн',
  'pipe.margin': 'Маржа: {amount}',
  'pipe.marginFx': 'ціну з {currency} перераховано в гривні за курсом замовлення {rate}',
  'pipe.catalog': 'каталог',
  'pipe.noRate': 'немає курсу',
  'pipe.orderHint': 'Рядки додаються з кроків плану. Ціна партнерського рядка = вартість партнера в гривнях (курс НБУ + націнка валюти) + наша націнка кроку, округлено вгору. Якщо справа в MDL чи EUR, ця ціна ще раз переводиться у валюту справи за курсом НБУ з націнкою цієї валюти. Собівартість завжди в гривнях. Прибрали крок — зник і його рядок.',
  'pipe.orderLocked': 'Замовлення підтверджене: зміни плану його вже не змінюють.',
  'pipe.src.our': 'наша послуга',
  'pipe.src.partner': 'партнер, {c}',
  'pipe.src.product': 'товар',
  'pipe.kind.intake': 'Прийом',
  'pipe.kind.intermediary': 'Похоронний дім за кордоном',
  'pipe.kind.cremation': 'Кремація',
  'pipe.kind.preparation': 'Підготовка до вивозу',
  'pipe.kind.permits': 'Дозволи',
  'pipe.kind.transport': 'Перевезення',
  'pipe.kind.transit': 'Транзит',
  'pipe.kind.handover': 'Видача родині',
  'pipe.kind.goods': 'Товари',
  'pipe.kind.other': 'Інше',
  'pipe.mode.road': 'авто',
  'pipe.mode.air': 'авіа',
  'pipe.mode.rail': 'залізниця',
  'pipe.role.coordinator': 'відповідальний',
  'pipe.role.intermediary': 'посередник',
  'pipe.role.carrier': 'перевізник',
  'pipe.role.driver': 'водій',
  'pipe.role.consulate': 'консульство',
  'pipe.role.cemetery': 'кладовище',
  'pipe.role.crematorium': 'крематорій',

  'proc.subtitle': 'Шаблони ланцюжків доставки і правила блоків по країнах. Нова країна чи коридор — нові рядки правил, без копіювання шаблонів.',
  'proc.templates': 'Шаблони справ',
  'proc.blockTypes': 'Типи блоків',
  'proc.newTemplate': 'Новий шаблон',
  'proc.newBlockType': 'Новий тип блоку',
  'proc.up': 'Вище',
  'proc.down': 'Нижче',
  'proc.onlyWhen': 'Є в справі',
  'proc.always': 'завжди',
  'proc.not': 'крім випадків: {x}',
  'proc.addStep': 'Тип блоку…',
  'proc.dueDays': 'Термін задачі, днів',
  'proc.dueDaysHint': 'Від дня, коли склали план справи. Порожньо — 2 дні.',
  'proc.toggles': 'Варіанти справи',
  'proc.without': 'без: {x}',
  'proc.togglesHint': 'Галочки, які менеджер ставить у справі (наприклад «Кремація за кордоном»). Від них залежить, які кроки є в плані і які документи потрібні.',
  'proc.defaultOn': 'типово увімкнено',
  'proc.newToggle': 'Новий перемикач, напр. «Авіа до Києва»',
  'proc.preview': 'Що вийде для коридору',
  'proc.mode': 'Транспорт',
  'proc.specific': 'для країни',
  'proc.rule': 'Правило',
  'proc.newRule': 'Нове правило',
  'proc.ruleRemoved': 'Правило видалено',
  'proc.everywhere': 'скрізь',
  'proc.excludes': 'прибирає',
  'proc.via': 'через {c}',
  'proc.cremation': 'Кремація',
  'proc.noCremation': 'без кремації',
  'proc.reqKind.doc': 'Документи',
  'proc.reqKind.action': 'Дії',
  'proc.reqKind.party_role': 'Учасники',
  'proc.reqKind.product': 'Товари',
  'proc.reqKindShort.doc': 'док.',
  'proc.reqKindShort.action': 'дія',
  'proc.reqKindShort.party_role': 'хто',
  'proc.reqKindShort.product': 'товар',
  'proc.lines': 'Рядки замовлення',
  'proc.partnerLine': 'партнер {cost} {cur} + {m}%',
  'proc.ourLine': 'наша ціна {price} грн',
  'proc.kind': 'Вид',
  'proc.docType': 'Тип документа',
  'proc.refKey': 'Ключ',
  'proc.refHint.action': 'латиницею, напр. embalming',
  'proc.refAuto': 'Заповнюється автоматично з назви. Змінюйте, лише якщо знаєте, навіщо.',
  'proc.refHint.party_role': 'роль латиницею, напр. carrier',
  'proc.refHint.product': 'ключ категорії каталогу, напр. coffins',
  'proc.title': 'Назва для людей',
  'proc.responsible': 'Хто приносить',
  'proc.required': 'Обовʼязково',
  'proc.excludeRule': 'Прибрати цю вимогу в цих умовах',
  'proc.conditions': 'Де діє',
  'proc.conditionsHint': 'Порожнє поле — будь-яке. Конкретніше правило (країна, коридор) переважує загальне для тієї ж вимоги.',
  'proc.origin': 'Звідки',
  'proc.dest': 'Куди',
  'proc.transit': 'Транзит через',
  'proc.any': 'будь-яка',
  'proc.service': 'Тип справи',
  'proc.footer': 'Дії беруться зі списку готових блоків, довільний код не пишемо, щоб процес не зламав дані. Документи блоків потрапляють у чекліст справи, тож кабінет клієнта показує їх як раніше.',

  'plan.view': 'Вигляд календаря',
  'plan.team': 'Команда',
  'plan.myWeek': 'Мій тиждень',
  'plan.prev': 'Попередній тиждень',
  'plan.next': 'Наступний тиждень',
  'plan.today': 'Сьогодні',
  'plan.event': 'Подія',
  'plan.newEvent': 'Нова подія',
  'plan.person': 'Людина',
  'plan.allDay': 'весь день',
  'plan.shift': 'Зміна',
  'plan.duty': 'Чергування',
  'plan.task': 'Задача',
  'plan.trip': 'Рейс',
  'plan.requested': 'запит',
  'plan.tabCalendar': 'Календар команди',
  'plan.dutyHint': 'Хто приймає нові заявки і дзвінки в який час. Заявки без відповідального приходять черговому.',
  'plan.moreN': '+{n} ще',
  'plan.legend.shift': 'Зміна',
  'plan.legend.duty': 'Чергування',
  'plan.legend.task': 'Задача',
  'plan.legend.trip': 'Рейс',
  'plan.legend.vacation': 'Відпустка',
  'plan.legend.off': 'Вихідний, лікарняний',
  'plan.kind.shift': 'Зміна',
  'plan.kind.duty': 'Чергування',
  'plan.kind.task': 'Задача',
  'plan.kind.trip': 'Рейс',
  'plan.kind.absence': 'Відсутність',
  'plan.src.shift': 'Графік змін',
  'plan.src.duty': 'Графік чергувань',
  'plan.src.task': 'Справи',
  'plan.src.trip': 'Логістика',
  'plan.src.absence': 'Запит на відсутність',
  'plan.abs.vacation': 'Відпустка',
  'plan.abs.sick': 'Лікарняний',
  'plan.abs.day_off': 'Вихідний',
  'plan.abs.absent': 'Відсутність',
  'plan.absKind': 'Що саме',
  'plan.when': 'Коли',
  'plan.who': 'Хто',
  'plan.from': 'Звідки',
  'plan.pick': 'Оберіть подію в календарі, щоб побачити деталі.',
  'plan.approve': 'Погодити',
  'plan.reject': 'Відхилити',
  'plan.cancelAbsence': 'Скасувати відсутність',
  'plan.handOver': 'Передати іншому',
  'plan.handOverBtn': 'Передати',
  'plan.reassigned': 'Задачу передано',
  'plan.conflictHint': 'Людина в цей час відсутня — передайте іншому.',
  'plan.conflicts': 'Конфліктів з відсутностями: {n}',
  'plan.requests': 'Запити на відсутність',
  'plan.whereFrom': 'Звідки береться календар',
  'plan.whereFromText': 'Рейси і задачі зʼявляються самі з Логістики і Справ. Зміни ставить керівник (шаблон на період одним кліком), відпустки і вихідні людина подає запитом.',
  'plan.applyTemplate': 'Шаблон змін',
  'plan.template': 'Шаблон',
  'plan.myself': 'Я сам(а)',
  'plan.sendRequest': 'Надіслати запит',
  'plan.requestHint': 'Запит побачить керівник; після погодження відсутність зʼявиться в календарі команди.',

  'docs.upload': 'Завантажити',
  'docs.uploaded': 'Документ завантажено',
  'docs.folders': 'Папки',
  'docs.all': 'Усі документи',
  'docs.folder.vehicles': 'Машини',
  'docs.folder.partners': 'Партнери і договори',
  'docs.folder.leasing': 'Лізинг',
  'docs.folder.cases': 'Справи',
  'docs.folder.trips': 'Рейси: CMR, накладні',
  'docs.folder.staff': 'Персонал',
  'docs.folder.company': 'Компанія',
  'docs.search': 'Пошук у документах',
  'docs.searchPh': 'Назва, номер, держномер',
  'docs.empty': 'Документів немає.',
  'docs.doc': 'Документ',
  'docs.type': 'Тип',
  'docs.owner': 'Привʼязано до',
  'docs.until': 'Діє до',
  'docs.access': 'Доступ',
  'docs.title': 'Назва',
  'docs.number': 'Номер',
  'docs.validFrom': 'Діє з',
  'docs.file': 'Файл',
  'docs.ownerKind': 'Чий документ',
  'docs.owner.case': 'Справа',
  'docs.owner.vehicle': 'Машина',
  'docs.owner.organization': 'Контрагент',
  'docs.owner.employee': 'Співробітник',
  'docs.owner.trip': 'Рейс',
  'docs.owner.company': 'Компанія',
  'docs.missing': 'Бракує',
  'docs.noDate': 'не вказано',
  'docs.unlimited': 'безстроковий',
  'docs.expiresIn': 'Спливає через {n|день|дні|днів}',
  'docs.expiredAgo': 'Прострочено {n|день|дні|днів} тому',
  'docs.mandatoryHint': 'Обовʼязковий для цього типу машини',
  'docs.reminderHint': 'За 14 днів до кінця дії CRM створить задачу оновити документ. Машину з простроченим обовʼязковим документом не можна поставити на рейс.',
  'docs.acc.staff': 'Власник, менеджер, сама людина',
  'docs.acc.special': 'Лише власник і менеджер',
  'docs.acc.vehicles': 'Логісти й офіс',
  'docs.acc.partners': 'Офіс',
  'docs.acc.leasing': 'Офіс',
  'docs.acc.cases': 'Хто веде справу',
  'docs.acc.trips': 'Логісти й водій рейсу',
  'docs.acc.staff_folder': 'Власник і менеджер',
  'docs.acc.company': 'Офіс',
  'fleet.docs': 'Документи',
  'fleet.docOk': 'усі дійсні',
  'fleet.docExpired': '{name}: прострочено',
  'fleet.docExpires': '{name} спливає {d}',
  'fleet.docMissing': 'бракує: {name}',
  'fleet.docsBad': 'прострочений документ',

  'freight.subtitle': 'Вантажні рейси сотнями трун: план кузова, партії з виробництва, графік',
  'freight.trip': 'Рейс {n}',
  'freight.carrier': 'перевізник {name}',
  'freight.loading': 'завантаження {d}',
  'freight.arrival': 'прибуття {d}',
  'freight.cmr': 'CMR і накладна',
  'freight.arrive': 'Прибула: оприбуткувати',
  'freight.arriveConfirm': 'Фура прибула? Товар буде оприбутковано на склад призначення.',
  'freight.received': 'Товар оприбутковано',
  'freight.loaded': 'Завантажено',
  'freight.ofUnits': 'з {n} шт',
  'freight.fill': 'Заповнення',
  'freight.perUnit': 'Вартість рейсу на 1 труну',
  'freight.afterArrival': 'Після прибуття',
  'freight.toStock': '+{n} шт на {loc}',
  'freight.receivedTo': 'оприбутковано {n} шт на {loc}',
  'freight.clickHint': 'Клік по вільній позиції кладе стос з вибраної партії, по стосу — знімає',
  'freight.freePos': 'Вільна позиція {n}',
  'freight.posAria': 'Позиція {n}: {name}, {q} шт',
  'freight.unstackConfirm': 'Зняти стос з плану?',
  'freight.pcs': '{n} шт',
  'freight.capacityHint': 'Місткість з типу машини: {p} позицій × {l} ярусів = {n}. Схему змінюють у Налаштування → Типи машин.',
  'freight.batches': 'Партії до відправки',
  'freight.noBatches': 'Немає партій від виробника. Створіть замовлення виробнику.',
  'freight.newPO': 'Замовлення виробнику',
  'freight.poCreated': 'Замовлення виробнику створено',
  'freight.po': 'Замовлення {n}',
  'freight.here': 'у цій фурі {n}',
  'freight.leftOf': '{n} з {m}',
  'freight.schedule': 'Графік фур',
  'freight.noTrips': 'Цього тижня рейсів фур немає. Рейс створюється в Автопарку для машини з кузовом «Фура».',
  'freight.toLocation': 'Склад призначення',
  'freight.expected': 'Очікується',
  'product.incoming': 'Їде з виробництва',

  'fleet.placesN': '{n} місць',
  'fleet.typeHint': 'Тип визначає, скільки і що вміщає машина: {p} місць у кузові, ярусів для упакованих трун — {l}, місць у салоні — {s}.',
  'vt.copy': 'Копія типу',
  'vt.copied': 'Тип скопійовано — змініть місткість під цю машину',
  'vt.copySuffix': '(копія)',

  'viewer.title': 'Документ',
  'viewer.accepted': 'Документ прийнято',
  'viewer.rejected': 'Документ відхилено — попросіть інший файл',
  'viewer.view': 'Переглянути',
  'viewer.newTab': 'Відкрити в новій вкладці',
  'viewer.noPreview': 'Цей тип файлу не можна показати тут — збережіть його на компʼютер.',
  'viewer.unavailable': 'Файл зараз недоступний. Спробуйте пізніше або відкрийте в новій вкладці.',

  'tasks.title': 'Задачі',
  'tasks.subtitle': 'Одна черга задач з усіх модулів',
  'tasks.who': 'Чиї задачі',
  'tasks.mine': 'Мої',
  'tasks.everyone': 'Усі',
  'tasks.open': 'Відкриті',
  'tasks.done': 'Виконано',
  'tasks.task': 'Задача',
  'tasks.case': 'Справа',
  'tasks.due': 'Термін',

  // вхід
  'login.title': 'Вхід для співробітників',
  'login.email': 'Email',
  'login.password': 'Пароль',
  'login.totp': 'Код з застосунку автентифікації',
  'login.totpHint': 'Введіть 6-значний код з Google Authenticator або аналогу.',
  'login.submit': 'Увійти',
  'login.verify': 'Підтвердити',
  'login.org': 'Організація',
  'login.back': 'Інший обліковий запис',

  // ролі
  'role.owner': 'Власник',
  'role.manager': 'Менеджер',
  'role.operator': 'Оператор',
  'role.accountant': 'Бухгалтер',
  'role.driver': 'Водій',
  'role.partner_admin': 'Партнер (адмін)',
  'role.partner_staff': 'Партнер',
  'role.client': 'Клієнт',

  // дашборд
  'dash.title': 'Показники й цілі',
  'dash.subtitle': 'Головна мета — продаж трун',
  'dash.sold': 'Продано {sold} з {target} трун',
  'dash.left': 'Залишилось {n}',
  'dash.progress': 'Прогрес мети',
  'dash.byChannel': 'Продажі для мети — за каналами',
  'dash.channel': 'Канал',
  'dash.qtySold': 'Продано, шт.',
  'dash.revenue': 'Виручка',
  'dash.avgPrice': 'Середня ціна',
  'dash.margin': 'Маржа',
  'dash.leads': 'Заявки',
  'dash.leadsToday': 'Сьогодні',
  'dash.leadsOpen': 'Відкриті',
  'dash.leadsOverdue': 'Без відповіді вчасно',
  'dash.cases': 'Відкриті справи',
  'dash.orders': 'Замовлення',
  'dash.inbox': 'Непрочитані повідомлення',
  'dash.openInbox': 'Відкрити повідомлення',
  'dash.sales': 'Усі продажі за 30 днів, шт',
  'dash.share': 'Частка',
  'dash.noChannels': 'Продажів ще немає.',
  'dash.goal': 'Мета продажів',
  'dash.attention': 'Потребує уваги',
  'dash.attnOverdue': 'Заявки, на які не відповіли вчасно',
  'dash.attnUnread': 'Непрочитані повідомлення',
  'dash.attnDocs': 'Справи з неповними документами',
  'dash.attnTasks': 'Прострочені задачі',
  'dash.allClear': 'Усе під контролем — термінових справ немає.',
  'dash.myTasks': 'Мої задачі',
  'dash.noTasks': 'Відкритих задач немає.',

  // ліди
  'leads.title': 'Звернення',
  'leads.subtitle': 'Заявки з сайтів, месенджерів і телефону. На нову заявку треба відповісти до вказаного часу.',
  'leads.new': 'Нова заявка',
  'leads.number': '№',
  'leads.contact': 'Контакт',
  'leads.source': 'Джерело',
  'leads.externalRef': 'Номер у старій системі',
  'leads.kind': 'Тип',
  'leads.sla': 'Відповісти до',
  'leads.slaLeft': 'ще {t}',
  'leads.slaOverdue': 'прострочено {t}',
  'leads.slaMet': 'відповідь {t}',
  'leads.convert': 'Створити справу',
  'leads.convertBotConfirm': 'Система позначила цю заявку як «схоже на бота». Ви переконались, що це справжня людина? Створити справу?',
  'leads.convertTitle': 'Створити справу із заявки',
  'leads.serviceType': 'Тип послуги',
  'leads.caseTitle': 'Назва справи',
  'leads.originCountry': 'Країна відправлення',
  'leads.destCountry': 'Країна призначення',
  'leads.openCase': 'Справа',
  'leads.converted': 'Справу створено',
  'leads.assign': 'Призначити',
  'leads.takeIt': 'Взяти собі',
  'leads.tabOpen': 'Відкриті',
  'leads.history': 'Що відбувалось',
  'leads.h.created': 'Заявка надійшла ({source})',
  'leads.h.assigned': 'Веде: {name}',
  'leads.h.unassigned': 'Відповідального знято',
  'leads.h.responded': 'Перша реакція на заявку (взято в роботу або відповіли)',
  'leads.h.status': 'Статус: {status}',
  'leads.h.converted': 'Створено справу',
  'leads.h.messageIn': 'Повідомлення від клієнта ({channel})',
  'leads.h.messageOut': 'Відповідь клієнту ({channel})',
  'leads.noneOpen': 'Нових заявок немає — усі в роботі або закриті.',
  'leads.received': 'Отримано',
  'leads.markSpam': 'Це спам',
  'leads.markLost': 'Відмова',
  'leads.reopen': 'Повернути в роботу',
  'leads.confirmClose': 'Закрити заявку зі статусом «{status}»?',
  'leads.filterSite': 'Сайт / країна',
  'leads.created': 'Заявку створено',
  'leads.updated': 'Заявку оновлено',

  'leadStatus.new': 'Новий',
  'leadStatus.in_progress': 'В роботі',
  'leadStatus.converted': 'Стала справою',
  'leadStatus.spam': 'Спам',
  'leadStatus.lost': 'Відмова',

  'leadKind.general': 'Загальне',
  'leadKind.repatriation': 'Репатріація',
  'leadKind.funeral': 'Поховання',
  'leadKind.shop': 'Магазин',
  'leadKind.b2b': 'B2B',
  'leadKind.monument': 'Памʼятник',

  'leadSource.form': 'Форма сайту',
  'leadSource.phone': 'Телефон',
  'leadSource.telegram': 'Telegram',
  'leadSource.tgbot': 'Бот VIA DOMUM',
  'leadSource.viber': 'Viber',
  'leadSource.whatsapp': 'WhatsApp',
  'leadSource.site_chat': 'Чат сайту',
  'leadSource.marketplace': 'Маркетплейс',
  'leadSource.partner': 'Партнер',
  'leadSource.manual': 'Вручну',

  // повідомлення
  'inbox.title': 'Повідомлення',
  'inbox.subtitle': 'Telegram, Viber, WhatsApp і чат сайту в одному місці',
  'inbox.conversations': 'Розмови',
  'inbox.selectConversation': 'Оберіть розмову зліва.',
  'inbox.noMessages': 'Повідомлень ще немає.',
  'inbox.reply': 'Відповідь',
  'inbox.replyPlaceholder': 'Напишіть відповідь… (Ctrl+Enter — надіслати)',
  'inbox.send': 'Надіслати',
  'inbox.markRead': 'Позначити прочитаним',
  'inbox.linkCase': 'Привʼязати до справи',
  'inbox.linkedCase': 'Справа',
  'inbox.unlink': 'Відвʼязати',
  'inbox.searchCase': 'Номер або назва справи',
  'inbox.close': 'Закрити розмову',
  'inbox.reopen': 'Відкрити знову',
  'inbox.statusOpen': 'Відкриті',
  'inbox.statusClosed': 'Закриті',
  'inbox.unread': '{n} непрочитаних',
  'inbox.you': 'Ви',
  'inbox.client': 'Клієнт',
  'inbox.attachments': 'Вкладення: {n}',
  'inbox.back': 'До списку розмов',

  'delivery.received': 'отримано',
  'delivery.queued': 'у черзі',
  'delivery.sent': 'надіслано',
  'delivery.failed': 'не доставлено',

  'channel.telegram': 'Telegram',
  'channel.viber': 'Viber',
  'channel.whatsapp': 'WhatsApp',
  'channel.site_chat': 'Чат сайту',
  'channel.email': 'Email',
  'channel.sms': 'SMS',

  // справи
  'cases.title': 'Справи',
  'cases.subtitle': 'Репатріація, поховання, перевезення, памʼятники',
  'cases.new': 'Нова справа',
  'cases.board': 'Канбан',
  'cases.list': 'Список',
  'cases.searchPlaceholder': 'Номер, назва, ПІБ',
  'cases.docs': 'Документи {done} з {total}',
  'cases.docsWaiting': '{n|чекає перевірки|чекають перевірки|чекають перевірки}',
  'cases.move': 'Перемістити',
  'cases.moveTo': 'Перемістити {n} у…',
  'cases.moved': 'Справу переміщено',
  'cases.dropHere': 'Перетягніть сюди',
  'cases.number': '№',
  'cases.route': 'Маршрут',
  'cases.state': 'Етап',
  'cases.deceased': 'Померлий',
  'cases.customer': 'Замовник',
  'cases.priority': 'Пріоритет',
  'cases.scopeSwitched': 'Справа з іншої країни: перемкнули фільтр країни на «{country}», щоб ви її бачили',
  'cases.scopeHidden': 'Справу створено, але фільтр країни «{country}» її ховає — перемкніть країну вгорі',
  'cases.customerMatched': 'Цей телефон чи e-mail уже є в контакті «{name}» — справу привʼязано до нього. Введене імʼя «{entered}» не збережено; за потреби виправте контакт.',
  'cases.customerMatchedSame': 'Замовника знайдено серед наявних контактів («{name}») — справу привʼязано до нього.',
  'cases.created': 'Справу створено',
  'cases.allStates': 'Усі етапи',

  'service.repatriation': 'Репатріація',
  'service.funeral': 'Поховання',
  'service.transport': 'Перевезення',
  'service.monument': "Пам'ятники",
  'service.product_only': 'Лише товари',

  'priority.low': 'Низький',
  'priority.normal': 'Звичайний',
  'priority.high': 'Високий',
  'priority.urgent': 'Терміново',

  // картка справи
  'case.stages': 'Етапи',
  'case.now': 'зараз',
  'case.done': 'завершено',
  'case.transitions': 'Переходи',
  'case.nextStep': 'Наступний крок',
  'case.transitionNote': 'Коментар до переходу',
  'case.noTransitions': 'Немає доступних переходів.',
  'case.blocked': 'Заблоковано',
  'case.transitioned': 'Етап змінено',
  'case.checklist': 'Потрібні документи',
  'case.checklistHint': 'Документ готовий, коли його завантажили і перевірили (кнопка «Прийняти»). Без цього справа не перейде на наступний етап.',
  'case.docsSummary': 'перевірено {done} з {total}',
  'case.docsSummarySkipped': 'готово {done} з {total}: перевірено {accepted}, не потрібні {skipped}',
  'case.skipRequired': 'Пропустити…',
  'case.skipReason': 'Чому документ «{name}» не потрібен у цій справі? Причина зʼявиться в хронології.',
  'case.skipReasonOptional': 'Документ «{name}» не потрібен у цій справі? Напишіть чому (необовʼязково) — причина зʼявиться в хронології.',
  'case.tab.overview': 'Огляд',
  'case.tab.plan': 'План справи',
  'case.tab.docs': 'Документи',
  'case.tab.money': 'Гроші',
  'case.tab.history': 'Історія',
  'case.tab.info': 'Дані',
  'case.edit': 'Змінити',
  'case.print': 'Зведення PDF',
  'case.editTitle': 'Пріоритет і відповідальний',
  'case.whatNext': 'Що далі',
  'case.goTo': 'Перейти: {name}',
  'case.needDocsFor': 'Щоб перейти до етапу «{name}», потрібно отримати й перевірити документи:',
  'case.needDocsN': 'Бракує {n|документа|документів|документів}',
  'case.waitingCheck': 'Чекають перевірки: {n}',
  'case.allDocsReady': 'Усі потрібні документи перевірені.',
  'case.allDocsReadySkipped': 'Документи закрито: перевірено {accepted}, позначено «не потрібен» — {skipped}.',
  'case.lastStage': 'Справа на останньому етапі.',
  'case.cancelCase': 'Скасувати справу',
  'case.cancelConfirm': 'Скасувати справу {n}? Її можна буде знайти у фільтрі «Скасовано».',
  'case.tile.docs': 'Документи',
  'case.tile.plan': 'План справи',
  'case.tile.money': 'Замовлення',
  'case.tile.docsValue': '{done} з {total}',
  'case.tile.docsSkipped': 'з них не потрібні: {n}',
  'case.tile.planValue': '{done} з {total} кроків',
  'case.tile.noPlan': 'Ще не складено',
  'case.tile.noOrder': 'Ще немає',
  'case.tile.open': 'Відкрити',
  'case.tile.ritual': 'Ритуальні послуги',
  'case.tile.ritualNone': 'Можливості ще немає',
  'case.tile.ritualCreate': 'Створити можливість',
  'case.required': 'обовʼязковий',
  'case.sensitive': 'особливі дані',
  'case.responsible': 'Відповідає',
  'case.accept': 'Прийняти',
  'case.contractSigned': 'Договір підписано',
  'case.contractGeneratedConfirm': 'Це згенерований CRM шаблон договору, а не підписаний скан: у ньому немає підписів і можуть бути незаповнені реквізити. Краще завантажте скан, підписаний клієнтом. Позначити договір підписаним усе одно (наприклад, клієнт підписав паперовий примірник)? Справа перейде в простір «Справи».',
  'error.generated_contract': 'Це згенерований шаблон договору, а не підписаний скан. Завантажте договір, підписаний клієнтом, або позначте «Договір підписано» у чеклісті справи з підтвердженням.',
  'case.contractSignedConfirm': 'Підтвердіть: завантажений файл — це договір, підписаний клієнтом, і реквізити в ньому заповнені. Після цього справа перейде в простір «Справи».',
  'case.reject': 'Відхилити',
  'case.notNeeded': 'Не потрібен',
  'case.reset': 'Скинути',
  'case.documents': 'Документи',
  'case.noDocuments': 'Документів ще немає.',
  'case.upload': 'Завантажити',
  'case.uploadFor': 'Додати файл: {name}',
  'case.uploadOther': 'Завантажити інший документ',
  'case.uploaded': 'Файл завантажено',
  'case.generate': 'Згенерувати',
  'case.generated': 'Документ згенеровано',
  'case.timeline': 'Хронологія',
  'case.noEvents': 'Подій ще немає.',
  'case.clientVisible': 'бачить клієнт',
  'case.comments': 'Коментарі',
  'case.commentPlaceholder': 'Коментар для команди…',
  'case.addComment': 'Додати коментар',
  'case.noComments': 'Коментарів ще немає.',
  'case.tasks': 'Задачі',
  'case.taskTitle': 'Нова задача',
  'case.taskDue': 'Термін',
  'case.noTasks': 'Задач немає.',
  'case.contacts': 'Контакти',
  'case.addContact': 'Додати контакт',
  'case.contactRole': 'Роль',
  'case.noContacts': 'Контактів немає.',
  'case.invite': 'Запросити в кабінет',
  'case.inviteSms': 'SMS',
  'case.inviteEmail': 'Email',
  'case.invited': 'Запрошення надіслано',
  'case.deceased': 'Дані померлого',
  'case.birthDate': 'Дата народження',
  'case.deathAt': 'Дата і час смерті',
  'case.deathTz': 'Часовий пояс',
  'case.deathPlace': 'Місце смерті',
  'case.deathCountry': 'Країна смерті',
  'case.citizenship': 'Громадянство',
  'case.medical': 'Медичні дані',
  'case.medicalHint': 'конфіденційно · лише власник і менеджер',
  'case.cause': 'Причина смерті',
  'case.infectious': 'Інфекційне захворювання',
  'case.embalmed': 'Бальзамування проведено',
  'case.orders': 'Замовлення',
  'case.noOrders': 'Замовлень немає.',
  'case.newOrder': 'Нове замовлення',
  'case.details': 'Основне',
  'case.tags': 'Теги',
  'case.tagsHint': 'через кому',
  'case.opened': 'Відкрито',

  'checklist.missing': 'очікується',
  'checklist.uploaded': 'завантажено',
  'checklist.accepted': 'прийнято',
  'checklist.rejected': 'відхилено',
  'checklist.not_needed': 'не потрібен',

  'checklistLong.missing': 'Ще не отримано',
  'checklistLong.uploaded': 'Завантажено — перевірте і прийміть',
  'checklistLong.accepted': 'Перевірено',
  'checklistLong.rejected': 'Відхилено — потрібен інший файл',
  'checklistLong.not_needed': 'Не потрібен',

  'responsible.client': 'клієнт',
  'responsible.us': 'ми',
  'responsible.partner': 'партнер',

  'contactRole.customer': 'Замовник',
  'contactRole.relative': 'Родич',
  'contactRole.payer': 'Платник',
  'contactRole.attorney': 'Довірена особа',

  'docStatus.pending': 'очікує файл',
  'docStatus.uploaded': 'завантажено',
  'docStatus.rejected': 'відхилено',

  'template.contract': 'Договір',
  'template.invoice': 'Рахунок',
  'template.act': 'Акт',

  // товари
  'products.title': 'Товари',
  'products.subtitle': 'Каталог: труни, урни, памʼятники, послуги',
  'products.add': 'Додати товар',
  'products.searchPlaceholder': 'Пошук за назвою або артикулом',
  'products.category': 'Категорія',
  'products.stock': 'Залишок',
  'products.low': 'мало',
  'products.selected': 'Вибрано',
  'products.publish': 'Опублікувати',
  'products.hide': 'Приховати',
  'products.toDraft': 'У чернетки',
  'products.clearSelection': 'Скасувати вибір',
  'products.selectAll': 'Вибрати все',
  'products.select': 'Вибрати {name}',
  'products.bulkDone': 'Статус змінено: {n}',
  'products.variants': '{n} варіант(ів)',

  'productStatus.draft': 'Чернетка',
  'productStatus.published': 'Опубліковано',
  'productStatus.hidden': 'Прихований',
  'productStatus.tab.published': 'Опубліковані',
  'productStatus.tab.draft': 'Чернетки',
  'productStatus.tab.hidden': 'Приховані',

  'productKind.stock': 'Складський',
  'productKind.made_to_order': 'Під замовлення',
  'productKind.configurable': 'Конфігурований',
  'productKind.service': 'Послуга',

  // редактор товару
  'edit.crumb': 'Редагування',
  'edit.newTitle': 'Новий товар',
  'edit.main': 'Основне',
  'edit.translations': 'Переклади',
  'edit.translationsHint': 'назва, slug і опис для кожної мови',
  'edit.nameField': 'Назва',
  'edit.slug': 'Slug (адреса сторінки)',
  'edit.description': 'Опис',
  'edit.kind': 'Тип',
  'edit.noTranslation': 'немає перекладу',
  'edit.leadTime': 'Строк виготовлення, днів',
  'edit.variants': 'Варіанти',
  'edit.variantsHint': 'Артикул і ціна в гривнях',
  'edit.sku': 'Артикул',
  'edit.variantAttrs': 'Атрибути (напр. колір=білий)',
  'edit.variantAttrsPlaceholder': 'color=білий; size=190',
  'edit.priceField': 'Ціна',
  'edit.compareAt': 'Стара ціна',
  'edit.cost': 'Собівартість',
  'edit.weight': 'Вага, г',
  'edit.hsCode': 'Код УКТЗЕД',
  'edit.addVariant': 'Додати варіант',
  'edit.removeVariant': 'Прибрати варіант {n}',
  'edit.specs': 'Характеристики',
  'edit.specsHint': 'таблиця на сторінці товару',
  'edit.specLabel': 'Назва характеристики',
  'edit.specValue': 'Значення',
  'edit.addSpec': 'Додати рядок',
  'edit.removeSpec': 'Прибрати рядок',
  'edit.attributes': 'Атрибути для фільтрів',
  'edit.attributesHint': 'ключ=значення, з нового рядка',
  'edit.photos': 'Фото',
  'edit.photosHint': 'PNG/JPG, 4:5',
  'edit.addPhoto': 'Додати фото',
  'edit.removePhoto': 'Прибрати фото',
  'edit.makeMain': 'Зробити головним',
  'edit.publication': 'Публікація',
  'edit.preview': 'Картка в каталозі',
  'edit.previewHint': 'попередній перегляд',
  'edit.more': 'детальніше',
  'edit.created': 'Товар створено',
  'edit.deleteProduct': 'Видалити товар',
  'edit.deleted': 'Товар видалено',
  'edit.nameRequired': 'Вкажіть назву українською.',
  'edit.skuRequired': 'Вкажіть артикул для кожного варіанта.',

  // склад
  'inv.title': 'Склад',
  'inv.subtitle': 'Залишки за локаціями, надходження і переміщення',
  'inv.location': 'Склад',
  'inv.allLocations': 'Усі локації',
  'inv.lowOnly': 'Лише мало на складі',
  'inv.product': 'Товар',
  'inv.onHand': 'Фізично',
  'inv.reserved': 'Резерв',
  'inv.available': 'Доступно',
  'inv.receipt': 'Надходження',
  'inv.adjustment': 'Коригування',
  'inv.transfer': 'Переміщення',
  'inv.movements': 'Історія рухів',
  'inv.variant': 'Товар (назва або артикул)',
  'inv.qtySigned': 'Кількість (± для коригування)',
  'inv.fromLocation': 'Звідки',
  'inv.toLocation': 'Куди',
  'inv.done': 'Рух записано',
  'inv.kind': 'Тип руху',
  'inv.selectVariant': 'Оберіть товар (артикул)',
  'inv.searchVariant': 'Почніть вводити назву або артикул',
  'inv.movementsFor': 'Рухи по {sku}',
  'inv.showMovements': 'Історія',
  'inv.newLocation': 'Нова локація',
  'inv.city': 'Місто',
  'inv.address': 'Адреса',

  'move.receipt': 'Надходження',
  'move.sale': 'Продаж',
  'move.adjustment': 'Коригування',
  'move.transfer_in': 'Переміщення (прихід)',
  'move.transfer_out': 'Переміщення (витрата)',
  'move.return': 'Повернення',

  // замовлення
  'orders.title': 'Замовлення',
  'orders.subtitle': 'Сайт, Prom, телефон, B2B',
  'orders.new': 'Нове замовлення',
  'orders.step.items': 'Товари',
  'orders.step.buyer': 'Покупець',
  'orders.step.delivery': 'Доставка',
  'orders.stepN': 'Крок {n} з 3',
  'orders.next': 'Далі',
  'orders.back': 'Назад',
  'orders.summary': 'Підсумок',
  'orders.positions': '{n|позиція|позиції|позицій}',
  'orders.pickupHint': 'Покупець забере сам — адреса не потрібна.',
  'orders.buyerNeeded': 'Вкажіть імʼя або телефон покупця, або оберіть B2B-клієнта.',
  'orders.number': '№',
  'orders.channel': 'Звідки замовлення',
  'orders.buyer': 'Покупець',
  'orders.items': 'Позицій',
  'orders.sum': 'Сума',
  'orders.delivery': 'Доставка',
  'orders.searchPlaceholder': 'Номер, покупець, ТТН',
  'orders.confirm': 'Підтвердити',
  'orders.ship': 'Відвантажити',
  'orders.complete': 'Завершити',
  'orders.cancel': 'Скасувати замовлення',
  'orders.cancelConfirm': 'Скасувати замовлення і зняти резерв?',
  'orders.invoice': 'Рахунок PDF',
  'orders.tracking': 'ТТН',
  'orders.shipTitle': 'Відвантаження',
  'orders.case': 'Справа',
  'orders.basePrice': 'Базова',
  'orders.discount': 'Знижка',
  'orders.trace': 'Як розраховано',
  'orders.updated': 'Замовлення оновлено',
  'orders.created': 'Замовлення створено',
  'orders.buyerSection': 'Покупець',
  'orders.buyerKind': 'Тип покупця',
  'orders.buyerPerson': 'Фізична особа',
  'orders.buyerB2B': 'B2B-клієнт',
  'orders.b2bAccount': 'B2B-акаунт',
  'orders.itemsSection': 'Товари',
  'orders.addItem': 'Додати позицію',
  'orders.addService': 'Додати послугу',
  'orders.serviceTitle': 'Назва послуги',
  'orders.unitPrice': 'Ціна за од.',
  'orders.lineTotal': 'Сума',
  'orders.quoting': 'розрахунок…',
  'orders.quoteFailed': 'ціну не розраховано',
  'orders.deliverySection': 'Доставка',
  'orders.city': 'Місто',
  'orders.branch': 'Відділення / поштомат',
  'orders.carrier': 'Перевізник',
  'orders.recipient': 'Отримувач',
  'orders.recipientPhone': 'Телефон отримувача',
  'orders.externalId': 'Номер замовлення на маркетплейсі',
  'orders.noItems': 'Додайте хоча б одну позицію.',
  'orders.removeItem': 'Прибрати позицію',
  'orders.estimate': 'Орієнтовно',
  'orders.serverPricesHint': 'Ціни підставляються з прайсу каналу; знижки покупця врахуються при створенні.',

  'orderStatus.draft': 'Чернетка',
  'orderStatus.confirmed': 'Підтверджено',
  'orderStatus.shipped': 'Відвантажено',
  'orderStatus.completed': 'Завершено',
  'orderStatus.cancelled': 'Скасовано',

  'channelKind.own_site': 'Власний сайт',
  'channelKind.b2b': 'B2B',
  'channelKind.phone': 'Телефон',
  'channelKind.prom': 'Prom.ua',
  'channelKind.rozetka': 'Rozetka',
  'channelKind.epicentr': 'Епіцентр',
  'channelKind.olx': 'OLX',
  'channelKind.etsy': 'Etsy',
  'channelKind.amazon': 'Amazon',
  'channelKind.ebay': 'eBay',
  'channelKind.allegro': 'Allegro',
  'channelKind.other': 'Інше',

  // b2b
  'b2b.title': 'Оптові клієнти (B2B)',
  'b2b.pick': 'Оберіть клієнта зі списку, щоб побачити баланс і замовлення.',
  'b2b.empty': 'Оптових клієнтів ще немає. Додайте ритуальну агенцію кнопкою «+» — для неї можна задати кредитний ліміт, відстрочку оплати і свій прайс.',
  'b2b.subtitle': 'Ритуальні агенції: ліміти, відстрочка, прайси',
  'b2b.new': 'Новий акаунт',
  'b2b.buyer': 'Компанія',
  'b2b.taxId': 'ЄДРПОУ / VAT',
  'b2b.creditLimit': 'Кредитний ліміт',
  'b2b.terms': 'Відстрочка, днів',
  'b2b.minOrder': 'Мінімальне замовлення',
  'b2b.priceList': 'Прайс-лист',
  'b2b.group': 'Група клієнтів',
  'b2b.balance': 'Баланс',
  'b2b.openOrders': 'Відкриті замовлення',
  'b2b.available': 'Доступно',
  'b2b.orders': 'Замовлення акаунта',
  'b2b.saved': 'Акаунт збережено',
  'b2b.editTitle': 'B2B-акаунт',
  'b2b.newGroup': 'Нова група',

  'b2bStatus.lead': 'Потенційний',
  'b2bStatus.active': 'Активний',
  'b2bStatus.paused': 'Призупинено',

  // ціни
  'pricing.title': 'Ціни',
  'pricing.subtitle': 'Прайс-листи, правила знижок, курси НБУ і націнки',
  'pricing.lists': 'Прайс-листи',
  'pricing.newList': 'Новий прайс-лист',
  'pricing.listKind': 'Тип',
  'pricing.default': 'за замовчуванням',
  'pricing.items': 'Позиції прайсу',
  'pricing.minQty': 'Від, шт.',
  'pricing.amount': 'Ціна',
  'pricing.addItem': 'Додати позицію',
  'pricing.itemsSaved': 'Прайс збережено',
  'pricing.rules': 'Правила',
  'pricing.newRule': 'Нове правило',
  'pricing.scope': 'Застосування',
  'pricing.ruleKind': 'Тип правила',
  'pricing.percentOff': 'Знижка, %',
  'pricing.priorityField': 'Пріоритет',
  'pricing.tiers': 'Пороги (кількість:знижка%, через кому)',
  'pricing.fx': 'Курси валют',
  'pricing.fxDate': 'Курс на',
  'pricing.refresh': 'Оновити з НБУ',
  'pricing.refreshed': 'Курси оновлено',
  'pricing.rate': 'Курс',
  'pricing.markup': 'Націнка, %',
  'pricing.rounding': 'Округлення (мін. од.)',
  'pricing.enabled': 'Увімкнено',
  'pricing.fxSettings': 'Валюти і націнки',
  'pricing.fxSaved': 'Налаштування валют збережено',
  'pricing.addCurrency': 'Додати валюту',
  'pricing.selectList': 'Оберіть прайс-лист, щоб редагувати позиції.',
  'pricing.ruleSaved': 'Правило збережено',
  'pricing.ruleDeleted': 'Правило видалено',

  'listKind.retail': 'Роздріб',
  'listKind.b2b': 'B2B',
  'listKind.channel': 'Канал',
  'scope.all': 'Усім',
  'scope.org': 'Компанії',
  'scope.group': 'Групі',
  'scope.channel': 'Каналу',
  'ruleKind.price_list': 'Прайс-лист',
  'ruleKind.percent_off': 'Знижка %',
  'ruleKind.qty_tier': 'Знижка від кількості',

  // канали
  'channels.title': 'Канали продажу',
  'channels.subtitle': 'Маркетплейси, посилання на товари, запас на складі',
  'channels.feed': 'Посилання на товари для Prom',
  'channels.feedInactive': 'Канал вимкнено — посилання не працює',
  'channels.feedUnsupported': 'Для цього маркетплейсу вивантаження ще немає',
  'channels.copyFeed': 'Скопіювати посилання',
  'channels.rotate': 'Новий токен',
  'channels.rotateConfirm': 'Старе посилання на товари перестане працювати. Продовжити?',
  'channels.rotated': 'Посилання оновлено',
  'channels.buffer': 'Запас, який не показуємо на сайті',
  'channels.bufferMarketplace': 'Запас, який не показуємо на маркетплейсі',
  'channels.bufferHint': 'скільки одиниць не показувати каналу',
  'channels.priceList': 'Прайс каналу',
  'channels.saved': 'Канал збережено',
  'channels.noFeed': 'Фід не налаштовано',

  // налаштування
  'settings.title': 'Користувачі і доступ',
  'settings.subtitle': 'Хто працює в CRM і що бачить, які сайти підключені, журнал дій. Зміни і чергування — у «Плануванні».',
  'settings.subtitleSelf': 'Ваші імʼя і телефон, пароль і вхід із кодом.',
  'settings.subtitleSelfAudit': 'Ваші імʼя і телефон, пароль і вхід із кодом, журнал змін.',
  'settings.users': 'Користувачі',
  'settings.sites': 'Сайти',
  'settings.duty': 'Чергування',
  'settings.confirmRole': 'Змінити роль «{name}» на «{role}»? Від ролі залежить, що людина бачить у CRM.',
  'settings.company': 'Реквізити компанії',
  'settings.companyFilled': 'заповнено',
  'settings.companyMissing': 'не заповнено',
  'settings.companyFill': 'Заповнити',
  'settings.companyOpen': 'Переглянути',
  'settings.confirmCountries': 'Змінити країни доступу для «{name}»?',
  'settings.confirmSuspend': 'Призупинити доступ для «{name}»? Людина не зможе увійти, поки доступ не відновлять.',
  'settings.audit': 'Журнал дій',
  'settings.security': 'Безпека',
  'settings.newUser': 'Новий користувач',
  'settings.password': 'Тимчасовий пароль',
  'settings.role': 'Роль',
  'settings.suspend': 'Призупинити',
  'settings.activate': 'Активувати',
  'settings.userCreated': 'Користувача створено',
  'settings.membershipSaved': 'Доступ оновлено',
  'settings.memberStatus.active': 'активний',
  'settings.memberStatus.suspended': 'призупинено',
  'settings.ownerOnly': 'Доступно лише власнику.',
  'settings.domain': 'Домен',
  'settings.siteKind': 'Тип',
  'settings.locales': 'Мови',
  'settings.defaultLocale': 'Мова за замовчуванням',
  'settings.defaultCurrency': 'Валюта',
  'settings.dutyPhone': 'Черговий телефон',
  'settings.siteSaved': 'Сайт збережено',
  'settings.shiftNew': 'Нове чергування',
  'settings.shiftStart': 'Початок',
  'settings.shiftEnd': 'Кінець',
  'settings.shiftLocales': 'Мови (через кому)',
  'settings.telegramChat': 'Номер чату в Telegram (куди надсилати заявки)',
  'settings.onDutyNow': 'Зараз на зміні',
  'settings.nobodyOnDuty': 'Зараз ніхто не на зміні.',
  'settings.shiftCreated': 'Зміну додано',
  'settings.shiftDeleted': 'Зміну видалено',
  'settings.week': 'Тиждень',
  'settings.prevWeek': 'Попередній тиждень',
  'settings.nextWeek': 'Наступний тиждень',
  'settings.auditTable': 'Обʼєкт',
  'settings.auditAction': 'Дія',
  'settings.auditActor': 'Хто',
  'settings.auditRow': 'Запис',
  'settings.auditChanges': 'Зміни',
  'settings.auditRowFilter': 'Показано історію одного запису',
  'settings.auditRowReset': 'Показати всі',
  'settings.auditRowOnly': 'Показати лише історію цього запису',
  // журнал дій: назви таблиць і полів для людей
  'audit.action.insert': 'Створено',
  'audit.action.update': 'Змінено',
  'audit.action.delete': 'Видалено',
  'audit.table.other': 'Інше',
  'audit.table.cases': 'Справа',
  'audit.table.orders': 'Замовлення',
  'audit.table.order_items': 'Позиція замовлення',
  'audit.table.case_contacts': 'Контакт справи',
  'audit.table.capacity_offers': 'Вільні місця партнера',
  'audit.table.contacts': 'Контакт',
  'audit.table.contact_identities': 'Контактні дані',
  'audit.table.documents': 'Документ',
  'audit.table.trips': 'Рейс',
  'audit.table.trip_stops': 'Зупинка рейсу',
  'audit.table.trip_loads': 'Вантаж у рейсі',
  'audit.table.vehicles': 'Машина',
  'audit.table.vehicle_types': 'Тип машини',
  'audit.table.users': 'Користувач',
  'audit.table.memberships': 'Доступ користувача',
  'audit.table.leads': 'Звернення',
  'audit.table.deceased': 'Померлий',
  'audit.table.deceased_medical': 'Медичні дані',
  'audit.table.shipments': 'Перевезення',
  'audit.table.products': 'Товар',
  'audit.table.product_variants': 'Варіант товару',
  'audit.table.attribute_defs': 'Властивість товару',
  'audit.table.attribute_options': 'Значення властивості',
  'audit.table.price_list_items': 'Ціна в прайсі',
  'audit.table.pricing_rules': 'Правило ціни',
  'audit.table.sales_channels': 'Канал продажу',
  'audit.table.collections': 'Колекція',
  'audit.table.b2b_accounts': 'B2B-партнер',
  'audit.table.legal_entities': 'Реквізити компанії',
  'audit.table.currency_settings': 'Валюта',
  'audit.table.absences': 'Відсутність',
  'audit.table.work_shifts': 'Зміна',
  'audit.table.shift_templates': 'Шаблон зміни',
  'audit.table.block_types': 'Тип кроку плану',
  'audit.table.block_requirements': 'Вимога кроку плану',
  'audit.table.case_blocks': 'Крок плану справи',
  'audit.table.case_block_items': 'Пункт кроку плану',
  'audit.table.case_block_parties': 'Учасник кроку плану',
  'audit.table.template_blocks': 'Крок шаблону',
  'audit.table.pipeline_templates': 'Шаблон справи',
  'audit.table.production_orders': 'Замовлення на виробництво',
  'audit.table.production_order_lines': 'Позиція виробництва',
  'audit.field.amount': 'сума',
  'audit.field.status': 'статус',
  'audit.field.title': 'назва',
  'audit.field.name': 'назва',
  'audit.field.kind': 'вид',
  'audit.field.qty': 'кількість',
  'audit.field.position': 'порядок',
  'audit.field.number': 'номер',
  'audit.field.note': 'примітка',
  'audit.field.notes': 'примітка',
  'audit.field.state_key': 'етап',
  'audit.field.assignee_id': 'відповідальний',
  'audit.field.assigned_to': 'відповідальний',
  'audit.field.origin_country': 'країна відправлення',
  'audit.field.dest_country': 'країна призначення',
  'audit.field.transit_country': 'транзит',
  'audit.field.country': 'країна',
  'audit.field.full_name': 'ПІБ',
  'audit.field.role': 'роль',
  'audit.field.priority': 'пріоритет',
  'audit.field.currency': 'валюта',
  'audit.field.cost_currency': 'валюта собівартості',
  'audit.field.closed_at': 'закрито',
  'audit.field.confirmed_at': 'підтверджено',
  'audit.field.shipped_at': 'відвантажено',
  'audit.field.opened_at': 'відкрито',
  'audit.field.deleted_at': 'видалено',
  'audit.field.archived_at': 'архів',
  'audit.field.file_name': 'файл',
  'audit.field.size': 'розмір файлу',
  'audit.field.valid_until': 'дійсний до',
  'audit.field.valid_from': 'дійсний з',
  'audit.field.expires_at': 'діє до',
  'audit.field.delivery': 'доставка',
  'audit.field.email': 'e-mail',
  'audit.field.places': 'місця',
  'audit.field.plate': 'номер машини',
  'audit.field.model': 'модель',
  'audit.field.vin': 'номер кузова',
  'audit.field.sku': 'артикул',
  'audit.field.is_active': 'активність',
  'audit.field.starts_at': 'початок',
  'audit.field.ends_at': 'кінець',
  'audit.field.starts_on': 'початок',
  'audit.field.ends_on': 'кінець',
  'audit.field.required': 'обовʼязковість',
  'audit.field.responsible': 'хто відповідає',
  'audit.field.cargo_type': 'вантаж',
  'audit.field.transport_mode': 'транспорт',
  'audit.field.death_place': 'місце смерті',
  'audit.field.death_country': 'країна смерті',
  'audit.field.death_at': 'дата смерті',
  'audit.field.birth_date': 'дата народження',
  'audit.field.citizenship': 'громадянство',
  'audit.field.driver_id': 'водій',
  'audit.field.default_driver_id': 'водій',
  'audit.field.vehicle_id': 'машина',
  'audit.field.vehicle_type_id': 'тип машини',
  'audit.field.trip_id': 'рейс',
  'audit.field.case_id': 'справа',
  'audit.field.order_id': 'замовлення',
  'audit.field.contact_id': 'контакт',
  'audit.field.buyer_contact_id': 'покупець',
  'audit.field.document_type_id': 'тип документа',
  'audit.field.variant_id': 'товар',
  'audit.field.product_id': 'товар',
  'audit.field.channel_id': 'канал продажу',
  'audit.field.price_list_id': 'прайс',
  'audit.field.location_id': 'склад',
  'audit.field.from_location_id': 'склад-джерело',
  'audit.field.to_location_id': 'склад призначення',
  'audit.field.attributes': 'властивості',
  'audit.field.images': 'фото',
  'audit.field.key': 'код',
  'audit.field.decided_at': 'рішення',
  'audit.field.decided_by': 'хто вирішив',
  'audit.field.decision_note': 'коментар до рішення',
  'audit.field.countries': 'країни',
  'audit.field.iban': 'IBAN',
  'audit.field.tax_id': 'код ІПН/ЄДРПОУ',
  'audit.field.bank': 'банк',
  'audit.field.address': 'адреса',
  'audit.field.vat_payer': 'платник ПДВ',
  'audit.field.stock_buffer': 'запас',
  'audit.field.totp_required': 'двоетапний вхід',
  'audit.field.message': 'повідомлення',
  'audit.field.eta_plan': 'прибуття (план)',
  'audit.field.etd_plan': 'відправлення (план)',
  'audit.field.eta_fact': 'прибуття (факт)',
  'audit.field.etd_fact': 'відправлення (факт)',
  'audit.field.from_place': 'звідки',
  'audit.field.to_place': 'куди',
  'audit.field.route_from': 'звідки',
  'audit.field.route_to': 'куди',
  'audit.field.date_from': 'дата з',
  'audit.field.date_to': 'дата до',
  'audit.field.place': 'місце',
  'audit.field.seq': 'порядок',
  'audit.field.window_from': 'вікно з',
  'audit.field.window_to': 'вікно до',
  'audit.field.lead_time_days': 'термін виготовлення',
  'audit.field.weight_g': 'вага',
  'audit.field.dims_mm': 'розміри',
  'audit.field.hs_code': 'код УКТЗЕД',
  'audit.field.source': 'джерело',
  'audit.field.locale': 'мова',
  'audit.field.sla_due_at': 'відповісти до',
  'audit.field.first_response_at': 'перша відповідь',
  'audit.field.lead_id': 'звернення',
  'audit.field.deceased_id': 'померлий',
  'audit.field.service_type_id': 'послуга',
  'audit.field.user_id': 'користувач',
  'audit.field.owner_id': 'власник',
  'audit.field.consent_processing_at': 'згода на обробку даних',
  'audit.field.consent_marketing_at': 'згода на розсилку',
  'audit.field.anonymized_at': 'знеособлено',
  'audit.field.merged_into_id': 'обʼєднано з',
  'audit.field.is_excluded': 'виключено',
  'audit.field.nuance': 'нюанс',
  'audit.field.cremation': 'кремація',
  'audit.field.discount': 'знижка',
  'audit.field.shipment_id': 'перевезення',
  'audit.field.block_type_id': 'тип кроку',
  'audit.field.template_block_id': 'крок шаблону',
  'audit.field.case_block_id': 'крок плану',
  'audit.field.template_id': 'шаблон',
  'audit.field.category_id': 'категорія',
  'audit.field.category_ids': 'категорії',
  'audit.field.specs': 'характеристики',
  'audit.field.min_qty': 'мінімальна кількість',
  'audit.field.swatch': 'колір',
  'audit.field.def_id': 'властивість',
  'audit.field.is_filter': 'фільтр на сайті',
  'audit.field.is_variant_axis': 'варіанти товару',
  'audit.field.ownership': 'власність',
  'audit.field.lease_company': 'лізингова компанія',
  'audit.field.lease_contract_no': 'договір лізингу',
  'audit.field.lease_start': 'початок лізингу',
  'audit.field.lease_end': 'кінець лізингу',
  'audit.field.lease_currency': 'валюта лізингу',
  'audit.field.base_city': 'місто бази',
  'audit.field.seats': 'місця',
  'audit.field.payload_kg': 'вантажопідйомність',
  'audit.field.body_type': 'тип кузова',
  'audit.field.allowed_cargo': 'дозволені вантажі',
  'audit.field.unit': 'одиниця',
  'audit.field.tax_mode': 'податки',
  'audit.field.fiscalize': 'фіскалізація',
  'audit.field.feed_token': 'посилання на товари',
  'audit.field.is_enabled': 'увімкнено',
  'audit.field.weekdays': 'дні тижня',
  'audit.field.start_time': 'початок',
  'audit.field.end_time': 'кінець',
  'audit.field.markup_pct': 'націнка',
  'audit.field.rounding_minor': 'округлення',
  'audit.field.customer_group_id': 'група клієнтів',
  'audit.field.credit_limit': 'кредитний ліміт',
  'audit.field.due_days': 'відстрочка',
  'audit.field.percent_off': 'знижка',
  'audit.field.payment_terms_days': 'відстрочка оплати',
  'audit.field.manager_id': 'менеджер',
  'audit.field.launch_date': 'дата запуску',
  'audit.field.is_seller': 'продавець',
  'audit.field.scope': 'область дії',
  'audit.field.tiers': 'рівні',
  'audit.field.supplier_org_id': 'постачальник',
  'audit.field.carrier_org_id': 'перевізник',
  'audit.field.buyer_org_id': 'покупець',
  'audit.field.owner_org_id': 'партнер',
  'audit.field.seller_legal_entity_id': 'продавець',
  'audit.field.external_order_id': 'зовнішній номер',
  'audit.field.reminded_at': 'нагадування',
  'audit.field.sla_notified_at': 'сповіщення про термін',
  'audit.field.uploaded_by': 'хто завантажив',
  'audit.field.requested_by': 'хто попросив',
  'audit.field.expected_at': 'очікується',
  'audit.field.production_order_id': 'замовлення на виробництво',
  'audit.field.toggle_key': 'перемикач',
  'audit.field.optional': 'необовʼязковий',
  'audit.field.req_kind': 'вид вимоги',
  'audit.field.ref_key': 'вимога',
  'audit.field.when_flags': 'умови',
  'audit.field.prefs': 'налаштування',
  'audit.field.story': 'опис',
  'audit.field.illustration': 'ілюстрація',
  'audit.otherFields': 'ще {n|поле|поля|полів}',
  'settings.totp': 'Двофакторна автентифікація',
  'settings.totpOn': 'Увімкнено',
  'settings.totpOff': 'Вимкнено',
  'settings.totpSetup': 'Налаштувати 2FA',
  'settings.totpSecret': 'Секрет (додайте в застосунок)',
  'settings.totpCode': 'Код з застосунку',
  'settings.totpEnable': 'Увімкнути',
  'settings.totpEnabled': '2FA увімкнено',

  'siteKind.shop': 'Магазин',
  'siteKind.repatriation': 'Репатріація',
  'siteKind.main': 'Головний',


  // події справи
  'event.case_created': 'Справу створено',
  'event.case_updated': 'Справу оновлено',
  'event.state_changed': 'Зміна етапу',
  'event.assigned': 'Призначено відповідального',
  'event.checklist_updated': 'Документ перевірено',
  'event.client_invited': 'Клієнта запрошено в кабінет',
  'event.comment_added': 'Коментар',
  'event.contact_added': 'Додано контакт',
  'event.deceased_updated': 'Оновлено дані померлого',
  'event.document_deleted': 'Документ видалено',
  'event.document_generated': 'Документ згенеровано',
  'event.document_uploaded': 'Документ завантажено',
  'event.medical_updated': 'Оновлено медичні дані',
  'event.message_received': 'Повідомлення від клієнта',
  'event.message_sent': 'Повідомлення клієнту',
  'event.order_cancelled': 'Замовлення скасовано',
  'event.order_completed': 'Замовлення завершено',
  'event.order_confirmed': 'Замовлення підтверджено',
  'event.order_created': 'Створено замовлення',
  'event.order_shipped': 'Замовлення відвантажено',
  'event.tags_changed': 'Змінено теги',
  'event.task_created': 'Нова задача',
  'event.task_done': 'Задачу виконано',
  'event.task_reopened': 'Задачу повернуто в роботу',
  'event.pipeline_applied': 'Застосовано план справи',
  'event.shipment_created': 'Створено перевезення',
  'event.trip_booked': 'Заброньовано місце в рейсі',
  'event.trip': 'рейс',
  'event.order_created_n': 'Створено замовлення {number}',
  'event.order_confirmed_n': 'Замовлення {number} підтверджено',
  'event.order_cancelled_n': 'Замовлення {number} скасовано',
  'event.order_completed_n': 'Замовлення {number} завершено',
  'event.order_shipped_n': 'Замовлення {number} відвантажено',
  'event.reason': 'причина: {reason}',

  'carrier.nova_poshta': 'Нова Пошта',
  'carrier.ukrposhta': 'Укрпошта',
  'carrier.meest': 'Meest',
  'carrier.own': 'Власна доставка',
  'carrier.pickup': 'Самовивіз',

  'locale.uk': 'Українська',
  'locale.en': 'English',
  'locale.pl': 'Polski',
  'locale.ro': 'Română',

  'common.system': 'система',
  'common.kb': '{n} КБ',
  'common.uah': 'грн',

  // час
  'time.min': '{n} хв',
  'time.hour': '{n} год',
  'time.hourMin': '{h} год {m} хв',
  'time.day': '{n} д',
  'time.justNow': 'щойно',
  'time.ago': '{t} тому',
  'time.today': 'сьогодні',
  'time.yesterday': 'вчора',

  // --- B4 logistics
  'trip.start': 'Виїхав',
  'trip.arrived': 'Прибув',
  'trip.arrivedDone': 'Прибуття відмічено',
  'trip.arrivedAt': 'прибув {t}',
  'trip.leftAt': 'виїхав {t}',
  'trip.finish': 'Рейс завершено',
  'trip.finishConfirm': 'Завершити рейс? Товар, який ще не прийнято, буде оприбутковано на склад призначення.',
  'trip.cancel': 'Скасувати рейс',
  'trip.cancelConfirm': 'Скасувати рейс? Усі бронювання на ньому буде знято.',
  'trip.past': 'Минулі рейси',
  'fleet.emptyRoute': 'За цим напрямком у ці дні рейсів немає.',
  'fleet.widenDays': 'Розширити на 30 днів',
  'fleet.createTrip': 'Створити рейс',
  'freight.orders': 'Замовлення виробнику',
  'freight.noOrders': 'Замовлень виробнику ще немає.',
  'freight.status.draft': 'чернетка',
  'freight.status.ordered': 'замовлено',
  'freight.status.in_production': 'виготовляється',
  'freight.status.ready': 'готово до відвантаження',
  'freight.status.closed': 'закрито — усе отримано',
  'freight.status.cancelled': 'скасовано',
  'freight.partlyReceived': 'отримано частково',
  'freight.lineStats': 'замовлено {q} · завантажено {l} · отримано {r}',
  'freight.cancelPo': 'Скасувати замовлення',
  'freight.cancelPoConfirm': 'Скасувати замовлення {n}?',
  'freight.cancelPoWhy': 'Частину вже завантажено у фуру — скасувати не можна.',
  'freight.poSaved': 'Замовлення оновлено',

  // B5: заявка — звідки прийшла, як відповісти клієнту; документи — чого бракує
  'lead.formKind.callback': 'Просить передзвонити',
  'lead.formKind.order': 'Замовлення з сайту',
  'lead.formKind.monument': 'Запит на памʼятник',
  'lead.formKind.repatriation': 'Форма перевезення',
  'lead.formKind.contact': 'Питання з сайту',
  'lead.routeFromForm': 'Маршрут, який вказав клієнт',
  'lead.conversations': 'Спілкування',
  'lead.reply': 'Відповісти',
  'lead.you': 'Ви',
  'lead.noChat': 'Чату немає — зателефонуйте або напишіть на пошту',
  'lead.call': 'Подзвонити {phone}',
  'lead.mail': 'Написати на {email}',
  'docs.missingBadge': 'бракує {n}',
  'docs.missingMore': 'Показати ще {n}',

  // --- B1 access-identity-team
  'error.duty_role': 'Чергувати на заявках можуть лише власник, менеджер або оператор.',
  'settings.user.edit': 'Редагувати',
  'settings.user.editTitle': 'Дані користувача',
  'settings.user.newPassword': 'Новий пароль',
  'settings.user.newPasswordHint': 'Залиште порожнім, якщо пароль не змінюється. Після зміни людину виведе з усіх пристроїв.',
  'settings.user.saved': 'Дані користувача збережено',
  'settings.password.change': 'Змінити мій пароль',
  'settings.password.current': 'Поточний пароль',
  'settings.password.new': 'Новий пароль',
  'settings.password.repeat': 'Повторіть новий пароль',
  'settings.password.mismatch': 'Паролі не збігаються',
  'settings.password.changed': 'Пароль змінено. На інших пристроях потрібно увійти знову.',
  'settings.password.minHint': 'Мінімум 10 символів',
  'settings.suspend.stillAssigned': 'У {name} ще залишилось задач: {tasks}, справ: {cases} — передайте їх іншому.',
  'settings.dutyOverlap': 'Чергування додано. Зверніть увагу: на цей час уже є інший черговий.',
  'planner.shiftOnAbsence': 'Зміну додано, але в цей день людина у відпустці чи на лікарняному.',
  // --- B2 case-flow-documents
  'stage.confirmClose': 'Закрити справу? Назад повернутися не можна.',
  'error.guard_trip_booked': 'Спочатку поставте тіло на рейс або передайте перевезення партнерові',
  'error.guard_order_confirmed': 'Замовлення ще не підтверджене',
  'error.guard_tasks_done': 'Спершу закрийте задачі справи (відкрито: {n})',
  'pipeline.noTemplate': 'План для цього типу справи ще не налаштовано',
  'docs.rejectReason': 'Що не так з документом?',
  'docs.rejectHint': 'причину побачить клієнт у кабінеті',
  'docs.rejectedBecause': 'Причина: {note}',
  'docs.skippedBecause': 'Не потрібен: {note}',
  'docs.reason.unreadable': 'Нечитабельно',
  'docs.reason.wrongDoc': 'Не той документ',
  'docs.reason.needsTranslation': 'Потрібен переклад',
  'docs.reason.other': 'Інше',
  'docs.reason.otherText': 'Що саме не так',
  'docs.reason.extraText': 'Уточнення (необовʼязково)',
  'event.checklist_requirements_changed': 'Змінено перелік документів',
  'event.checklist_note': 'Примітка до документа',
  'event.tasks_closed': 'Задачі закрито',
  // --- B3 shop-orders-stock
  'order.buyerFound': 'Знайдено клієнта: {name}{phone}. Це той самий покупець?',
  'order.useContact': 'Це він/вона',
  'order.newContact': 'Новий клієнт',
  'order.contactPicked': 'Клієнт з бази: {name}',
  'order.contactChange': 'Інший клієнт',
  'order.buyerRequired': 'Вкажіть імʼя та телефон (або email) покупця, або оберіть оптового клієнта.',
  'order.inStock': 'В наявності: {n}',
  'order.inStockAt': 'В наявності: {n} (склад «{loc}»)',
  'order.noStock': 'Немає на складі',
  'order.overStock': 'Більше, ніж є на складі — буде під замовлення',
  'order.ruleApplied': 'Ціна за правилом «{name}»',
  'orders.needsConfirm': 'Потрібно підтвердити',
  'orders.needsConfirmHint': 'Замовлення з маркетплейсу: товару не вистачило, тому його не зарезервовано. Перевірте склад і підтвердіть вручну.',
  'product.publishMissing': 'Щоб опублікувати, додайте: {list}',
  'product.missing.name': 'назву',
  'product.missing.slug': 'адресу сторінки',
  'product.missing.price': 'ціну',
  'product.missing.image': 'фото',
  'seller.title': 'Реквізити продавця (для рахунків)',
  'seller.hint': 'Ці дані друкуються в договорах, актах і рахунках. Поки код і IBAN не заповнені, документи друкуються з попередженням.',
  'seller.incomplete': 'Не заповнено — документи клієнтам друкуються без реквізитів.',
  'seller.name': 'Назва (як у виписці)',
  'seller.kind': 'Форма',
  'seller.kind.fop': 'ФОП',
  'seller.kind.company': 'Компанія (ТОВ, ПП)',
  'seller.taxId': 'ЄДРПОУ або ІПН',
  'seller.taxIdHint': 'ФОП — 10 цифр ІПН, компанія — 8 цифр ЄДРПОУ',
  'seller.iban': 'IBAN',
  'seller.ibanHint': '29 символів, починається з UA',
  'seller.bank': 'Банк',
  'seller.address': 'Адреса',
  'seller.vat': 'Платник ПДВ',
  'seller.saved': 'Реквізити збережено',
  'inv.balanceAt': 'На складі: {n}',
  'inv.locations': 'Склади',
  'inv.rename': 'Перейменувати',
  'inv.renameTitle': 'Перейменувати склад',
  'inv.archive': 'В архів',
  'inv.unarchive': 'Повернути',
  'inv.archived': 'в архіві',
  'inv.archiveConfirm': 'Прибрати склад «{name}» в архів? Його не буде у списках вибору.',
  'inv.noteRequired': 'Вкажіть причину коригування (наприклад: бій, перерахунок)',
  'inv.reason': 'Причина',
  'pricing.priorityHint': 'Діє лише одне правило — з найбільшим пріоритетом.',
  'pricing.eurRounding': 'Ціни в EUR округлюються вгору до 1 €.',
  'b2b.prepaid': 'Без кредиту (передоплата)',
  // batch: crm-fleet-shop-ui
  'fleet.resultsOffersOnly': 'Рейсів немає, але є вільні місця партнерів: {n}',
  'fleet.stageNotMoved': 'Справа {case} залишилась на етапі «{stage}»: {reason}',
  'fleet.offerPlacesMin': 'Вкажіть кількість місць, не менше 1',
  'fleet.offerDatesOrder': 'Дата «по» раніше за дату «з»',
  'channels.feedMarketplace': 'Посилання на товари для маркетплейсу',
  'channels.bufferChannel': 'Запас, який не пропонуємо в цьому каналі',
  // batch: team-fleet
  'handover.title': 'Передати роботу на час відсутності',
  'handover.subtitle': '{name}: {kind}, {from} — {to}',
  'handover.intro': 'Поки людини немає, її задачі, справи, рейси, чергування і заявки має хтось вести. Оберіть кому — одним вибором для всього або окремо для кожного рядка.',
  'handover.allTo': 'Передати все одній людині',
  'handover.applyAll': 'Застосувати до всіх',
  'handover.absentSuffix': '— у відпустці',
  'handover.keep': 'Не передавати',
  'handover.tasks': 'Задачі',
  'handover.cases': 'Справи',
  'handover.trips': 'Рейси (як водій)',
  'handover.duty_shifts': 'Чергування',
  'handover.leads': 'Заявки',
  'handover.noDue': 'без строку',
  'handover.due': 'до {date}',
  'handover.leadNoName': 'Заявка без імені',
  'handover.nothing': 'Нічого передавати — можна погодити',
  'handover.submit': 'Передати і погодити',
  'handover.approveOnly': 'Погодити',
  'handover.done': 'Відсутність погоджено, роботу передано',
  'handover.approved': 'Відсутність погоджено',
  'handover.targetFor': 'Кому передати: {item}',
  'handover.allToHint': 'Рядки нижче заповняться цією людиною («Застосувати до всіх» скидає ваші ручні зміни). Робота, що їй не підходить, лишиться «Не передавати».',
  'handover.unset': 'Не передано: {list}. На час відсутності це лишиться за {name} — оберіть людину в цих рядках або погодьте так.',
  'handover.unsetDuty': 'Чергування не передано — оберіть чергового (власник, менеджер або оператор).',
  'error.handover_target': 'Цій людині не можна передати цю роботу (водієві — лише задачі й рейси, чергування — лише офісу).',
  'error.vehicle_documents_departure': 'Виїзд неможливий: {detail}. Оновіть документи машини і спробуйте знову.',
  'fleet.departureBlocked': 'Виїзд заблоковано: {problems}',
  'fleet.departureWarn': 'Зверніть увагу на документи: {warnings}',
  'fleet.departureHint': 'Обовʼязкові документи перевіряються на дату останньої зупинки рейсу.',
  'fleet.departureDocs': 'Документи машин',
  'fleet.departureWarnToast': 'Рейс вирушив. Документи: {warnings}',
  // batch: countries-config
  'nav.countries': 'Країни',
  'countries.subtitle': 'Для кожної країни — які документи й дії потрібні, коли тіло везуть звідти, сюди або лише проїжджають через неї. Ці правила потрапляють у план справи.',
  'countries.add': 'Додати країну',
  'countries.addTitle': 'Нова країна',
  'countries.addIntro': 'Оберіть країну, з якою працюєте. Потім додасте до неї документи, дії й контакти партнерів.',
  'countries.country': 'Країна',
  'countries.allAdded': 'Усі країни зі списку вже додано.',
  'countries.created': 'Країну додано',
  'countries.seed': 'Додати приклади (NL, PL, MD, DE, IT)',
  'countries.seedHint': 'Приклади ще не перевірені — уточніть їх з партнером і позначте «Перевірено з партнером».',
  'countries.seeded': 'Додано країн: {c}, правил: {r}',
  'countries.empty': 'Країн ще немає. Додайте першу або візьміть приклади.',
  'countries.pick': 'Оберіть країну у списку зліва.',
  'countries.list': 'Список країн',
  'countries.inactive': 'не працюємо',
  'countries.rulesCount': 'правил: {n}',
  'countries.exampleBanner': 'Ця країна — приклад, її ще ніхто не перевірив. Звірте документи, строки й контакти з партнером, а потім на вкладці «Нотатки» увімкніть «Перевірено з партнером».',
  'countries.tabs': 'Розділи країни',
  'countries.tab.rules': 'Документи і дії',
  'countries.tab.notes': 'Нотатки',
  'countries.role.origin': 'Коли тіло везуть з цієї країни (тут сталася смерть)',
  'countries.role.dest': 'Коли тіло везуть у цю країну (тут поховання)',
  'countries.role.transit': 'Коли машина лише проїжджає через цю країну',
  'countries.roleShort.origin': 'везуть звідси',
  'countries.roleShort.dest': 'везуть сюди',
  'countries.roleShort.transit': 'проїзд через країну',
  'countries.noRules': 'Окремих правил немає — діють загальні правила з «Процесів».',
  'countries.kind.doc': 'Документ',
  'countries.kind.action': 'Дія',
  'countries.kind.party_role': 'Учасник',
  'countries.kind.product': 'Товар',
  'countries.required': 'обовʼязково',
  'countries.optional': 'за потреби',
  'countries.excluded': 'тут не потрібно',
  'countries.who': 'оформлює: {who}',
  'countries.cremationOnly': 'лише з кремацією',
  'countries.noCremationOnly': 'лише без кремації',
  'countries.dueDaysShort': 'термін: {n} дн.',
  'countries.ruleRemoved': 'Правило видалено',
  'countries.removeTitle': 'Видалити правило?',
  'countries.removeText': '«{name}» зникне з цієї країни і з «Процесів». У планах нових справ його більше не буде.',
  'countries.form.new': 'Нове правило · {c}',
  'countries.form.edit': 'Змінити правило · {c}',
  'countries.form.intro': 'Крок 1 — що потрібно. Крок 2 — на якому етапі плану, хто оформлює і за яких умов. Правило одразу потрапить у план нових справ (випадок: {role}).',
  'countries.form.step1': '1. Що потрібно',
  'countries.form.step2': '2. Етап і умови',
  'countries.form.kind': 'Що це',
  'countries.form.docType': 'Документ',
  'countries.form.actionTitle': 'Що треба зробити',
  'countries.form.actionPlaceholder': 'Напр.: Дозвіл санслужби на вивіз тіла',
  'countries.form.ownTitle': 'Своя назва (необовʼязково)',
  'countries.form.block': 'Етап плану',
  'countries.form.blockFixed': 'Етап правила не змінюється. Щоб перенести, видаліть правило і додайте заново.',
  'countries.form.required': 'Обовʼязково для справи',
  'countries.form.exclude': 'У цій країні це НЕ потрібно (прибрати загальну вимогу)',
  'countries.form.responsible': 'Хто оформлює',
  'countries.form.mode': 'Вид транспорту',
  'countries.form.modeAny': 'будь-який',
  'countries.form.cremation': 'Кремація',
  'countries.form.cremationAny': 'неважливо',
  'countries.form.cremationYes': 'так, лише з кремацією',
  'countries.form.cremationNo': 'ні, лише без кремації',
  'countries.form.note': 'Примітка для команди',
  'countries.form.dueDays': 'Термін, днів',
  'countries.form.dueDaysHint': 'Від складання плану. Порожньо — 2 дні.',
  'countries.form.next': 'Далі',
  'countries.form.needWhat': 'Оберіть документ або напишіть, що треба зробити.',
  'countries.notes': 'Як працюємо з країною',
  'countries.notesHint': 'Строки, особливості, на що звернути увагу. Зберігається, щойно ви виходите з поля.',
  'countries.partners': 'Партнери в країні',
  'countries.partnersHint': 'Похоронні доми, перекладачі, консульство — кому дзвонити по цій країні.',
  'countries.partner.name': 'Назва або імʼя',
  'countries.partner.role': 'Хто це',
  'countries.partnerAdd': '+ Контакт',
  'countries.noPartners': 'Контактів ще немає.',
  'countries.isExample': 'Перевірено з партнером',
  'countries.isActive': 'Працюємо з цією країною',
  'countries.status': 'Готовність',
  'countries.unverified': 'не перевірено',
  'countries.counts': 'Окремих правил: {list}',
  'countries.countItem': '{role} — {n}',
  'countries.isExampleHint': 'Поки вимкнено, країна позначена як приклад.',
  'countries.partnerEdit': 'Змінити контакт',
  'countries.partnerNew': 'Новий контакт',
  'countries.partnerReplace': 'Замінити на справжній',
  'countries.partnerExample': 'приклад',
  'countries.partnerRemoveTitle': 'Видалити контакт?',
  'countries.partnerRemoveText': 'Контакт «{name}» зникне з цієї країни.',
  'countries.partnerSaved': 'Контакт збережено',
  'countries.partnerRemoved': 'Контакт видалено',
  'countries.partnerNameHint': 'Наприклад: Bestattungshaus Müller або Олена (перекладачка).',
  'countries.partnerRolePlaceholder': 'напр.: перекладач',
  'vdoc.on': 'обовʼязковий',
  'vdoc.off': 'не потрібен',
  'vdoc.title': 'Обовʼязкові документи — для всіх машин',
  'vdoc.intro': 'Це загальне правило для всіх машин компанії, а не лише для вибраної вище. Позначте, які документи обовʼязкові для кожного типу кузова. Машина без чинного обовʼязкового документа не стане на рейс і не виїде.',
  'vdoc.doc': 'Документ',
  'vdoc.empty': 'Типів документів для машин немає.',
  'vdoc.cell': '{doc} — {body}',
  // batch: plan-templates
  'task.whatNeededExample': 'Це приклад — відредагуйте текст у Налаштування → Процеси',
  'planex.chip': 'Приклад',
  'planex.chipHint': 'Приклад для старту — відредагуйте під себе',
  'planex.whatNeeded': 'Що потрібно: {note}',
  'planex.offerHint': 'Готовий план для старту: кроки, документи і задачі з термінами. Після застосування все можна змінити.',
  'planex.noteLabel': 'Що потрібно (підказка в задачі)',
  'planex.noteHint': 'Цей текст бачить працівник у вікні задачі. Текст з «Приклад:» сід може оновити — напишіть свій, щоб зберегти.',
  // batch: pricing-tech
  'collPrice.field': 'Окрема ціна колекції, грн',
  'collPrice.hint': 'Діє для товарів колекції зі статусом «Тест» або «У продажу» замість прайс-листа. Знижки і правила застосовуються після неї. Порожньо — ціна з прайсів.',
  'collPrice.chip': 'Ціна колекції: {price}',
  'collPrice.itemPrice': 'Своя ціна товару, грн',
  'collPrice.itemPlaceholder': 'ціна з прайсу',
  'collPrice.itemPlaceholderColl': 'як у колекції: {price}',
  'collPrice.itemsHint': 'Поле біля товару — своя ціна саме цього товару, грн. Вона замінює ціну колекції. Залиште порожнім — діятиме ціна колекції (а якщо її немає — ціна з прайсу).',
  'collPrice.notActive': 'Зараз колекція в статусі «{status}» — її ціни на продаж не впливають.',
  'trace.title': 'Як порахована ціна',
  'trace.priceList': 'Ціна з прайсу «{name}» ({source}, від {n} шт.): {amount}',
  'trace.source.b2b_account': 'прайс B2B-клієнта',
  'trace.source.channel': 'прайс каналу',
  'trace.source.default': 'типовий прайс',
  'trace.collection': 'Окрема ціна колекції «{name}»: {amount}',
  'trace.collectionItem': 'Своя ціна товару в колекції «{name}»: {amount}',
  'trace.rulePercent': 'Правило «{name}» (−{pct}%): {amount}',
  'trace.rulePriceList': 'Правило «{name}» (ціна з прайсу «{list}»): {amount}',
  'trace.ruleTier': 'Правило «{name}» (сходинка від {n} шт., −{pct}%): {amount}',
  'trace.fx': 'Перераховано у {cur} за курсом {rate} (націнка {markup}%): {amount}',
  'trace.manual': 'Ціну вписано вручну: {amount}',
  'trace.empty': 'Пояснення для цієї ціни немає.',
  'pricing.explainTitle': 'Порядок застосування',
  'pricing.explainIntro': 'Так система рахує ціну кожного товару в замовленні:',
  'pricing.explain1': '1. Окрема ціна колекції — якщо товар у колекції зі статусом «Тест» або «У продажу» і для неї (чи для товару в ній) задано ціну.',
  'pricing.explain2': '2. Інакше — прайс-листи: спершу прайс B2B-клієнта, потім прайс каналу, потім типовий.',
  'pricing.explain3': '3. Потім до цієї ціни (з колекції чи з прайсу) застосовується одне правило з найвищим пріоритетом — знижка, інший прайс або сходинка за кількістю. Тобто знижки діють і на ціну колекції.',
  'pricing.explain4': '4. Якщо замовлення не в гривнях — ціна перераховується за курсом.',
  'pricing.explainOrderHint': 'Ціну рахує система: окрема ціна колекції (якщо товар у колекції «Тест» або «У продажу»), інакше прайс; потім правило знижки. У списку пошуку вже показано підсумкову ціну для цього замовлення; як вона склалася — у «Як порахована ціна» під рядком.',
  'limits.tooLarge': 'Файл більший за {mb} МБ',
  // batch: notify-staff
  'notif.title': 'Сповіщення',
  'notif.intro': 'Тут збирається все, що стосується саме вас: нові заявки й задачі, повідомлення клієнтів, рішення щодо відпусток і нагадування.',
  'notif.unreadBadge': 'непрочитаних: {n}',
  'notif.new': 'нове',
  'notif.markAll': 'Позначити всі прочитаними',
  'notif.markedAll': 'Усі сповіщення прочитано',
  'notif.all': 'Усі сповіщення',
  'notif.empty': 'Поки нічого — тут зʼявляться призначені вам заявки й задачі, повідомлення клієнтів та нагадування',
  'notif.emptyUnread': 'Непрочитаних немає — усе переглянуто.',
  'notif.filter': 'Які сповіщення показати',
  'notif.filterUnread': 'Непрочитані',
  'notif.filterAll': 'Усі',
  'notif.kind.lead_assigned': 'Заявка',
  'notif.kind.client_message': 'Повідомлення клієнта',
  'notif.kind.absence_request': 'Запит на відсутність',
  'notif.kind.absence_decided': 'Відсутність',
  'notif.kind.document_expiring': 'Документ',
  'notif.kind.task_assigned': 'Задача',
  'notif.kind.task_overdue': 'Прострочена задача',
  'notif.kind.trip_status': 'Рейс',
  'notif.kind.handover_offered': 'Передача справи',
  'notif.kind.handover_accepted': 'Передачу прийнято',
  'notif.kind.handover_declined': 'Передачу відхилено',
  'notif.kind.handover_revoked': 'Передачу відкликано',
  'notif.kind.handover_completed': 'Передачу завершено',
  'notif.kind.handover_progress': 'Перевезення партнера',
  'notif.kind.handover_document': 'Документ партнера',
  'notif.kind.quality_assigned': 'Скарга / ідея',
  'notif.kind.quality_partner_item': 'Скарга від партнера',
  'duty.none': 'Немає чергового — нові заявки отримає власник',
  'password.seedWarning': 'Ви увійшли з початковим паролем із налаштувань сервера. Змініть його, щоб доступ до CRM був лише у вас.',
  'password.seedLink': 'Змінити пароль',
  'duty.noneShort': 'Немає чергового',
  'duty.noneLink': 'Поставити чергування',
  'duty.noneHere': 'Натисніть «+ Нове чергування» нижче',
  'notif.plannerCount': 'Запитів на відсутність чекають рішення: {n}',
  'nav.myDocuments': 'Мої документи',
  'mydocs.title': 'Мої документи',
  'mydocs.intro': 'Ваші особисті документи: посвідчення, довідки, договори. Коли термін дії спливає, ви отримаєте нагадування.',
  'mydocs.expected': 'Що має бути',
  'mydocs.files': 'Усі мої файли',
  'mydocs.status.ok': 'дійсний до {date}',
  'mydocs.status.okNoDate': 'додано, безстроковий',
  'mydocs.status.expiring': 'спливає за {n} дн.',
  'mydocs.status.expired': 'прострочено',
  'mydocs.status.missing': 'не додано',
  'mydocs.add': 'Додати файл',
  'mydocs.addTitle': 'Додати файл: {name}',
  'mydocs.addIntro': 'Оберіть фото або скан документа. Якщо в документа є термін дії — вкажіть його, і ми нагадаємо за 14 днів до кінця.',
  'mydocs.file': 'Файл',
  'mydocs.fileTitle': 'Назва (необовʼязково)',
  'mydocs.validFrom': 'Дійсний з',
  'mydocs.validUntil': 'Дійсний до',
  'mydocs.upload': 'Завантажити',
  'mydocs.uploaded': 'Документ додано',
  'mydocs.restricted': 'Додає керівник',
  'mydocs.restrictedHint': 'Цей документ веде керівник — тут видно лише, чи він чинний.',
  'mydocs.empty': 'Ви ще не додали жодного документа.',
  'mydocs.col.type': 'Документ',
  'mydocs.col.file': 'Файл',
  'mydocs.col.dates': 'Термін дії',
  'mydocs.open': 'Відкрити',
  'mydocs.unlimited': 'безстроковий',
  'mydocs.staffHint': 'Кожен співробітник бачить і додає свої документи у «Мої документи».',
  'mydocs.employee': 'Співробітник',
  'mydocs.allEmployees': 'Усі співробітники',
  'profile.title': 'Мій профіль',
  'profile.intro': 'Ваше імʼя бачать колеги в задачах і справах, з ним вас вітає сторінка «Сьогодні».',
  'profile.name': 'ПІБ',
  'profile.phone': 'Телефон',
  'profile.phoneHint': 'Для колег і сповіщень. Можна без +380, наприклад 050 123 45 67.',
  'profile.phoneInvalid': 'Не вдалося розпізнати номер. Напишіть його так: 050 123 45 67 або +380 50 123 45 67.',
  'profile.saved': 'Збережено',
  'error.profile_name_required': 'Вкажіть імʼя — поле не може бути порожнім.',
  // batch: shop-returns-feeds
  'ret.open': 'Оформити повернення',
  'ret.title': 'Повернення товару',
  'ret.intro': 'Повернення зменшує виручку, повертає товар на склад або списує його і друкує акт.',
  'ret.step1': 'Що повертаємо',
  'ret.step2': 'Що робити з товаром і чому',
  'ret.step3': 'Відшкодування',
  'ret.col.pick': 'Повернути',
  'ret.col.item': 'Позиція',
  'ret.col.qty': 'Скільки',
  'ret.col.of': 'з {n}',
  'ret.col.action': 'Що робимо з товаром',
  'ret.col.amount': 'За одиницю',
  'ret.col.lineTotal': 'Разом',
  'ret.pickRow': 'Повернути «{title}»',
  'ret.alreadyReturned': 'вже повернуто {n}',
  'ret.nothingLeft': 'усе повернуто',
  'ret.service': 'Послуга — на склад не повертається',
  'ret.restockTo': 'На склад: {location}',
  'ret.writeOff': 'Списати (зіпсовано)',
  'ret.restock.restock': 'На склад',
  'ret.restock.write_off': 'Списано',
  'ret.restock.none': 'Послуга',
  'ret.reasonLabel': 'Причина повернення',
  'ret.reason.damaged': 'Пошкоджено',
  'ret.reason.wrong_item': 'Не той товар',
  'ret.reason.customer_refused': 'Відмова покупця',
  'ret.reason.quality': 'Неналежна якість',
  'ret.reason.other': 'Інше',
  'ret.reasonNote': 'Пояснення',
  'ret.reasonNoteHint': 'Друкується в акті поруч із причиною',
  'ret.note': 'Примітка для колег',
  'ret.amountHint': 'Типово — ціна, яку сплатив покупець',
  'ret.methodLabel': 'Як повертаємо гроші',
  'ret.method.cash': 'Готівкою',
  'ret.method.card': 'На картку',
  'ret.method.bank': 'Банківським переказом',
  'ret.method.none': 'Без відшкодування',
  'ret.refundTotal': 'До повернення покупцю',
  'ret.summary': 'Перевірте перед підтвердженням',
  'ret.summaryItems': 'Повертаємо: {n} шт.',
  'ret.summaryRestock': 'На склад: {n} шт.',
  'ret.summaryWriteOff': 'Списуємо: {n} шт.',
  'ret.confirm': 'Підтвердити повернення',
  'ret.done': 'Повернення {number} оформлено',
  'ret.err.pick': 'Позначте хоча б одну позицію, яку повертають.',
  'ret.err.qty': 'Можна повернути не більше {available} шт. позиції «{title}».',
  'ret.err.location': 'Оберіть склад для «{title}».',
  'ret.err.amount': 'Сума за «{title}» має бути від 0 до {max}.',
  'ret.err.reasonNote': 'Для причини «Інше» коротко поясніть, що сталося.',
  'ret.kpi.returned': 'Повернуто',
  'ret.kpi.net': 'Разом після повернень',
  'ret.section': 'Повернення',
  'ret.colReturned': 'Повернуто',
  'ret.returnedOf': '{n} з {total}',
  'ret.by': 'Оформив(ла): {name}',
  'ret.document': 'Акт повернення',
  'ret.chip': 'повернення',
  'ret.chipHint': 'За замовленням оформлено повернення',
  'error.return_qty_exceeds': 'Можна повернути не більше {available} шт. цієї позиції',
  'error.return_refund_exceeds': 'Сума відшкодування не може перевищувати ціну позиції',
  'error.return_restock_required': 'Оберіть, що робити з товаром «{title}»: повернути на склад чи списати',
  'order.collectionPrice': 'Ціна за колекцією «{name}»',
  'order.collectionItemPrice': 'Своя ціна товару в колекції «{name}»',
  'order.ruleAfterCollection': 'далі правило «{name}»',
  'variantPicker.priceHint': 'Підсумкова ціна для цього замовлення — така стане в рядок',
  'feeds.label.prom': 'Посилання на фід для Prom',
  'feeds.label.rozetka': 'Посилання на фід для Rozetka',
  'feeds.label.epicentr': 'Посилання на фід для Епіцентру',
  'feeds.hint': 'Вставте це посилання у кабінеті маркетплейсу як джерело товарів (оновлюється кожні 5 хвилин)',
  'feeds.label.none': 'Вивантаження товарів',
  'ret.allReturned': 'Усі товари з цього замовлення вже повернуто — нове повернення оформити не можна.',
  'ret.wasTotal': 'було {sum}',
  'ret.wasTotalHint': 'Сума після повернень; нижче дрібно — початкова сума замовлення',
  // --- batch: crm-frontend
  'cases.allServices': 'Усі послуги',
  'cases.emptyMine': 'Справ, де ви відповідальний або маєте задачу, зараз немає.',
  'event.order_returned': 'Повернення по замовленню',
  'event.order_returned_n': 'Повернення по замовленню {number}',
  'event.checklist_item_reset': 'Пункт чекліста скинуто',
  'event.task_assigned': 'Задачу призначено',
  'nav.noAccessTitle': 'Немає доступу до цього розділу',
  'nav.noAccessText': 'Ваша роль не може відкрити цю сторінку. Якщо посилання прийшло у сповіщенні чи пошуку — зверніться до керівника.',
  'nav.noAccessHome': 'На головну',
  'product.photoN': 'Фото {n}',
  // --- batch: document-types
  'docTypes.add': 'Додати новий тип документа',
  'docTypes.section': 'Типи документів',
  'docTypes.sectionHint': 'Свої типи документів компанії: їх можна обрати в правилах країн і при завантаженні документів.',
  'docTypes.empty': 'Своїх типів документів ще немає.',
  'docTypes.newTitle': 'Новий тип документа',
  'docTypes.editTitle': 'Перейменувати тип документа',
  'docTypes.name': 'Назва',
  'docTypes.nameHint': 'Так документ називатиметься у справах і в кабінеті клієнта',
  'docTypes.folder': 'Тека',
  'docTypes.owners': 'Чий це документ',
  'docTypes.ownersHint': 'Позначте хоча б один варіант',
  'docTypes.validity': 'Має термін дії',
  'docTypes.validityHint': 'Для документа можна буде вказати «Діє до» і отримати нагадування',
  'docTypes.sensitivity': 'Чутливість',
  'docTypes.sens.normal': 'Звичайний документ',
  'docTypes.sens.special': 'Особлива категорія',
  'docTypes.specialHint': 'Особлива категорія — бачать лише власник і менеджер',
  'docTypes.clientHint': 'Підказка клієнту',
  'docTypes.clientHintHint': 'Необовʼязково. Клієнт побачить її в кабінеті поруч із документом',
  'docTypes.created': 'Тип документа додано',
  'docTypes.saved': 'Тип документа збережено',
  'docTypes.rename': 'Перейменувати',
  'docTypes.archive': 'Архівувати',
  'docTypes.unarchive': 'Відновити',
  'docTypes.archivedOk': 'Тип документа перенесено в архів',
  'docTypes.restored': 'Тип документа відновлено',
  'docTypes.archivedChip': 'в архіві',
  'docTypes.inUse': 'Документів: {d} · правил: {r}',
  'docTypes.archiveTitle': 'Архівувати тип документа?',
  'docTypes.archiveText': '«{name}» більше не можна буде обрати для нових правил. Наявні документи й правила залишаться.',
  'docTypes.archivedRule': 'тип документа в архіві',
  'docTypes.addInForm': 'Немає потрібного? Додати новий тип документа',
  'error.c.document_types_key': 'Тип документа з такою назвою вже є. Змініть назву.',
  'error.c.document_type_archived': 'Цей тип документа в архіві. Оберіть інший або відновіть його в списку «Типи документів».',
  // --- batch: cases-plan
  'plan.handoverWork': 'Передати роботу',
  'plan.handoverReverted': 'Відсутність скасовано, роботу повернуто людині ({n})',
  'handover.submitApproved': 'Передати',
  'handover.closeNothing': 'Готово',
  'handover.nothingApproved': 'Нічого передавати — у людини немає відкритої роботи на ці дні',
  'handover.transferred': 'Роботу передано на час відсутності',
  'handover.nothingMoved': 'Нічого не передано — робота лишилась за людиною',
  'error.cannot_decide_own': 'Свій запит на відсутність погоджує інший керівник або власник',
  // --- batch: crm-partner
  'hr.nav': 'Передані нам',
  'hr.title': 'Передані нам',
  'hr.intro': 'Справи, які інші компанії передали вам для виконання. Видно лише те, що дозволив відправник.',
  'hr.empty': 'Поки нічого не передано',
  'hr.emptyFiltered': 'Немає передач із таким статусом',
  'hr.filterLabel': 'Статус передачі',
  'hr.status.offered': 'нова пропозиція',
  'hr.status.accepted': 'прийнято',
  'hr.status.declined': 'відхилено',
  'hr.status.revoked': 'відкликано',
  'hr.status.completed': 'завершено',
  'hr.scope.case': 'уся справа',
  'hr.scope.transport': 'лише перевезення',
  'hr.stage.accepted': 'Прийнято',
  'hr.stage.picked_up': 'Тіло забрано',
  'hr.stage.in_transit': 'У дорозі',
  'hr.stage.delivered': 'Доставлено',
  'hr.hidden': 'Приховано відправником',
  'hr.hiddenShort': 'приховано',
  'hr.from': 'Від: {name}',
  'hr.col.from': 'Від кого',
  'hr.col.case': 'Справа',
  'hr.col.route': 'Маршрут',
  'hr.col.dates': 'Дати',
  'hr.col.deceased': 'Померлий',
  'hr.col.stage': 'Етап',
  'hr.col.trip': 'Мій рейс',
  'hr.offeredAt': 'Запропоновано {date}',
  'hr.accept': 'Прийняти',
  'hr.decline': 'Відхилити',
  'hr.declineConfirm': 'Відхилити передачу справи {number}? Відправник отримає сповіщення, а справа зникне з вашого списку.',
  'hr.acceptedOk': 'Справу прийнято',
  'hr.declinedOk': 'Передачу відхилено',
  'hr.offeredHint': 'Перегляньте умови і прийміть або відхиліть передачу.',
  'hr.onlyManagers': 'Прийняти чи відхилити передачу може власник або менеджер.',
  'hr.acceptFirst': 'Після прийняття тут можна буде вести перевезення, завантажувати документи і привʼязати свій рейс.',
  'hr.completedHint': 'Відправник завершив передачу. Дані доступні лише для перегляду.',
  'hr.sec.route': 'Маршрут і дати',
  'hr.sec.deceased': 'Померлий',
  'hr.sec.payment': 'Оплата партнеру',
  'hr.sec.documents': 'Документи',
  'hr.sec.checklist': 'Чекліст',
  'hr.sec.family': 'Контакти родини',
  'hr.sec.price': 'Ціна',
  'hr.sec.medical': 'Медичні дані',
  'hr.sec.trip': 'Мій рейс',
  'hr.sec.progress': 'Хід перевезення',
  'hr.sec.note': 'Примітка відправника',
  'hr.f.origin': 'Звідки',
  'hr.f.dest': 'Куди',
  'hr.f.transit': 'Транзит',
  'hr.f.window': 'Вікно перевезення',
  'hr.f.opened': 'Справу відкрито',
  'hr.f.deathAt': 'Дата смерті',
  'hr.f.birth': 'Дата народження',
  'hr.f.deathCountry': 'Країна смерті',
  'hr.f.citizenship': 'Громадянство',
  'hr.f.fullName': 'ПІБ',
  'hr.f.amount': 'Сума до сплати вам',
  'hr.f.infectious': 'Інфекційне захворювання',
  'hr.f.embalmed': 'Бальзамування',
  'hr.f.cause': 'Причина смерті',
  'hr.f.notes': 'Нотатки',
  'hr.f.stage': 'Етап',
  'hr.f.eta': 'Орієнтовне прибуття',
  'hr.f.note': 'Коментар для відправника',
  'hr.f.docType': 'Тип документа',
  'hr.f.file': 'Файл',
  'hr.f.orders': 'Замовлення',
  'hr.f.total': 'Разом',
  'hr.paymentFree': 'Без оплати',
  'hr.progressSave': 'Зберегти етап',
  'hr.progressSaved': 'Етап перевезення оновлено',
  'hr.progressUpdated': 'Оновлено {date}',
  'hr.progressNone': 'Етап ще не відмічено',
  'hr.download': 'Завантажити',
  'hr.upload': 'Завантажити транспортний документ',
  'hr.uploadBtn': 'Завантажити',
  'hr.uploaded': 'Документ завантажено і передано відправнику',
  'hr.uploadHint': 'Лише транспортні документи: CMR, накладна, акт передачі тощо. Відправник побачить їх у своїй справі.',
  'hr.pickType': 'Оберіть тип документа',
  'hr.noDocs': 'Документів поки немає',
  'hr.noChecklist': 'Чекліст порожній',
  'hr.required': 'обовʼязковий',
  'hr.linkTrip': 'Привʼязати рейс',
  'hr.linked': 'Рейс привʼязано до передачі',
  'hr.pickTrip': 'Оберіть свій рейс',
  'hr.noTrips': 'Немає запланованих рейсів. Створіть рейс у розділі «Автопарк».',
  'hr.linkedTrips': 'Привʼязані рейси',
  'hr.noLinked': 'Рейс ще не привʼязано',
  'hr.tripLabel': '{number} · {plate}',
  'hr.notFound': 'Передачу не знайдено: відправник її відкликав або вона вам не належить.',
  'hr.back': 'До списку переданих',
  'hr.identity.phone': 'Телефон',
  'hr.identity.email': 'Email',
  'hr.identity.telegram': 'Telegram',
  'hr.identity.viber': 'Viber',
  'hr.identity.whatsapp': 'WhatsApp',
  // --- batch: crm-sponsor
  'settings.partners': 'Партнерські компанії',
  'ho.partners': 'Партнерські компанії',
  'ho.err.duplicateEmail': 'Користувач з таким email уже є в системі. Вкажіть іншу адресу.',
  'ho.err.partner': 'Цю компанію не можна обрати: вона не ваша партнерська або призупинена.',
  'error.c.handover_live': 'Цьому партнерові справу вже передано. Відкличте попередню передачу, щоб створити нову.',
  'error.c.organization_suspended': 'Роботу вашої компанії в системі призупинено. Зверніться до компанії, що вас підключила.',
  'error.organization_suspended': 'Роботу вашої компанії в системі призупинено. Зверніться до компанії, що вас підключила.',
  'ho.pc.intro': 'Окремі компанії-партнери зі своїми працівниками, справами й автопарком. Ви бачите лише назву, країну, статус і склад людей — не їхніх клієнтів. Справу чи перевезення передають партнеру з картки справи.',
  'ho.pc.new': 'Створити партнерську компанію',
  'ho.pc.empty': 'Партнерських компаній ще немає',
  'ho.pc.name': 'Назва компанії',
  'ho.pc.members': 'Людей',
  'ho.pc.adminEmail': 'Email адміністратора',
  'ho.pc.open': 'Відкрити',
  'ho.pc.company': 'Партнерська компанія',
  'ho.pc.status.active': 'Активна',
  'ho.pc.status.suspended': 'Призупинена',
  'ho.pc.adminTitle': 'Адміністратор партнера',
  'ho.pc.adminHint': 'Перший користувач компанії з роллю «Власник». Він сам додасть своїх працівників і ролі. При першому вході система попросить змінити пароль.',
  'ho.pc.generate': 'Згенерувати',
  'ho.pc.created': 'Партнерську компанію створено',
  'ho.pc.createdTitle': '«{name}» створено',
  'ho.pc.passwordOnce': 'Передайте ці дані людині. Пароль показано лише зараз — після закриття вікна його не буде видно.',
  'ho.pc.done': 'Готово',
  'ho.pc.copyFailed': 'Не вдалося скопіювати. Виділіть текст і скопіюйте вручну.',
  'ho.pc.createdAt': 'Створено',
  'ho.pc.membersTitle': 'Люди компанії',
  'ho.pc.membersHint': 'Працівниками і ролями керує адміністратор партнера. Тут можна лише скинути пароль.',
  'ho.pc.suspend': 'Призупинити',
  'ho.pc.activate': 'Активувати',
  'ho.pc.confirmSuspend': 'Призупинити «{name}»? Усі її працівники одразу вийдуть із системи і не зможуть увійти, доки компанію не активують.',
  'ho.pc.confirmActivate': 'Активувати «{name}»? Її працівники знову зможуть увійти.',
  'ho.pc.suspended': 'Компанію призупинено',
  'ho.pc.activated': 'Компанію активовано',
  'ho.pc.suspendedHint': 'Компанію призупинено: її працівники не можуть увійти, передані їй справи вона не бачить.',
  'ho.pc.resetPassword': 'Скинути пароль',
  'ho.pc.resetTitle': 'Новий пароль: {name}',
  'ho.pc.resetHint': 'Поточний пароль {email} перестане діяти, усі сесії буде закрито. При вході людина змінить пароль на свій.',
  'ho.pc.resetSubmit': 'Встановити пароль',
  'ho.pc.passwordReset': 'Пароль змінено',
  'ho.tab': 'Партнери',
  'ho.handOver': 'Передати партнеру',
  'ho.modal.title': 'Передати партнеру справу {number}',
  'ho.modal.submit': 'Передати',
  'ho.modal.partner': 'Партнер',
  'ho.modal.partnerPick': 'Оберіть компанію',
  'ho.modal.noPartners': 'Немає активних партнерських компаній. Створіть їх у Налаштуваннях → Партнерські компанії.',
  'ho.modal.scope': 'Що передаємо',
  'ho.modal.payment': 'Оплата партнеру',
  'ho.modal.paymentHint': 'Поки що 0 — розрахунки з партнерами ще не ведемо',
  'ho.modal.paymentInvalid': 'Вкажіть суму числом, наприклад 150 або 150,50',
  'ho.modal.noteHint': 'Партнер побачить цю примітку',
  'ho.scope.case': 'Вся справа',
  'ho.scope.transport': 'Лише перевезення',
  'ho.status.offered': 'Запропоновано',
  'ho.status.accepted': 'Прийнято',
  'ho.status.declined': 'Відхилено',
  'ho.status.revoked': 'Відкликано',
  'ho.status.completed': 'Завершено',
  'ho.stage.accepted': 'Прийнято в роботу',
  'ho.stage.picked_up': 'Тіло забрано',
  'ho.stage.in_transit': 'У дорозі',
  'ho.stage.delivered': 'Доставлено',
  'ho.vis.groupOpen': 'Відкрито партнеру',
  'ho.vis.groupClosed': 'Закрито за замовчуванням',
  'ho.vis.on': 'відкрито',
  'ho.vis.off': 'закрито',
  'ho.vis.route': 'Маршрут',
  'ho.vis.dates': 'Дати',
  'ho.vis.transport_documents': 'Документи для перевезення',
  'ho.vis.partner_payment': 'Оплата партнеру',
  'ho.vis.price': 'Ціна для родини',
  'ho.vis.family_contacts': 'Контакти родини',
  'ho.vis.medical': 'Медичні дані',
  'ho.vis.all_documents': 'Усі документи справи',
  'ho.vis.hint.route': 'Країни і місця відправлення та призначення, транзит',
  'ho.vis.hint.dates': 'Дата смерті і вікно перевезення',
  'ho.vis.hint.transport_documents': 'Свідоцтво про смерть, laissez-passer, CMR, акти та інші документи, без яких не перевезти',
  'ho.vis.hint.partner_payment': 'Скільки ви платите партнеру за цю роботу',
  'ho.vis.hint.price': 'Замовлення і суми, які сплачує родина',
  'ho.vis.hint.family_contacts': 'Імена, телефони й email замовника та родичів',
  'ho.vis.hint.medical': 'Причина смерті, інфекційність, бальзамування і документи особливої категорії',
  'ho.vis.hint.all_documents': 'Усі документи справи, не лише потрібні для перевезення (крім медичних)',
  'ho.offered': 'Справу передано: {name}',
  'ho.empty': 'Справу ще не передавали партнерам',
  'ho.offeredAt': 'Передано',
  'ho.respondedAt': 'Відповідь партнера',
  'ho.completedAt': 'Завершено',
  'ho.revokedAt': 'Відкликано',
  'ho.payment': 'Оплата партнеру',
  'ho.paymentFree': 'Без оплати',
  'ho.progress': 'Етап у партнера',
  'ho.noProgress': 'Ще не оновлював',
  'ho.eta': 'очікується {at}',
  'ho.partnerNote': 'Коментар партнера',
  'ho.trips': 'Рейси партнера',
  'ho.driver': 'Водій: {name}',
  'ho.stopFact': 'факт {at}',
  'ho.stopPlan': 'план {at}',
  'ho.stopNoTime': 'час не вказано',
  'ho.docs': 'Документи від партнера',
  'ho.visTitle': 'Що бачить партнер',
  'ho.visEdit': 'Змінити',
  'ho.visSaved': 'Видимість для партнера змінено',
  'ho.visNextRead': 'Зміни діють одразу: партнер побачить нові налаштування, щойно відкриє справу.',
  'ho.revoke': 'Відкликати',
  'ho.complete': 'Завершити',
  'ho.confirmRevoke': 'Відкликати передачу для «{name}»? Партнер одразу втратить доступ до справи і документів.',
  'ho.confirmComplete': 'Позначити передачу для «{name}» завершеною? Партнер бачитиме справу лише для читання.',
  'ho.revoked': 'Передачу відкликано',
  'ho.completed': 'Передачу завершено',
  'ho.log.show': 'Журнал доступу ({n})',
  'ho.log.hide': 'Сховати журнал доступу',
  'ho.log.empty': 'Партнер ще нічого не відкривав',
  'ho.log.when': 'Коли',
  'ho.log.who': 'Хто',
  'ho.log.what': 'Що',
  'ho.log.action.view': 'переглянув справу',
  'ho.log.action.document_download': 'завантажив документ',
  'ho.log.action.document_upload': 'додав документ',
  'ho.log.action.progress_update': 'оновив етап',
  'ho.log.action.respond': 'відповів на передачу',
  // batch: ws-core — робочі простори
  'ws.title.sales': 'Продажі',
  'ws.title.cases': 'Справи',
  'ws.title.ritual': 'Ритуальні послуги в Україні',
  'ws.title.transport': 'Перевезення й партнери',
  'ws.title.production': 'Виробництво й склад',
  'ws.title.marketing': 'Маркетинг',
  'ws.title.money': 'Гроші',
  'ws.title.quality': 'Якість і зворотний звʼязок',
  'ws.title.overview': 'Огляд власника',
  'ws.title.settings': 'Налаштування',
  'ws.menu.home': 'Головна',
  'ws.menu.today': 'Мій день',
  'ws.menu.leads': 'Заявки',
  'ws.menu.inbox': 'Повідомлення',
  'ws.menu.tasks': 'Задачі',
  'ws.menu.cases': 'Справи',
  'ws.menu.documents': 'Документи',
  'ws.menu.planner': 'Планування',
  'ws.menu.ritual': 'Можливості',
  'ws.menu.products': 'Товари',
  'ws.menu.fleet': 'Рейси і місця',
  'ws.menu.handovers': 'Передані нам',
  'ws.menu.partners': 'Партнерські компанії',
  'ws.menu.freight': 'Поставки з цеху',
  'ws.menu.inventory': 'Залишки',
  'ws.menu.orders': 'Замовлення',
  'ws.menu.marketing': 'Джерела і конверсія',
  'ws.menu.channels': 'Канали продажу',
  'ws.menu.money': 'Платежі',
  'ws.menu.invoices': 'Рахунки',
  'ws.menu.pricing': 'Ціни',
  'ws.menu.audit': 'Журнал змін',
  'ws.menu.quality': 'Звернення',
  'ws.menu.overview': 'Огляд',
  'ws.menu.control': 'Показники й цілі',
  'ws.menu.users': 'Користувачі',
  'ws.menu.workspaces': 'Робочі простори',
  'ws.menu.sites': 'Сайти',
  'ws.menu.processes': 'Процеси',
  'ws.menu.countries': 'Країни',
  'ws.menu.dictionaries': 'Властивості товарів',
  'ws.menu.vehicleTypes': 'Місткість машин',
  'ws.switch': 'Робочий простір',
  'ws.switchFailed': 'Не вдалося перемкнути робочий простір',
  'ws.notCounted': 'ще не рахується',
  'ws.open': 'Відкрити',
  'ws.recent': 'Останні',
  'ws.emptyItems': 'Поки що тут порожньо',
  'ws.team': 'Команда',
  'ws.teamPerson': 'Людина',
  'ws.teamOpenCases': 'Справ у роботі',
  'ws.directorNote': 'Ви директор напряму: бачите всі справи простору в усіх країнах.',
  'ws.overview.hint': 'Одне головне число з кожного напряму. Натисніть плитку, щоб перейти в простір.',
  'ws.overview.asOf': 'Оновлено о {at}',
  'ws.settings.hint':
    'Кожна людина бачить простори своєї ролі (позначено галочкою). Тут можна відкрити ще простори і призначити директора напряму — він бачить усе у своєму просторі в усіх країнах.',
  'ws.settings.person': 'Людина',
  'ws.settings.byRole': 'Є за роллю',
  'ws.settings.grant': 'Відкрити доступ',
  'ws.settings.revoke': 'Закрити доступ',
  'ws.settings.director': 'Директор напряму',
  'ws.settings.makeDirector': 'Зробити директором напряму',
  'ws.settings.unmakeDirector': 'Зняти з директора напряму',
  'ws.settings.saved': 'Збережено',
  'ws.settings.ownerAll': 'Власник має всі простори',
  // --- batch: C-ritual
  'rit.title': 'Ритуальні послуги',
  'rit.subtitle': 'Допродаж після репатріації в Україну: труна, атрибутика, церемонія, поховання.',
  'rit.new': 'Нова можливість',
  'rit.stage.new': 'Нова можливість',
  'rit.stage.contacted': 'Звʼязались',
  'rit.stage.proposal': 'Пропозиція',
  'rit.stage.agreed': 'Погоджено',
  'rit.stage.done': 'Виконано',
  'rit.stage.declined': 'Відмова',
  'rit.viewLabel': 'Вигляд',
  'rit.view.board': 'Дошка',
  'rit.view.list': 'Список',
  'rit.whoLabel': 'Чиї можливості',
  'rit.who.all': 'Усі',
  'rit.who.mine': 'Мої',
  'rit.search': 'Номер, справа, померлий, замовник',
  'rit.empty': 'Поки немає жодної можливості. Вона зʼявляється сама, коли справу доставлено в Україну, або натисніть «Нова можливість».',
  'rit.emptyFiltered': 'Нічого не знайдено',
  'rit.emptyStage': 'Порожньо',
  'rit.col.number': 'Номер',
  'rit.col.deceased': 'Померлий',
  'rit.col.case': 'Справа',
  'rit.col.stage': 'Етап',
  'rit.col.value': 'Сума',
  'rit.col.assignee': 'Відповідальний',
  'rit.col.updated': 'Оновлено',
  'rit.noAssignee': 'не призначено',
  'rit.monthDone': 'Виручка цього місяця',
  'rit.inWork': 'У роботі',
  'rit.create.case': 'Справа',
  'rit.create.caseSearch': 'Номер справи або прізвище',
  'rit.create.pickCase': 'Оберіть справу зі списку',
  'rit.create.noCases': 'Справ не знайдено',
  'rit.create.change': 'Інша справа',
  'rit.create.note': 'Нотатка',
  'rit.create.submit': 'Створити',
  'rit.create.done': 'Можливість створено',
  'rit.caseBadge': 'Справа {number}',
  'rit.openCase': 'Відкрити справу',
  'rit.contact': 'Контакт',
  'rit.noContact': 'Контакт не вказано',
  'rit.assignee': 'Відповідальний',
  'rit.note': 'Нотатка',
  'rit.notePlaceholder': 'Що запропонували, про що домовились…',
  'rit.save': 'Зберегти',
  'rit.saved': 'Збережено',
  'rit.value': 'Сума',
  'rit.valueManual': 'Орієнтовна сума (поки перелік порожній)',
  'rit.history': 'Історія етапів',
  'rit.historyAuto': 'автоматично, коли справа перейшла в ритуальні послуги',
  'rit.next': 'Далі: {stage}',
  'rit.stageChanged': 'Етап: {stage}',
  'rit.closedAt': 'Закрито {date}',
  'rit.reason': 'Причина: {reason}',
  'rit.decline': 'Відмова',
  'rit.declineTitle': 'Родина відмовилась',
  'rit.declineReason': 'Причина відмови',
  'rit.declineHint': 'Наприклад: дорого, організують самі, обрали іншу фірму',
  'rit.declineSubmit': 'Позначити відмову',
  'rit.confirmDone': 'Позначити можливість виконаною? Після цього її не можна буде змінити.',
  'rit.confirmDoneTitle': 'Позначити виконаною?',
  'rit.confirmDoneSubmit': 'Так, виконано',
  'rit.items': 'Товари й послуги',
  'rit.items.empty': 'Ще нічого не додано. Додайте товар з каталогу або послугу.',
  'rit.items.addProduct': 'Додати товар',
  'rit.items.addService': 'Додати послугу',
  'rit.items.kind.product': 'Товар',
  'rit.items.kind.service': 'Послуга',
  'rit.items.title': 'Назва',
  'rit.items.qty': 'Кількість',
  'rit.items.price': 'Ціна за одиницю',
  'rit.items.total': 'Разом',
  'rit.items.remove': 'Прибрати',
  'rit.items.save': 'Зберегти перелік',
  'rit.items.saved': 'Перелік збережено',
  'rit.items.reset': 'Скасувати зміни',
  'rit.items.servicePh': 'Напр. церемонія прощання',
  'rit.items.pick': 'Товар з каталогу',
  'rit.items.locked': 'Можливість закрита — перелік змінювати не можна.',
  'rit.items.unsaved': 'Є незбережені зміни',
  'rit.items.badPrice': 'Перевірте ціну в рядку {n}',
  'rit.items.badTitle': 'Вкажіть назву послуги в рядку {n}',
  'rit.err.stage_order': 'Етапи йдуть по черзі — спершу попередній.',
  'rit.err.stage_backwards': 'Повернути на попередній етап не можна.',
  'rit.err.stage_final': 'Можливість уже закрита.',
  'rit.err.stage_changed': 'Етап щойно змінив хтось інший — оновіть сторінку.',
  'rit.err.value_from_items': 'Суму рахують з переліку товарів і послуг.',
  'rit.err.duplicate': 'Для цієї справи вже є відкрита можливість.',
  'rit.err.no_price': 'У товару немає ціни в прайсі — вкажіть ціну вручну.',
  // batch: B-case-flow
  'flow.workspace': 'Простір',
  'flow.allWorkspaces': 'Усі простори',
  'flow.ws.sales': 'Продажі',
  'flow.ws.cases': 'Справи',
  'flow.ws.transport': 'Перевезення',
  'flow.ws.ritual': 'Ритуальні послуги',
  'flow.now': 'Зараз у просторі',
  'flow.move': 'Перемістити',
  'flow.moveTitle': 'Перемістити справу в інший простір',
  'flow.moveHint': 'Зазвичай справа переходить сама: після договору, коли документи готові, після доставки. Переміщуйте вручну лише коли треба інакше.',
  'flow.target': 'Куди',
  'flow.note': 'Чому (необовʼязково)',
  'flow.notePh': 'Напр. родина вже підписала договір у відділенні',
  'flow.moved': 'Справу переміщено',
  'flow.history': 'Шлях справи',
  'flow.historyEmpty': 'Справа ще не переходила між просторами',
  'flow.line': 'Справа перейшла: {from} → {to}',
  'flow.lineFirst': 'Справа зʼявилась у просторі «{to}»',
  'flow.by': 'хто: {name}',
  'flow.auto': 'автоматично',
  'flow.showAll': 'Уся історія ({n})',
  'flow.chips': 'Фільтр за простором',
  'ws.rule.new': 'нова заявка, договору ще немає',
  'ws.rule.contract_signed': 'договір підписано',
  'ws.rule.docs_ready': 'документи готові — час везти',
  'ws.rule.delivered': 'тіло доставлено',
  'ws.rule.delivered_ua': 'тіло доставлено в Україну — можна запропонувати ритуальні послуги',
  'ws.rule.manual': 'переміщено вручну',
  'ws.rule.backfill': 'простір визначено під час запуску',
  'ws.rule.keep_final': 'справу закрито',
  // --- batch: D-quality
  'qa.title': 'Якість і зворотний звʼязок',
  'qa.subtitle': 'Скарги й відгуки родин, проблеми та ідеї від партнерів і колег.',
  'qa.add': 'Додати',
  'qa.newTitle': 'Нове звернення',
  'qa.created': 'Звернення додано',
  'qa.saved': 'Збережено',
  'qa.empty': 'Звернень ще немає. Додайте першу скаргу чи відгук кнопкою «Додати».',
  'qa.notFound': 'Звернення не знайдено або воно в іншій компанії.',
  'qa.back': 'До звернень',
  'qa.summaryOpen': '{n|відкрите звернення|відкриті звернення|відкритих звернень}',
  'qa.summaryOldest': 'найдовше чекає {days|день|дні|днів}',
  'qa.avgRating': 'середня оцінка за 30 днів: {r}',
  'qa.kindLabel': 'Вид',
  'qa.kind.complaint': 'Скарга',
  'qa.kind.review': 'Відгук',
  'qa.kind.problem': 'Проблема',
  'qa.kind.idea': 'Ідея',
  'qa.sourceLabel': 'Від кого',
  'qa.source.family': 'Родина',
  'qa.source.partner': 'Партнер',
  'qa.source.staff': 'Колега',
  'qa.statusLabel': 'Статус',
  'qa.allStatuses': 'Усі статуси',
  'qa.status.new': 'Нове',
  'qa.status.in_progress': 'В роботі',
  'qa.status.fixed_in_crm': 'Виправлено в CRM',
  'qa.status.closed': 'Закрито',
  'qa.status.rejected': 'Відхилено',
  'qa.onlyOpen': 'Ще не закриті',
  'qa.mine': 'Мої',
  'qa.searchPh': 'Пошук: текст, номер, справа',
  'qa.col.what': 'Що сталося',
  'qa.col.link': 'Справа / партнер',
  'qa.col.assignee': 'Відповідальний',
  'qa.col.status': 'Статус',
  'qa.col.created': 'Додано',
  'qa.caseN': 'Справа {n}',
  'qa.orderN': 'Замовлення {n}',
  'qa.titleLabel': 'Коротко, що сталося',
  'qa.titlePh': 'Напр.: запізнилися на прощання',
  'qa.bodyLabel': 'Подробиці',
  'qa.rating': 'Оцінка',
  'qa.ratingN': 'Оцінка {n} з 5',
  'qa.partner': 'Партнер',
  'qa.reporter': 'Хто повідомив',
  'qa.reporterContact': 'Як звʼязатися',
  'qa.reporterContactPh': 'Телефон або email',
  'qa.case': 'Справа',
  'qa.caseSearch': 'Знайти справу',
  'qa.caseSearchPh': 'Номер або прізвище',
  'qa.caseHint': 'Почніть вводити номер справи',
  'qa.casePick': 'Оберіть справу',
  'qa.order': 'Замовлення',
  'qa.contact': 'Контакт',
  'qa.assignee': 'Відповідальний',
  'qa.owner': 'Власник звернення',
  'qa.ownerHint': 'Хто стежить, щоб звернення закрили',
  'qa.what': 'Що сталося',
  'qa.noBody': 'Подробиць немає.',
  'qa.resolution': 'Рішення',
  'qa.resolutionPh': 'Що зробили, щоб це не повторилося',
  'qa.resolutionRequired': 'Щоб позначити «Виправлено в CRM», опишіть рішення.',
  'qa.fixedAt': 'виправлено {at}',
  'qa.manage': 'Хто і що робить',
  'qa.changeTo': 'змінити на…',
  'qa.finalHint': 'Звернення закрите — змінити його вже не можна.',
  'qa.fixedHint': '«Виправлено в CRM» — лише з описаним рішенням.',
  'qa.links': 'Повʼязано',
  'qa.createdAt': 'Додано',
  'qa.closedAt': 'Закрито',
  'qa.history': 'Історія і коментарі',
  'qa.commentPh': 'Коментар для колег…',
  'qa.addComment': 'Додати коментар',
  'qa.noEvents': 'Поки нічого.',
  'qa.partnerTag': 'партнер',
  'qa.ev.created': 'Додав(ла) звернення',
  'qa.ev.createdPartner': 'Партнер надіслав звернення',
  'qa.ev.status': 'Статус: {from} → {to}',
  'qa.ev.assigned': 'Доручено: {name}',
  'qa.ev.unassigned': 'Відповідального знято',
  'qa.ev.comment': 'Коментар',
  // --- batch: F-money
  'money.title': 'Гроші',
  'money.subtitle': 'Платежі й рахунки за місяць',
  'money.noAccess': 'Розділ «Гроші» бачать власник і бухгалтер.',
  'money.month': 'Місяць',
  'money.prevMonth': 'Попередній місяць',
  'money.nextMonth': 'Наступний місяць',
  'money.searchPh': 'Номер, справа, нотатка',
  'money.tab.payments': 'Платежі',
  'money.tab.invoices': 'Рахунки',
  'money.dir.in': 'Надходження',
  'money.dir.out': 'Виплата',
  'money.kind.customer': 'Від клієнта',
  'money.kind.partner': 'Партнеру',
  'money.kind.refund': 'Повернення',
  'money.kind.other': 'Інше надходження',
  'money.method.bank': 'Банк',
  'money.method.card': 'Картка',
  'money.method.cash': 'Готівка',
  'money.method.online': 'Онлайн',
  'money.status.draft': 'Чернетка',
  'money.status.issued': 'Виставлено',
  'money.status.paid': 'Оплачено',
  'money.status.cancelled': 'Скасовано',
  'money.statusFilter.draft': 'Чернетки',
  'money.statusFilter.issued': 'Не оплачені',
  'money.statusFilter.paid': 'Оплачені',
  'money.statusFilter.cancelled': 'Скасовані',
  'money.col.date': 'Дата',
  'money.col.number': 'Номер',
  'money.col.kind': 'Що це',
  'money.col.case': 'Справа',
  'money.col.order': 'Замовлення',
  'money.col.invoice': 'Рахунок',
  'money.col.method': 'Спосіб',
  'money.col.amount': 'Сума',
  'money.col.by': 'Вніс',
  'money.col.status': 'Стан',
  'money.col.payer': 'Платник',
  'money.col.issued': 'Виставлено',
  'money.col.total': 'Сума',
  'money.col.unpaid': 'Не оплачено',
  'money.col.actions': 'Дії',
  'money.sum.received': 'Отримано',
  'money.sum.invoiced': 'Виставлено',
  'money.sum.outstanding': 'Не оплачено',
  'money.sum.partners': 'Партнерам',
  'money.sum.outstandingHint': 'за всіма виставленими рахунками',
  'money.sum.noCaseHint':
    'З них {amount} — платежі без справи: у них немає країни, тож вони входять у підсумок кожної країни. Суми окремих країн разом можуть бути більшими, ніж для «Усі».',
  'money.sum.partnersHint': 'зараз 0 — партнери працюють безкоштовно (тестування)',
  'money.sum.refundHint': 'з них повернуто {amount}',
  'money.sum.otherHint': 'з них інші надходження {amount}',
  'money.sum.byWeek': 'Надходження по тижнях',
  'money.sum.weekOf': 'з {date}',
  'money.sum.topCases': 'Найбільше отримали',
  'money.sum.noTop': 'Платежів по справах цього місяця ще немає.',
  'money.pay.add': 'Додати платіж',
  'money.pay.title': 'Новий платіж',
  'money.pay.titleInvoice': 'Оплата рахунку {number}',
  'money.pay.direction': 'Напрям',
  'money.pay.kind': 'Що це за платіж',
  'money.pay.method': 'Спосіб оплати',
  'money.pay.amount': 'Сума',
  'money.pay.currency': 'Валюта',
  'money.pay.date': 'Дата оплати',
  'money.pay.note': 'Нотатка',
  'money.pay.link': 'Справа або замовлення',
  'money.pay.linkCase': 'Справа {number}',
  'money.pay.linkOrder': 'Замовлення {number}',
  'money.pay.linkInvoice': 'Рахунок {number}',
  'money.pay.linkHint': 'Можна не вказувати — тоді платіж буде без привʼязки.',
  'money.pay.unlink': 'Змінити',
  'money.pay.searchLabel': 'Пошук справи або замовлення',
  'money.pay.searchPh': 'Номер справи, замовлення або імʼя',
  'money.pay.noMatches': 'Нічого не знайдено',
  'money.pay.submit': 'Зберегти платіж',
  'money.pay.saved': 'Платіж збережено',
  'money.pay.badAmount': 'Вкажіть суму більше нуля',
  'money.pay.futureDate': 'Дата оплати не може бути в майбутньому',
  'money.pay.fxHint': 'Суму в гривнях порахуємо за курсом НБУ на дату оплати.',
  'money.pay.partnerHint': 'Партнерам зараз не платимо — вони працюють безкоштовно (тестування).',
  'money.pay.remove': 'Видалити платіж',
  'money.pay.removeConfirm': 'Видалити платіж {number}? Якщо він закривав рахунок, рахунок знову стане неоплаченим.',
  'money.pay.removed': 'Платіж видалено',
  'money.pay.emptyMonth': 'За {month} платежів ще немає.',
  'money.inv.new': 'Новий рахунок',
  'money.inv.create': 'Створити чернетку',
  'money.inv.created': 'Чернетку рахунку створено',
  'money.inv.amount': 'Сума',
  'money.inv.amountFromOrder': 'Порожньо — сума замовлення',
  'money.inv.due': 'Оплатити до',
  'money.inv.dueShort': 'до {date}',
  'money.inv.needLink': 'Оберіть справу або замовлення',
  'money.inv.needAmount': 'Для рахунку на справу вкажіть суму',
  'money.inv.issue': 'Виставити',
  'money.inv.issued': 'Рахунок виставлено',
  'money.inv.issueForOrder': 'Виставити рахунок',
  'money.inv.cancel': 'Скасувати',
  'money.inv.cancelled': 'Рахунок скасовано',
  'money.inv.cancelConfirm': 'Скасувати рахунок {number}?',
  'money.inv.cancelConfirmPaid':
    'За рахунком {number} уже внесено {paid}. Скасувати його можна лише після повернення цих грошей (кнопка «Оплата» рахунку → «Виплата», вид «Повернення») або видалення оплати. Спробувати скасувати?',
  'money.inv.pay': 'Оплата',
  'money.inv.noPdf': 'Файла рахунку немає',
  'money.inv.empty': 'Рахунків немає.',
  'money.inv.allTime': 'за весь час',
  'money.inv.forMonth': 'за {month}',
  'money.panel.noAccess': 'Платежі бачать власник, бухгалтер і менеджер.',
  'money.panel.noPayments': 'Платежів ще немає.',
  'money.panel.noInvoices': 'Рахунків ще немає.',
  'money.order.section': 'Платежі',
  'money.err.invalid_reference': 'Справа, замовлення і рахунок не збігаються — перевірте, що обрали.',
  'money.err.currency_mismatch': 'Валюта платежу має збігатися з валютою рахунку.',
  'money.err.invoice_cancelled': 'Рахунок скасовано — оплату до нього не додати.',
  'money.err.invalid_status': 'Рахунок уже змінили — оновіть сторінку.',
  'money.err.invoice_has_payments': 'За рахунком уже внесено гроші. Спершу оформіть повернення (кнопка «Оплата» рахунку → «Виплата», вид «Повернення») або видаліть оплату, тоді рахунок можна скасувати.',
  'money.err.invoice_zero_total': 'Сума рахунку має бути більшою за нуль.',
  'money.err.case_or_order_required': 'Оберіть справу або замовлення',
  'money.err.total_required': 'Для рахунку на справу вкажіть суму',
  'money.err.invalid_currency': 'Невідома валюта',
  'money.err.invalid_month': 'Невірний місяць',
  // --- batch: E-marketing
  'leadSource.website_bot': 'Чат-бот сайту (старий)',
  'leadSource.ads': 'Реклама',
  'leadSource.referral': 'Рекомендація',
  'leadSource.other': 'Інше',
  'mk.title': 'Маркетинг',
  'mk.subtitle': 'Звідки приходять заявки і скільки з них стають справами',
  'mk.period': 'Період',
  'mk.days': '{n} днів',
  'mk.group': 'Групувати',
  'mk.group.source': 'Джерело',
  'mk.group.channel': 'Канал',
  'mk.group.site': 'Сайт',
  'mk.group.utm_source': 'Мітка: джерело',
  'mk.group.utm_campaign': 'Кампанія',
  'mk.group.utm_medium': 'Мітка: тип',
  'mk.col.leads': 'Заявки',
  'mk.col.bots': 'Схожі на бота',
  'mk.col.inProgress': 'У роботі',
  'mk.col.converted': 'Справи',
  'mk.col.lost': 'Втрачено',
  'mk.col.conversion': 'Конверсія',
  'mk.col.time': 'Час на сайті',
  'mk.total': 'Разом',
  'mk.kpi.leads': 'Заявок від людей',
  'mk.kpi.bots': 'Схожих на бота',
  'mk.kpi.converted': 'Стали справами',
  'mk.kpi.conversion': 'Конверсія',
  'mk.kpi.today': 'Сьогодні: {n}',
  'mk.conversionHint': 'Справи ÷ заявки від людей. Заявки, схожі на бота (автоматичні, спам), не враховуються.',
  'mk.countryFilter': 'Звіт лише по країнах: {list} — так обрано в перемикачі країни вгорі (або так обмежено ваш доступ).',
  'mk.botsConverted': '+{n} схожих на бота',
  'mk.botsConvertedHint': 'Заявки, позначені «схоже на бота», які все ж стали справою. У конверсію не входять.',
  'mk.openLeads': 'Відкрити заявки',
  'mk.empty': 'За цей період заявок немає',
  'mk.sites': 'Сайти за 30 днів',
  'mk.campaigns': 'Кращі кампанії за 30 днів',
  'mk.noCampaigns': 'Заявок з кампаній ще не було',
  'mk.lead.title': 'Джерело і поведінка',
  'mk.lead.source': 'Джерело',
  'mk.lead.channel': 'Канал',
  'mk.lead.utm': 'Мітки',
  'mk.lead.referrer': 'Прийшов з',
  'mk.lead.landing': 'Перша сторінка',
  'mk.lead.clicks': 'Кліки',
  'mk.lead.time': 'Час на сайті',
  'mk.lead.pages': 'Сторінки',
  'mk.lead.bot': 'Схоже на бота',
  'mk.lead.notBot': 'Не бот',
  'mk.lead.noData': 'Сайт не передав даних про відвідування',
  'mk.lead.edit': 'Змінити джерело',
  'mk.lead.saved': 'Джерело збережено',
  'mk.leads.source': 'Джерело',
  'mk.leads.bot': 'Схоже на бота',
  'mk.leads.onlyBots': 'Лише схожі на бота',
  // batch: p3-D — Налаштування → Мови (ui_locales / ui_translations, міграція 042)
  'settings.languages': 'Мови',
  'lang.intro': 'Тексти кабінету партнера і підписи в актах та рахунках. Нова мова з’являється в кабінеті партнера без змін у коді, щойно в ній є хоч один перекладений рядок; якщо рядок не перекладено — показується українською.',
  'lang.locales': 'Мови інтерфейсу',
  'lang.code': 'Код',
  'lang.codeHint': '2–3 латинські літери, напр. de або pt-br',
  'lang.name': 'Назва мови',
  'lang.active': 'Показувати',
  'lang.position': 'Порядок',
  'lang.strings': 'Рядків',
  'lang.add': 'Додати мову',
  'lang.added': 'Мову додано. Перекладіть тексти нижче — партнер побачить мову після першого збереженого рядка',
  'lang.saved': 'Мову збережено',
  'lang.deleted': 'Мову видалено',
  'lang.deleteConfirm': 'Видалити мову «{name}» разом з усіма її перекладами?',
  'lang.fallback': 'основна',
  'lang.fallbackHint': 'Українська — мова за замовчуванням: її не можна вимкнути чи видалити',
  'lang.badCode': 'Код мови: 2–3 малі латинські літери (можна з регіоном: pt-br)',
  'lang.exists': 'Така мова вже є',
  'lang.texts': 'Переклади',
  'lang.namespace': 'Розділ',
  'lang.ns.partner': 'Кабінет партнера',
  'lang.ns.docs': 'Акти й рахунки (PDF)',
  'lang.locale': 'Мова',
  'lang.search': 'Пошук за ключем або текстом',
  'lang.onlyMissing': 'Лише неперекладені',
  'lang.missing': 'Не перекладено: {n}',
  'lang.key': 'Ключ',
  'lang.source': 'Українською',
  'lang.text': 'Переклад',
  'lang.placeholder': 'Не перекладено — показується українською',
  'lang.save': 'Зберегти ({n})',
  'lang.savedN': 'Збережено рядків: {n}',
  'lang.export': 'Експорт JSON',
  'lang.import': 'Імпорт JSON',
  'lang.imported': 'Імпортовано, змінено рядків: {n}',
  'lang.importConfirm': 'Імпортувати {n} рядків у «{locale}»? Наявні переклади з тими самими ключами буде замінено.',
  'lang.err.json': 'Файл не є коректним JSON',
  'lang.err.object': 'Очікується плаский JSON-обʼєкт {"ключ": "текст"}',
  'lang.err.value': 'Значення мають бути текстом (рядком)',
  'lang.err.key': 'Ключ порожній або довший за 200 символів',
  'lang.err.empty': 'У файлі немає жодного рядка',
  'lang.err.tooMany': 'Забагато рядків в одному файлі (більше 5000)',
  'lang.empty': 'У цьому розділі ще немає рядків',
  'lang.noMatch': 'Нічого не знайдено',
  'lang.unsaved': 'Є незбережені зміни',
  'lang.more': 'Показано {shown} з {total} — уточніть пошук',
  // batch: p3-B — кроки перевезення з фото (міграція 040)
  'hs.step.picked_up': 'Забрав тіло',
  'hs.step.border_crossed': 'Перетнув кордон',
  'hs.step.customs_cleared': 'Пройшов митницю',
  'hs.step.delivered': 'Доставив',
  'hs.step.other': 'Інша подія',
  'hs.last': 'Останній крок',
  'hs.photos': '{n} фото',
  'hs.log.step': 'відмітив крок',
  // --- batch: p3-A
  'ws.rule.product_only': 'товари магазину — продажі / виробництво',
  'case.demo.badge': 'Демо',
  'case.demo.toggle': 'Демо / тестова справа',
  'case.demo.hint': 'Вигадані дані для навчання й перевірок. Таку справу можна передати партнерові без угоди про обробку даних.',
  'case.demo.filter': 'Лише демо',
  'case.demo.filterReal': 'Без демо',
  'case.demo.on': 'Справу позначено як демо',
  'case.demo.off': 'Позначку «демо» знято',
  // batch: p3-C — акти й рахунки передачі, DPA партнера, контекст звернення (міграція 041)
  'hd.steps.title': 'Кроки партнера',
  'hd.steps.empty': 'Партнер ще не відмітив жодного кроку.',
  'hd.steps.photo': 'Фото {n}',
  'hd.steps.map': 'На мапі',
  'hd.steps.by': 'відмітив(ла) {name}',
  'hd.acts.title': 'Акти і рахунки',
  'hd.acts.genAct': 'Сформувати акт',
  'hd.acts.genInvoice': 'Сформувати рахунок (0)',
  'hd.acts.hint': 'Двомовний PDF: українська і мова партнера. Оплата партнеру — 0 (безоплатне тестування).',
  'hd.acts.receivedHint': 'Документи, які сформував відправник. Сума — 0 (безоплатне тестування).',
  'hd.acts.needAccepted': 'Сформувати можна, коли партнер прийме передачу.',
  'hd.acts.empty': 'Актів і рахунків ще немає.',
  'hd.acts.kind.act': 'Акт',
  'hd.acts.kind.invoice': 'Рахунок',
  'hd.acts.generatedAct': 'Акт сформовано',
  'hd.acts.generatedInvoice': 'Рахунок {number} на 0 сформовано',
  'hd.acts.download': 'Завантажити',
  'hd.acts.free': 'безоплатно',
  'hd.sponsor.title': 'Передача · {number}',
  'hd.sponsor.to': 'Партнер: {name}',
  'hd.sponsor.toCase': 'Відкрити справу',
  'hd.notFound': 'Передачу не знайдено або вона вам недоступна.',
  'pc.dpa.toggle': 'Договір про обробку даних (DPA) підписано',
  'pc.dpa.hint': 'без DPA партнеру можна передавати лише демо/тестові справи',
  'pc.dpa.col': 'DPA',
  'pc.dpa.signed': 'підписано',
  'pc.dpa.signedAt': 'підписано {date}',
  'pc.dpa.none': 'немає — лише демо',
  'pc.dpa.on': 'DPA позначено як підписаний',
  'pc.dpa.off': 'Позначку DPA знято',
  'pc.dpa.demoOnly': 'без DPA — лише демо',
  'pc.dpa.blocked': 'У цього партнера немає DPA: передати можна лише демо/тестову справу.',
  'pc.dpa.required': 'Партнер ще не підписав договір про обробку даних (DPA). Без нього передавати можна лише демо/тестові справи.',
  'qd.context.title': 'Контекст звернення',
  'qd.context.screen': 'Екран',
  'qd.context.url': 'Адреса сторінки',
  'qd.context.app_version': 'Версія застосунку',
  'qd.context.locale': 'Мова',
  'qd.context.user_agent': 'Пристрій / браузер',
  'qd.context.case_number': 'Справа',
  // batch: p4-C — призначення за країною (049)
  'case.assign.byCountry': 'за правилом країни ({country})',
  'case.assign.ruleHint': 'Справу призначено типовому менеджеру країни (Налаштування → Країни).',
  'case.assign.button': 'Призначити за країною',
  'case.assign.done': 'Призначено: {name}',
  'case.assign.noRule': 'Для країн цієї справи не задано типового менеджера.',
  'countries.preset.title': 'Готові правила країни',
  'countries.preset.unverified': 'Не перевірено',
  'countries.preset.apply': 'Додати правила',
  'countries.preset.applied': 'Додано правил: {n}',
  // batch: p4-D
  'money.currency.label': 'Валюта справи',
  'money.currency.source.case': 'вибрано вручну',
  'money.currency.source.country': 'за країною призначення',
  'money.currency.source.site': 'за сайтом справи',
  'money.currency.source.base': 'типово',
  'money.currency.auto': 'Автоматично',
  'money.currency.change': 'Змінити валюту справи',
  'money.currency.changed': 'Валюту справи змінено: {currency}',
  'money.currency.locked': 'Валюту не змінити — є виставлений рахунок № {number}',
  'money.currency.notEnabled': 'Валюту країни вимкнено в налаштуваннях валют — рахуємо в гривнях.',
  'money.currency.rate': 'Курс НБУ: 1 {currency} = {rate} грн ({date}), націнка {markup} %',
  'money.currency.byCurrency': 'За валютами',
  'money.currency.col': 'Валюта',
  'money.currency.inUah': 'у гривнях',
  'money.currency.planHint': 'Ціни з плану перераховано за курсом НБУ + націнка',
  'money.currency.orderCurrency': 'Валюта',
  'money.currency.err.currency_locked': 'Валюту не змінити — у справі вже є виставлений рахунок або підтверджене замовлення в іншій валюті.',
  'money.currency.err.currency_not_supported': 'Ця валюта не увімкнена в налаштуваннях валют.',
  'money.currency.err.fx_rate_missing': 'Немає курсу НБУ для цієї валюти — оновіть курси.',
  // batch: p4-A — від кого чекаємо документи, нагадування, «Чого чекаємо і від кого» (047)
  'nav.waiting': 'Чого чекаємо',
  'waiting.title': 'Чого чекаємо і від кого',
  'waiting.subtitle': 'Документи відкритих справ, яких ще немає: від кого чекаємо, до коли і що робити',
  'waiting.total': 'Всього',
  'waiting.overdue': 'Прострочено',
  'waiting.today': 'Сьогодні',
  'waiting.groupLabel': 'Групувати',
  'waiting.byParty': 'За стороною',
  'waiting.byCase': 'За справою',
  'waiting.party': 'Сторона',
  'waiting.country': 'Країна',
  'waiting.workspace': 'Простір',
  'waiting.manager': 'Менеджер',
  'waiting.allParties': 'Усі сторони',
  'waiting.allCountries': 'Усі країни',
  'waiting.allWorkspaces': 'Усі простори',
  'waiting.allManagers': 'Усі менеджери',
  'waiting.mine': 'Мої справи',
  'waiting.onlyOverdue': 'Лише прострочені',
  'waiting.searchPh': 'Справа, померлий, від кого…',
  'waiting.empty': 'Усі документи на місці — чекати нічого.',
  'waiting.col.document': 'Документ',
  'waiting.col.case': 'Справа',
  'waiting.col.party': 'Від кого',
  'waiting.col.due': 'Термін',
  'waiting.col.reminders': 'Нагадування',
  'waiting.col.actions': 'Дії',
  'waiting.call': 'Подзвонити',
  'waiting.help': 'Що робити?',
  'waiting.optional': 'необовʼязковий — справу не блокує',
  'waiting.noDate': 'без терміну',
  'waiting.overdueBy': 'прострочено на {n} дн.',
  'waiting.dueToday': 'сьогодні',
  'waiting.dueTomorrow': 'завтра',
  'waiting.dueIn': 'через {n} дн.',
  'waiting.groupOverdue': 'прострочено: {n}',
  'waiting.limitHint': 'Показано перші {n} документів — звузьте фільтри.',
  'waiting.runReminders': 'Нагадати за терміном',
  'waiting.runDone': 'Нагадувань створено: {n}',
  'party.kind.family': 'Родина',
  'party.kind.morgue': 'Морг / лікарня',
  'party.kind.consulate': 'Консульство',
  'party.kind.translator': 'Перекладач',
  'party.kind.notary': 'Нотаріус',
  'party.kind.partner': 'Партнер',
  'party.kind.staff': 'Наші співробітники',
  'party.kind.other': 'Інше',
  'party.waitingFrom': 'Чекаємо від: {party}',
  'party.until': 'до {date}',
  'party.edit': 'Від кого і до коли',
  'party.change': 'Змінити',
  'party.kindLabel': 'Хто має дати документ',
  'party.contact': 'Контакт зі справи',
  'party.noContact': '— без контакту —',
  'party.name': 'Назва або імʼя',
  'party.namePh': 'напр. Spital Chișinău',
  'party.phone': 'Телефон',
  'party.expected': 'Чекаємо до',
  'party.expectedPast': 'Ця дата вже минула: пункт одразу стане простроченим, а родина побачить «Потрібно до» з минулою датою',
  'party.remindBefore': 'Нагадати за, днів',
  'party.saved': 'Збережено',
  'doc.remind': 'Нагадати',
  'doc.remind.sentEmail': 'Нагадування надіслано родині на e-mail',
  'doc.remind.sentSms': 'Нагадування надіслано родині SMS',
  'doc.remind.logged': 'Записано в історію справи',
  'doc.remind.loggedCall': 'Записано в історію, зателефонуйте: {phone}',
  'doc.remindCount': 'нагадувань: {n}',
  'doc.received': 'Отримано без файлу',
  'doc.received.short': 'Отримано',
  'doc.received.title': 'Документ отримано без файлу',
  'doc.received.hint': 'Оригінал привезли або показали на місці. Документ буде позначено прийнятим; файл можна додати пізніше.',
  'doc.received.note': 'Примітка (необовʼязково)',
  'doc.received.notePh': 'напр. оригінал у сейфі офісу',
  'doc.received.confirm': 'Позначити отриманим',
  'doc.received.done': 'Документ позначено отриманим',
  'doc.receivedAt': 'отримано {date}',
  'event.checklist_party_updated': 'Змінено, від кого чекаємо документ',
  'event.document_reminder': 'Нагадування про документ',
  // batch: p4-B — інструкції й контакти країн, «Що робити?», право «редагує правила країн», винятки, зберігання (048)
  'countries.tab.guides': 'Інструкції',
  'countries.tab.contacts': 'Контакти',
  'countries.tab.defaults': 'Типово для справ',
  'countries.defaults.manager': 'Менеджер справ країни',
  'countries.defaults.managerHint': 'нова справа з цією країною дістається йому',
  'countries.defaults.managerLabel': 'Менеджер',
  'countries.defaults.noManager': 'Не призначати автоматично',
  'countries.defaults.match': 'Коли застосовувати',
  'countries.defaults.matchOpt.dest': 'за країною призначення',
  'countries.defaults.matchOpt.origin': 'за країною відправлення',
  'countries.defaults.matchOpt.both': 'обома',
  'countries.defaults.currency': 'Валюта справ',
  'countries.defaults.currencyHint': 'для справ, де країна — місце призначення',
  'countries.defaults.currencyLabel': 'Валюта',
  'countries.defaults.currencySite': 'Як на сайті',
  'countries.defaults.notYet': 'Ще не доступно — це налаштування зʼявиться з наступним оновленням.',
  'guides.intro': 'Що робити і кому дзвонити: загальна інструкція країни і окремі — до документа, дії чи етапу плану. Їх видно в справі за кнопкою «Що робити?».',
  'guides.readOnly': 'лише перегляд',
  'guides.add': 'Інструкція',
  'guides.new': 'Нова інструкція',
  'guides.edit': 'Інструкція',
  'guides.empty': 'Інструкцій ще немає.',
  'guides.emptyBody': 'Тексту ще немає — лише поради з досвіду.',
  'guides.saved': 'Інструкцію збережено',
  'guides.removed': 'Інструкцію видалено',
  'guides.removeConfirm': 'Видалити інструкцію разом з порадами?',
  'guides.target': 'До чого',
  'guides.target.general': 'Загальне',
  'guides.target.document': 'Документ',
  'guides.target.action': 'Дія',
  'guides.target.block': 'Етап плану',
  'guides.pick': 'Оберіть…',
  'guides.noActions': 'У правилах країни ще немає дій.',
  'guides.roleLabel': 'Коли країна',
  'guides.role.any': 'будь-яка роль',
  'guides.role.origin': 'відправлення',
  'guides.role.dest': 'призначення',
  'guides.role.transit': 'транзит',
  'guides.title': 'Назва (необовʼязково)',
  'guides.body': 'Що робити',
  'guides.bodyHint': 'Пишіть кроками: 1) … 2) …',
  'guides.contacts': 'Кому дзвонити',
  'guides.noContactsHint': 'Спершу додайте контакти країни на вкладці «Контакти».',
  'guides.tips': 'Поради з досвіду: {n}',
  'guides.tipAdd': 'Додати пораду',
  'guides.tipPlaceholder': 'Що допомогло в справі, кому краще дзвонити…',
  'guides.tipAdded': 'Пораду додано',
  'guides.tipRemoved': 'Пораду видалено',
  'guides.tipAuthorUnknown': 'Невідомо',
  'guides.updated': 'Оновлено {date}',
  'guides.verified': 'перевірено',
  'guides.verifiedLabel': 'Контакт перевірено',
  'guides.noContacts': 'Контактів ще немає.',
  'guides.contactAdd': 'Контакт',
  'guides.contactNew': 'Новий контакт',
  'guides.contactEdit': 'Контакт',
  'guides.contactKind': 'Хто це',
  'guides.contactName': 'Назва або імʼя',
  'guides.contactRole': 'Посада / роль',
  'guides.contactHours': 'Години роботи',
  'guides.contactAddress': 'Адреса',
  'guides.contactSaved': 'Контакт збережено',
  'guides.contactRemoved': 'Контакт видалено',
  'guides.contactRemoveTitle': 'Видалити контакт?',
  'guides.contactRemoveText': '«{name}» зникне з контактів країни та з інструкцій.',
  'guides.kind.consulate': 'Консульство',
  'guides.kind.morgue': 'Морг',
  'guides.kind.hospital': 'Лікарня',
  'guides.kind.partner': 'Партнер',
  'guides.kind.translator': 'Перекладач',
  'guides.kind.notary': 'Нотаріус',
  'guides.kind.broker': 'Брокер',
  'guides.kind.crematorium': 'Крематорій',
  'guides.kind.registry': 'РАЦС / реєстрація',
  'guides.kind.other': 'Інше',
  'help.open': 'Що робити?',
  'help.title': 'Що робити',
  'help.titleFor': 'Що робити: {name}',
  'help.noCountries': 'У справі не вказано країн.',
  'help.blockedBy': 'Щоб перейти далі, бракує: {list}',
  'help.callFirst': 'Кому дзвонити першим',
  'help.party': 'Від кого чекаємо в цій справі',
  'help.callFirstCountry': 'Контакт країни',
  'help.steps': 'Наступні кроки',
  'help.noSteps': 'Інструкції для цього ще немає. Додайте пораду нижче — вона стане початком інструкції.',
  'help.source.guide': 'інструкція',
  'help.source.rule': 'правило',
  'help.source.tip': 'порада',
  'help.exceptions': 'Винятки в цій справі',
  'help.whom': 'Кому дзвонити',
  'help.noContacts': 'Контактів країн справи ще немає.',
  'help.editGuide': 'Редагувати інструкцію {code}',
  'help.addTip': 'Додати пораду в інструкцію',
  'help.addTipBtn': 'Додати пораду',
  'help.tipCountry': 'Країна',
  'help.tipPlaceholder': 'Що спрацювало в цій справі — побачать усі, з вашим імʼям і датою',
  'help.tipAdded': 'Пораду додано в інструкцію країни',
  'help.exception': 'Виняток у цій справі',
  'help.exceptionTitle': 'Виняток з правила країни',
  'help.exceptionText': '«{name}» у цій справі не знадобиться. Причина буде видна в історії справи.',
  'help.exceptionReason': 'Причина',
  'help.exceptionSave': 'Зберегти виняток',
  'help.exceptionDone': 'Виняток збережено',
  'grants.col': 'Окремі права',
  'grants.country_rules': 'Редагує правила країн',
  'grants.always': 'правила країн — завжди',
  'grants.hint': 'owner, менеджери і директор напряму «Справи» мають право «Редагує правила країн» завжди; іншим його дає owner.',
  'retention.title': 'Зберігання документів',
  'retention.note': 'Документи справ не видаляються автоматично. Строк зберігання визначить бухгалтер; доти жодна задача нічого не видаляє.',
  'event.rule_exception': 'Виняток із правила країни',
  'event.tip_added': 'Додано пораду в інструкцію',
  // --- batch: p5-F
  'case.tab.family': 'Родина',
  'family.notConnected': 'Ще не підключено',
  'family.notConnectedHint': 'Цей розділ запрацює, щойно оновиться сервер.',
  'family.steps.title': 'Кроки для родини',
  'family.now': 'Родина бачить',
  'family.nowHint': 'Останній крок, який бачить родина. Кроки рахуються окремо від етапу справи — етап змінюйте кнопкою переходу.',
  'family.steps.aside': 'Що родина бачить у кабінеті',
  'family.steps.empty': 'Для цієї послуги родина не бачить кроків.',
  'family.steps.privacy': 'Родина бачить лише назви кроків і дати — без місця, фото й назв партнерів.',
  'family.step.accepted': 'Прийняли справу',
  'family.step.docs_collecting': 'Збираємо документи',
  'family.step.docs_ready': 'Документи готові',
  'family.step.picked_up': 'Тіло забрали',
  'family.step.in_transit': 'У дорозі',
  'family.step.border_crossed': 'Перетнули кордон',
  'family.step.delivered': 'Доставили',
  'family.step.burial': 'Поховання',
  'family.state.done': 'Виконано',
  'family.state.current': 'Зараз',
  'family.state.next': 'Далі',
  'family.notReached': 'ще не досягнуто',
  'family.source.stage': 'авто: за етапом',
  'family.source.checklist': 'авто: за чеклістом',
  'family.source.transport': 'авто: за кроком перевезення',
  'family.source.handover': 'авто: за кроком партнера',
  'family.source.trip': 'авто: за рейсом',
  'family.source.ritual': 'авто: за ритуальною воронкою',
  'family.source.rule': 'авто',
  'family.source.manual': 'вручну',
  'family.step.mark': 'Позначити виконаним',
  'family.step.revert': 'Скасувати',
  'family.step.markAria': 'Позначити виконаним: {name}',
  'family.step.revertAria': 'Скасувати крок: {name}',
  'family.step.markTitle': 'Крок «{name}» виконано',
  'family.step.revertTitle': 'Зняти крок «{name}»',
  'family.step.markHint': 'Родина отримає одне повідомлення про цей крок.',
  'family.step.revertHint': 'Родині нічого не надсилаємо; крок зникне з кабінету як виконаний.',
  'family.step.at': 'Коли',
  'family.step.note': 'Примітка (для співробітників)',
  'family.step.noteHint': 'Чому змінюємо вручну — щонайменше 3 символи.',
  'family.step.back': 'Не змінювати',
  'family.step.save': 'Зберегти',
  'family.step.err.note': 'Напишіть примітку — щонайменше 3 символи.',
  'family.step.err.at': 'Вкажіть дату й час.',
  'family.step.err.future': 'Час не може бути в майбутньому.',
  'family.step.reachedToast': 'Крок оновлено. Родина отримає одне повідомлення.',
  'family.step.revertedToast': 'Крок знято. Родині нічого не надсилаємо.',
  'family.notify.title': 'Повідомлення родині',
  'family.notify.aside': 'Одне повідомлення на крок, уночі не надсилаємо',
  'family.notify.empty': 'Поки що нічого не надсилали.',
  'family.notify.col.date': 'Дата',
  'family.notify.col.to': 'Кому',
  'family.notify.col.channel': 'Канал',
  'family.notify.col.status': 'Статус',
  'family.notify.col.title': 'Заголовок',
  'family.notify.status.queued': 'Надішлемо вранці',
  'family.notify.status.sent': 'Надіслано',
  'family.notify.status.logged': 'Записано (канал не налаштовано)',
  'family.notify.status.failed': 'Не доставлено',
  'family.notify.status.skipped': 'Пропущено',
  'family.channel.email': 'E-mail',
  'family.channel.sms': 'SMS',
  'family.channel.telegram': 'Telegram',
  'family.channel.viber': 'Viber',
  'family.channel.whatsapp': 'WhatsApp',
  'family.channel.log': 'Журнал',
  'family.channel.auto': 'авто',
  'family.preferred.label': 'Бажаний канал',
  'family.preferred.hint': '«Авто» — e-mail або підключений месенджер, інакше SMS.',
  'family.preferred.saved': 'Бажаний канал збережено',
  'family.preferred.noContacts': 'У справі немає контакту замовника — нікому надсилати.',
  'family.feedback.title': 'Відгук',
  'family.feedback.aside': 'Один делікатний запит через 2–3 тижні після завершення',
  'family.feedback.none': 'Не заплановано',
  'family.feedback.scheduled': 'Заплановано на {date}',
  'family.feedback.sent': 'Надіслано {date}',
  'family.feedback.logged': 'Записано {date} (канал не налаштовано)',
  'family.feedback.answered': 'Відповіли {date}',
  'family.feedback.expired': 'Прострочено — родина не відповіла',
  'family.feedback.skipped': 'Не надсилали',
  'family.feedback.optedOut': 'Не надсилаємо — вимкнено для цієї справи',
  'family.feedback.openQuality': 'Відкрити в «Якості»',
  'family.feedback.switch': 'Не надсилати запит на відгук для цієї справи',
  'family.feedback.note': 'Чому не надсилаємо',
  'family.feedback.noteHint': 'Щонайменше 3 символи; бачать лише співробітники.',
  'family.feedback.confirm': 'Не надсилати',
  'family.feedback.optOutBy': 'Вимкнув(ла) {name} · {date}',
  'family.feedback.offToast': 'Запит на відгук для цієї справи не надсилатимемо.',
  'family.feedback.onToast': 'Запит на відгук знову ввімкнено.',
  'family.rating': 'Оцінка {n} з 5',
  // --- batch: p5-E — Налаштування → «Імпорт» (справи й ліди / дані старого бота, docs/IMPORT.md)
  'import.tab': 'Імпорт',
  'import.noAccess': 'Імпорт доступний власнику і менеджеру.',
  'import.intro':
    'Перенесіть поточні справи й дані старого бота сайту з таблиці. Завантажте шаблон, заповніть його, поверніть файл і перегляньте, що буде створено. Повторне завантаження того самого файлу оновлює записи, а не дублює їх. Родинам нічого не надсилається.',
  'import.step1': '1. Що імпортуємо',
  'import.step1Aside': 'Шаблон: перший рядок — назви колонок, другий — підказки, третій — приклад',
  'import.kind': 'Що імпортуємо',
  'import.kind.cases': 'Справи',
  'import.kind.leads': 'Ліди й дані бота',
  'import.kindHint.cases':
    'Померлий, родина, маршрут, етап, стан документів, менеджер, країна сайту і валюта. Обовʼязкові: номер у старій системі і країна сайту (UA, MD або PL).',
  'import.kindHint.leads':
    'Звернення з сайту, телефону й месенджерів і все, що зібрав старий бот: мітки реклами, сторінки, кліки, час на сайті, будь-які інші поля як JSON. Рядок зберігається повністю.',
  'import.templateCsv': 'Завантажити шаблон CSV',
  'import.templateXlsx': 'Завантажити шаблон XLSX',
  'import.step2': '2. Файл і перевірка',
  'import.limits': 'CSV або XLSX, до 5 МБ і 5000 рядків',
  'import.file': 'Файл',
  'import.reading': 'Читаємо і перевіряємо файл…',
  'import.readFailed': 'Не вдалося прочитати файл',
  'import.onlyCsvXlsx': 'Потрібен файл .csv або .xlsx. Збережіть таблицю в одному з цих форматів.',
  'import.tooLarge': 'Файл завеликий: до 5 МБ і 5000 рядків. Розділіть його на частини.',
  'import.emptyFile': 'Файл порожній.',
  'import.badFile': 'Не вдалося прочитати файл. Збережіть його як CSV UTF-8 або XLSX за шаблоном.',
  'import.summary': 'Підсумок перевірки',
  'import.chip.total': 'всього {n}',
  'import.chip.create': 'буде створено {n}',
  'import.chip.update': 'оновлено {n}',
  'import.chip.errors': 'з помилками {n}',
  'import.chip.warned': 'з попередженнями {n}',
  'import.unknownColumns': 'Ці колонки не з шаблону, їх пропущено: {cols}',
  'import.noRows': 'У файлі немає рядків з даними.',
  'import.moreRows': 'Ще {n|рядок|рядки|рядків} не показано — їх видно в підсумку і в списку помилок після запуску.',
  'import.line': 'Рядок',
  'import.lineN': 'рядок {n}',
  'import.action': 'Дія',
  'import.action.create': 'створити',
  'import.action.update': 'оновити',
  'import.action.skip': 'пропустити',
  'import.warning': 'Увага',
  'import.dryRun': 'Лише перевірити (пробний запуск)',
  'import.run': 'Імпортувати',
  'import.alreadyRun': 'Це завантаження вже виконано — результат нижче й в історії. Щоб імпортувати знову, виберіть файл ще раз.',
  'import.nothingToDo': 'Немає рядків без помилок — виправте файл і завантажте знову.',
  'import.safety':
    'Пробний запуск проходить увесь імпорт і все скасовує: видно, що сталося б. Імпорт нічого не видаляє і не надсилає родинам повідомлень; рядки з помилками пропускаються.',
  'import.confirmTitle': 'Імпортувати в компанію?',
  'import.confirm': 'Створити {create} і оновити {update} записів у компанії {company}?',
  'import.confirmSkip': 'Рядки з помилками ({n}) буде пропущено.',
  'import.dryDone': 'Пробний запуск завершено — нічого не змінено',
  'import.done': 'Імпорт завершено: створено {created}, оновлено {updated}',
  'import.step3': '3. Результат',
  'import.dryAside': 'пробний запуск — нічого не змінено',
  'import.resultDry': 'Якби це був імпорт: створено {created}, оновлено {updated}, пропущено {skipped}.',
  'import.resultDone': 'Створено {created}, оновлено {updated}, пропущено {skipped}.',
  'import.created': 'Створено',
  'import.updated': 'Оновлено',
  'import.unchanged': 'без змін',
  'import.errorsTitle': 'Помилки (ці рядки пропущено)',
  'import.warningsTitle': 'Попередження',
  'import.lines': 'рядки {lines}',
  'import.history': 'Історія завантажень',
  'import.historyEmpty': 'Ще нічого не завантажували.',
  'import.when': 'Коли',
  'import.statusCol': 'Стан',
  'import.rowsCol': 'Рядки',
  'import.who': 'Хто',
  'import.status.preview': 'перевірено',
  'import.status.dry_run': 'пробний запуск',
  'import.status.done': 'імпортовано',
  'import.status.failed': 'не вдалося',
  'import.counts': '{total|рядок|рядки|рядків}, з помилками {errors}',
  'import.countsDone': 'створено {created}, оновлено {updated}, з помилками {errors}',
  'ho.modal.wait': 'Час на відповідь',
  'ho.modal.waitMin': '{m} хв',
  'ho.modal.wait60': '1 год',
  'ho.modal.waitHint': 'Не відповів за цей час — пропозиція знімається, вам приходить сповіщення, і можна запропонувати наступному партнеру або виконати самим. Партнер отримує пропозицію в кабінеті та в Telegram-боті.',
  'leads.repeats': 'повторних: {n}',
  'leads.hiddenByCountry': 'Ще {n} заявок не видно: вгорі вибрано лише країну {country}.',
  'leads.showAllCountries': 'Показати всі країни',
  'leads.repeatsHint': 'Той самий контакт звернувся ще раз протягом 24 год — текст дописано в повідомлення',
  // --- Telegram-бот VIA DOMUM (059)
  'tgbot.tab': 'Telegram-бот',
  'tgbot.title': 'Бот VIA DOMUM',
  'tgbot.configured': 'Бот працює: {name}. Водії, диспетчери й партнери привʼязуються одноразовим кодом.',
  'tgbot.not_configured': 'Токен бота ще не задано (XQ_TGBOT_TOKEN). Коди можна видавати вже зараз — запрацюють, щойно бот стартує.',
  'tgbot.link': 'Код для водія або співробітника',
  'tgbot.link_hint': 'Людина надсилає код боту (або відкриває посилання) — і бот знає її роль. Код одноразовий, діє 24 години.',
  'tgbot.person': 'Людина',
  'tgbot.choose': 'Оберіть людину',
  'tgbot.make_code': 'Створити код',
  'tgbot.code_for': 'Код для {name}:',
  'tgbot.code_until': 'Діє до {at}',
  'tgbot.partners': 'Запрошення партнерів',
  'tgbot.partners_hint': 'Код для адміністратора партнерської компанії (діє 72 години). Своїх водіїв партнер привʼязує сам у своєму кабінеті.',
  'tgbot.invite': 'Запросити в бота',
  'tgbot.accounts': 'Привʼязані акаунти',
  'tgbot.who': 'Хто',
  'tgbot.role': 'Роль',
  'tgbot.linked': 'Привʼязано',
  'tgbot.seen': 'Остання дія',
  'tgbot.family': 'родина',
  'tgbot.disable': 'Вимкнути доступ',
  'tgbot.disabled': 'Доступ до бота вимкнено',
  'tgbot.off': 'вимкнено',
  'tgbot.escalations': 'Ескалації',
  'tgbot.esc_hint': 'Пропозиція партнеру без відповіді або прострочений крок рейсу: диспетчер → власник → черговий уночі (зі «Чергування», інакше — обраний нижче).',
  'tgbot.esc_after': 'Наступний рівень через, хв',
  'tgbot.step_grace': 'Крок прострочено через, хв',
  'tgbot.owner': 'Власник (рівень 2)',
  'tgbot.night_user': 'Черговий уночі, якщо немає зміни',
  'tgbot.night_from': 'Ніч з, год',
  'tgbot.night_to': 'Ніч до, год',
  'tgbot.default': 'Типово',
  'tgbot.save': 'Зберегти',
  'tgbot.saved': 'Збережено',
  'tgbot.expenses': 'Витрати водія (чеки з бота)',
  'tgbot.expenses_total': 'Разом',
  'tgbot.exp.fuel': 'Пальне',
  'tgbot.exp.tolls': 'Дороги',
  'tgbot.exp.border': 'Кордон',
  'tgbot.exp.other': 'Інше',
  'nav.signals': 'Сигнали з груп',
  'sig.title': 'Сигнали з груп',
  'sig.subtitle': 'Пости з Telegram-груп, де людина шукає перевезення. Візьміть, напишіть людині, а коли дасть телефон, зробіть заявку.',
  'sig.tabs': 'Сигнали',
  'sig.new': 'Нові',
  'sig.taken': 'Взяті',
  'sig.notOurs': 'Не наше',
  'sig.empty': 'Сигналів немає.',
  'sig.unknownGroup': 'Група без назви',
  'sig.score': 'збіг {n}',
  'sig.takenBy': 'взяв(ла): {name}',
  'sig.leadNumber': 'заявка {n}',
  'sig.openPost': 'Відкрити пост',
  'sig.take': 'Взяти',
  'sig.tookDone': 'Сигнал ваш. Напишіть людині.',
  'sig.makeLead': 'Зробити заявку',
  'sig.dismiss': 'Не наше',
  'sig.createLead': 'Створити заявку',
  'sig.leadHint': 'Текст посту і посилання підуть у заявку. Телефон потрібен, щоб CRM знайшла людину, якщо вона писала раніше.',
  'sig.name': 'Імʼя',
  'sig.phone': 'Телефон',
  'parser.title': 'Парсер груп',
  'parser.snapshotAt': 'Стан від парсера: {when}',
  'parser.noSnapshot': 'Парсер ще не надсилав свій стан.',
  'parser.stale': 'Парсер не оновлював стан понад 30 хвилин: перевірте, чи він працює.',
  'parser.accounts': 'Акаунти в роботі',
  'parser.accountsHint': 'працюють / усього',
  'parser.groups': 'Груп читаємо',
  'parser.queued': 'ще {n} у черзі вступу',
  'parser.duplicates': 'Дублі',
  'parser.spread': 'Груп на акаунт',
  'parser.cap': 'ліміт {n}',
  'parser.accountsTitle': 'Акаунти',
  'parser.noAccounts': 'Акаунтів ще немає.',
  'parser.account': 'Акаунт',
  'parser.state': 'Стан',
  'parser.reads': 'Читає',
  'parser.queue': 'У черзі',
  'parser.memberOf': 'Членств',
  'parser.msgsDay': 'Повідомлень/день',
  'parser.load': 'Навантаження',
  'parser.ok': 'працює',
  'parser.down': 'не працює: {s}',
  'parser.noProxy': 'без проксі',
  'parser.dupTitle': 'Групи на кількох акаунтах ({n})',
  'parser.noDups': 'Дублів немає: кожну групу читає один акаунт.',
  'parser.dupHint': 'Читає групу один акаунт; зайві можуть з неї вийти і звільнити місце.',
  'parser.group': 'Група',
  'parser.reader': 'Читає',
  'parser.extra': 'Зайві',
  'parser.suggestTitle': 'Куди додати нові групи',
  'parser.suggestHint': 'Вставте посилання на групи (по одному в рядку). Система покаже, які вже є і на якому акаунті, а нові розподілить на найменш завантажені акаунти.',
  'parser.links': 'Посилання',
  'parser.suggest': 'Розподілити',
  'parser.toAdd': 'Нові: {n}, вступ займе до {days} дн.',
  'parser.commandHint': 'Надішліть цю команду в чат операторів парсера, і акаунти почнуть вступати в групи:',
  'parser.copy': 'Скопіювати',
  'parser.existing': 'Уже в системі: {n}',
  'parser.readBy': 'читає {acc}',
  'parser.noReader': 'ще без акаунта',
  'parser.alsoOn': 'також на {list}',
  'parser.full': 'Для {n} груп немає місця на жодному акаунті: потрібен ще акаунт.',
  'parser.bad': 'Не схоже на посилання групи: {list}',
  'tgbot.team.title': 'Командна група',
  'tgbot.team.hint': 'Додайте бота в супергрупу з темами адміністратором і надішліть у потрібній темі /chatid: бот відповість id групи і теми. Картка в групі — без імені й телефону, «Взяти» працює прямо з групи.',
  'tgbot.team.chat': 'Id групи',
  'tgbot.team.delivery': 'Куди слати картки заявок',
  'tgbot.team.personal': 'Особисто менеджерам (як зараз)',
  'tgbot.team.both': 'І особисто, і в групу (на час переходу)',
  'tgbot.team.group': 'Лише в групу',
  'tgbot.team.leads': 'Тема для заявок (id)',
  'tgbot.team.system': 'Тема «Система» (id)',
  'tgbot.team.badChat': 'Id групи — відʼємне число, напр. -1001234567890 (бот надсилає його у відповідь на /chatid)',
  'tgbot.team.badTopic': 'Id теми — ціле додатне число',
  'error.team_chat_required': 'Щоб слати картки в групу, вкажіть id групи',
  'nav.reports': 'Звіти про проблеми',
  'rep.button': 'Повідомити про проблему',
  'rep.title': 'Є проблема чи ідея?',
  'rep.fab': 'Є проблема?',
  'rep.draft': 'Дописати звіт',
  'rep.kind': 'Що це',
  'rep.kind.bug': 'Щось не працює',
  'rep.kind.idea': 'Ідея, як покращити',
  'rep.kind.question': 'Питання',
  'rep.body': 'Що сталося',
  'rep.bodyHint': 'Що робили, що чекали побачити і що побачили натомість.',
  'rep.shotAlt': 'Знімок {n}',
  'rep.removeShot': 'Прибрати знімок',
  'rep.capture': 'Зняти екран',
  'rep.upload': 'Додати файл',
  'rep.pasteHint': 'Або вставте знімок з буфера: Ctrl+V / ⌘V у цьому вікні.',
  'rep.auto': 'Сторінка, браузер і розмір екрана додаються самі.',
  'rep.withErrors': 'Додати останні помилки сторінки ({n})',
  'rep.tooLarge': 'Знімок завеликий',
  'rep.badImage': 'Не вдалося прочитати зображення',
  'rep.captureFailed': 'Не вдалося зняти екран. Додайте файл або вставте знімок.',
  'rep.send': 'Надіслати',
  'rep.sent': 'Дякуємо! Звіт {n} збережено',
  'rep.all': 'Усі звіти',
  'rep.mine': 'Мої звіти',
  'trash.tab': 'Корзина',
  'trash.delete': 'Видалити',
  'trash.deleteTitle': 'Видалити заявку?',
  'trash.deleteHint': 'Заявка піде в корзину. Звідти її можна відновити. Перші 30 днів остаточно видалити її не може ніхто.',
  'trash.reason': 'Причина',
  'trash.reasonHint': 'Обовʼязково: чому видаляєте (дубль, помилка, тест…).',
  'trash.deleted': 'Заявку перенесено в корзину',
  'trash.restored': 'Заявку відновлено',
  'trash.purged': 'Заявку видалено назавжди',
  'trash.hint': 'Видалені заявки. Відновити можна будь-коли. Остаточно видалити — лише власник і не раніше ніж через {n} днів.',
  'trash.empty': 'Корзина порожня',
  'trash.by': 'Видалив(ла): {who}, {when}',
  'trash.restore': 'Відновити',
  'trash.purge': 'Видалити назавжди',
  'trash.purgeConfirm': 'Видалити заявку назавжди? Це не можна скасувати.',
  'trash.purgeFrom': 'Назавжди — з {date}',
  'rep.doneTitle': 'Збережено! Звіт {n}',
  'rep.doneText': 'Дякуємо. Ми побачимо його і виправимо. Що з ним зараз — на сторінці «Звіти про проблеми».',
  'rep.doneView': 'Подивитись мої звіти',
  'rep.doneMore': 'Написати ще',
  'rep.page': 'Звіти про проблеми',
  'rep.pageSub': 'Ваші звіти про проблеми й ідеї щодо CRM і що з ними зараз.',
  'rep.pageSubAdmin': 'Проблеми й ідеї від усієї команди. Ведіть статус, а «Вивантажити» копіює відкриті звіти одним текстом для виправлення.',
  'rep.export': 'Вивантажити відкриті',
  'rep.copied': 'Скопійовано звітів: {n}',
  'rep.downloaded': 'Не вдалося скопіювати — звіти ({n}) збережено файлом reports.md',
  'rep.tabs': 'Звіти',
  'rep.tab.open': 'Відкриті',
  'rep.tab.fixed': 'Виправлені',
  'rep.tab.closed': 'Закриті без змін',
  'rep.search': 'Пошук у звітах',
  'rep.empty': 'Звітів поки немає',
  'rep.status.new': 'Новий',
  'rep.status.in_progress': 'У роботі',
  'rep.status.fixed': 'Виправлено',
  'rep.status.wontfix': 'Не будемо робити',
  'rep.status.duplicate': 'Дубль',
  'rep.prio.low': 'Низький',
  'rep.prio.normal': 'Звичайний',
  'rep.prio.high': 'Високий',
  'rep.prio.critical': 'Критичний',
  'rep.statusLabel': 'Статус',
  'rep.prioLabel': 'Пріоритет',
  'rep.resolution': 'Що зроблено',
  'rep.page_url': 'Сторінка',
  'rep.browser': 'Браузер',
  'rep.screen': 'Екран, версія',
} as const;

export type Dict ={ [K in keyof typeof uk]: string };
export type DictKey = keyof typeof uk;
